(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantages-section"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.advantages-carousel', {
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: true,
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["become-a-dealer"] && !Shopify.designMode) return;
  try {
    
  const dealerForm = document.getElementById('dealer_form')
  dealerForm.addEventListener('submit', function (e) {
    e.preventDefault()
    const formData = new FormData(dealerForm)
     fetch(window.Shopify.routes.root + 'apps/api/forms', {
       method: 'POST',
       body: formData,
     })
       .then((response) => {
         return response.json()
       })
       .then((response) => {
         console.log('[Become a Dealer] Form response:', response)
         if (response.success) {
           Toastify({
             text: 'Your message has been sent successfully!',
             duration: 3000,
             newWindow: true,
             close: false,
             gravity: 'bottom', // `top` or `bottom`
             position: 'left', // `left`, `center` or `right`
             stopOnFocus: true, // Prevents dismissing of toast on hover
             style: {
               background: 'white',
               color: 'black',
               borderRadius: '8px',
             },
             onClick: function () {}, // Callback after click
           }).showToast()
         } else {
           throw new Error(response.error || 'An error occurred')
         }
       })
       .catch((error) => {
         console.error('[Become a Dealer] Error:', error)
         Toastify({
           text: 'There was an error sending your message.',
           duration: 3000,
           newWindow: true,
           close: false,
           gravity: 'bottom', // `top` or `bottom`
           position: 'left', // `left`, `center` or `right`
           stopOnFocus: true, // Prevents dismissing of toast on hover
           style: {
             background: 'white',
             color: 'black',
             borderRadius: '8px',
           },
           onClick: function () {}, // Callback after click
         }).showToast()
       })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-section"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.benefits-carousel', {
    pagination: {
      el: '.swiper-pagination',
      dynamicBullets: true,
      dynamicMainBullets: 5,
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
    slidesPerView: 'auto',
    centeredSlides: true,
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-seller-compare"] && !Shopify.designMode) return;
  try {
    
  const createOdometer = (element, value) => {
    const od = new Odometer({
      el: element,
      value: 0,
      animation: 'count',
      duration: 1000,
      format: 'dddd.dd',
    })
    // Only update when visible
    const observer = new window.IntersectionObserver(
      function (entries, obs) {
        if (entries[0].isIntersecting) {
          setTimeout(() => {
            od.update(value)
          }, 200)

          obs.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(element)
  }
  const odometer = document.querySelectorAll('.compare-featured-product-frequency')
  odometer.forEach((odometer) => {
    createOdometer(odometer, odometer.dataset.freq)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["booklet-hero-section"] && !Shopify.designMode) return;
  try {
    
  const createOdometer = (element, value) => {
    const od = new Odometer({
      el: element,
      value: 0,
      animation: 'count',
      duration: 1000,
      format: 'd',
    })
    // Only update when visible
    const observer = new window.IntersectionObserver(
      function (entries, obs) {
        if (entries[0].isIntersecting) {
          setTimeout(() => {
            od.update(value)
          }, 200)

          obs.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(element)
  }
  const odometer = document.querySelectorAll('.odometer-element')
  odometer.forEach((odometer) => {
    createOdometer(odometer, odometer.dataset.odometer)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cardLinkingModal"] && !Shopify.designMode) return;
  try {
    
  console.log('=== Card Linking Modal Initialization (Refactored) ===')

  const modal = document.getElementById('cardLinkingModal')
  const closeBtn = document.getElementById('modalCloseBtn')
  const contentContainer = document.getElementById('cardLinkFormContent')
  const urlParams = new URLSearchParams(window.location.search)
  const cardUid = urlParams.get('cardUid')

  // Close modal handler - redirect to storefront
  closeBtn.addEventListener('click', () => {
    window.location.href = '/'
  })

  function openModal() {
    modal.classList.add('opened-modal')
  }

  function renderContent(html) {
    contentContainer.innerHTML = html
  }

  function redirectToDiscount(code) {
    const redirectPath = encodeURIComponent('/?toast=Commission discount active')
    window.location.href = `/discount/${code}?redirect=${redirectPath}`
  }

  // Check API availability
  if (typeof CardLinkingApi === 'undefined') {
    renderContent('<h2>Error</h2><p>Card linking module not available.</p>')
    openModal()
  } else {
    // Main Logic
    async function checkAndSetup() {
      if (!cardUid) {
        return
      }

      try {
        const customerId = CardLinkingApi.getCustomerId()
        const result = await CardLinkingApi.checkCard(cardUid, customerId)

        if (result.isLinked) {
          // Already linked -> Show toast and redirect
          console.log('Card already linked. Redirecting...')

          // Show toast immediately if CardLinkingApi is ready
          if (typeof CardLinkingApi !== 'undefined' && CardLinkingApi.showSuccess) {
            CardLinkingApi.showSuccess('Discount has been applied')
          }

          const discountText = result.discountValue || 'exclusive'

          renderContent(`
             <h1>Discount applied!</h1>
             <p>Your ${discountText} discount has been activated by the NFC card. Enjoy your Schumann Club benefits.</p>
             <p>Redirecting you to the store...</p>
             <div class="loader-row">
               <div class="card-linking-loader-container">
                 <div class="card-linking-circle card-linking-border"></div>
               </div>
             </div>
           `)
          openModal()
          setTimeout(() => redirectToDiscount(result.discountCode), 3000)
        } else if (result.cardStatus === 'ACTIVE' || result.cardStatus === 'PENDING_ACTIVATION') {
          // Valid Card -> Show Link UI
          openModal()

          let buttonText = customerId ? 'Redeem Discount' : 'Log in to Redeem'
          let warningHtml = ''

          if (!customerId) {
            warningHtml = `
               <div class="account-warning">
                 <strong>Log in required</strong>
                 You will be redirected to the linking page after logging in.
               </div>
             `
          } else if (result.linkedCards && result.linkedCards.length > 0) {
            // Replacement Warning
            warningHtml = `
                <div class="replacement-warning" style="background-color: #fff3cd; border: 1px solid #ffc107; color: #856404; padding: 1rem; border-radius: 0.5rem;">
                  <h3 style="margin-top: 0; margin-bottom: 0.5rem; font-size: 1rem;">⚠️ Existing Discount Found</h3>
                  <p style="margin-bottom: 0.5rem; font-size: 0.9rem;">Redeeming this new offer will replace your existing one.</p>
                </div>
              `
          }

          renderContent(`
            <h1>Welcome to the Schumann Club</h1>
            <p>You've been invited to the Schumann Club. Link your NFC card to redeem your exclusive discount.</p>
            ${warningHtml}
            <button id="actionBtn" class="action-button">${buttonText}</button>
          `)

          // Attach listener
          document.getElementById('actionBtn').addEventListener('click', async function () {
            const btn = this
            btn.disabled = true
            btn.textContent = 'Processing...'

            try {
              const linkResult = await CardLinkingApi.linkCard(cardUid, customerId)
              const discountText = linkResult.discountValue || 'exclusive'

              // Success
              renderContent(`
                   <h1>Success!</h1>
                   <p>Your ${discountText} discount has been redeemed.</p>
                   <p>Applying to your cart...</p>
                   <div class="loader-row">
                     <div class="card-linking-loader-container">
                       <div class="card-linking-circle card-linking-border"></div>
                     </div>
                   </div>
                 `)

              setTimeout(() => redirectToDiscount(linkResult.discountCode), 3000)
            } catch (error) {
              console.error('Linking error:', error)
              if (error.code === 'NOT_LOGGED_IN' && error.redirectUrl) {
                window.location.href = error.redirectUrl
              } else {
                CardLinkingApi.handleError(error)
                btn.disabled = false
                btn.textContent = 'Try Again'
              }
            }
          })
        } else {
          // Invalid Status
          renderContent(`
             <h1>Offer Unavailable</h1>
             <p>This invite is no longer valid (Status: ${result.cardStatus}).</p>
             <button class="action-button" onclick="window.location.href='/'">Return Home</button>
           `)
          openModal()
        }
      } catch (error) {
        console.error('Check error:', error)
        renderContent(`
          <h2>Something went wrong</h2>
          <p>Please try again later.</p>
          <button class="action-button" onclick="window.location.reload()">Retry</button>
        `)
        openModal()
      }
    }

    // Start
    checkAndSetup()
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carousel-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carousel-home-hero')) {
    class CarouselHomeHero extends HTMLElement {
      connectedCallback() {
        // Re-inserted (e.g. moved in the editor): listeners and clones survive
        if (this.track) return this.setupTimer();
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.paused = false;

        // Infinite loop: a copy of the last slide sits before the first and a
        // copy of the first after the last. When a scroll settles on a copy we
        // jump, without animation, to the real slide it mirrors.
        this.loop = this.slides.length > 1;
        if (this.loop) {
          const cloneOf = (slide) => {
            const clone = slide.cloneNode(true);
            clone.removeAttribute('data-shopify-editor-block');
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelectorAll('img').forEach((img) => {
              img.loading = 'lazy';
              img.removeAttribute('fetchpriority');
            });
            return clone;
          };
          this.track.prepend(cloneOf(this.slides[this.slides.length - 1]));
          this.track.append(cloneOf(this.slides[0]));
          this.jumpTo(1);
        }
        this.panels = Array.from(this.track.children);

        this.onScroll = () => {
          const i = this.realIndex(this.position());
          if (i !== this.index) this.setActive(i);
          if (!this.loop || 'onscrollend' in window) return;
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(this.onSettle, 120);
        };
        this.onSettle = () => {
          const pos = this.position();
          const aligned = Math.abs(this.track.scrollLeft - pos * this.track.clientWidth) < 2;
          if (!aligned) return;
          if (pos === 0) this.jumpTo(this.slides.length);
          else if (pos === this.slides.length + 1) this.jumpTo(1);
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        if (this.loop) this.track.addEventListener('scrollend', this.onSettle);

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.manual(Number(dot.dataset.dot)));
        });
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.manual(this.index - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.manual(this.index + 1));

        // Pause autoplay while the visitor is reading or interacting
        this.addEventListener('pointerenter', () => (this.paused = true));
        this.addEventListener('pointerleave', () => (this.paused = false));
        this.addEventListener('focusin', () => (this.paused = true));
        this.addEventListener('focusout', () => (this.paused = false));

        this.setActive(0);
        this.setupTimer();
        // Two frames so the first slide's text starts hidden, then animates in
        this.raf = requestAnimationFrame(() => {
          this.raf = requestAnimationFrame(() => this.classList.add('is-ready'));
        });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        cancelAnimationFrame(this.raf);
        clearTimeout(this.settleTimer);
      }

      // Panel position in the track, counting the leading clone when looping
      position() {
        return Math.round(this.track.scrollLeft / this.track.clientWidth);
      }

      realIndex(pos) {
        const n = this.slides.length;
        return this.loop ? (pos - 1 + n) % n : pos;
      }

      jumpTo(pos) {
        this.track.style.scrollBehavior = 'auto';
        this.track.scrollLeft = pos * this.track.clientWidth;
        this.track.style.scrollBehavior = '';
      }

      setupTimer() {
        clearInterval(this.timer);
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay !== 'true' || reduceMotion || this.slides.length < 2) return;
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.go(this.index + 1);
        }, Number(this.dataset.interval) || 6000);
      }

      // i may run one past either end (-1 or n); with looping that lands on a
      // clone and onSettle jumps to the real slide.
      go(i) {
        const n = this.slides.length;
        if (!n) return;
        const pos = this.loop ? Math.max(0, Math.min(n + 1, i + 1)) : (i + n) % n;
        this.track.scrollTo({ left: pos * this.track.clientWidth, behavior: 'smooth' });
      }

      manual(i) {
        this.go(i);
        this.setupTimer();
      }

      setActive(i) {
        this.index = i;
        // Clones mirror their slide's active state so the copy shows its text
        // while it's on screen, and the jump back lands on the same state.
        this.panels.forEach((panel, pos) => {
          panel.classList.toggle('is-active', this.realIndex(pos) === i);
        });
        this.panels.forEach((panel) => {
          const real = this.slides.indexOf(panel);
          panel.toggleAttribute('inert', real === -1 || real !== i);
        });
        this.dots.forEach((dot, k) => {
          dot.classList.toggle('is-active', k === i);
          if (k === i) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }

    customElements.define('carousel-home-hero', CarouselHomeHero);
  }

  // Theme editor: scroll to the slide whose block is selected
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-slide]');
    const root = slide?.closest('carousel-home-hero');
    if (!root) return;
    root.go(root.slides.indexOf(slide));
    clearInterval(root.timer);
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    event.target.closest('carousel-home-hero')?.setupTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["club-privileges"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.club-privileges', {
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
    slidesPerView: 'auto',
    centeredSlides: true,
    centeredSlidesBounds: true,
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-section"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.community-carousel', {
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
    slidesPerView: 'auto',
    loop: true,
    centeredSlides: true,
  })
  var muted = true
  var allVideos = document.querySelectorAll('.community-carousel .swiper-slide video')

  var muteButtons = document.querySelectorAll('.video-mute-button')
  muteButtons.forEach((button) => {
    button.addEventListener('click', () => {
      muted = !muted
      allVideos.forEach((video) => {
        video.muted = muted
      })
      if (muted) {
        button.querySelector('.mute').style.display = 'block'
        button.querySelector('.unmute').style.display = 'none'
      } else {
        button.querySelector('.mute').style.display = 'none'
        button.querySelector('.unmute').style.display = 'block'
      }
    })
  })
  if (allVideos.length)
    allVideos.forEach((video) => {
      video.addEventListener('ended', () => {
        swiper.slideNext(200)
      })
      video.addEventListener('waiting', () => {
        video.parentElement.querySelector('.video-progress-bar').classList.add('loading-video')
        // Show a loading indicator.
      })
      video.addEventListener('playing', () => {
        video.parentElement.querySelector('.video-progress-bar').classList.remove('loading-video')
        // Hide the loading indicator.
      })
      video.addEventListener('click', () => {
        if (video.paused) {
          video.play()
        } else {
          video.pause()
        }
      })
    })
  swiper.on('slideChange', function (e) {
    // Pause all videos
    allVideos.forEach((video) => {
      video.pause()
    })
    // Play video in active slide
    const activeSlide = e.slides[e.activeIndex]
    const video = activeSlide.querySelector('video')
    if (video) {
      let playPromise = video.play()
      playPromise.catch((error) => {})
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everybody-benefits"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    const section = document.querySelector('.everybody-benefits')
    if (!section) return

    const cards = section.querySelectorAll('.everybody-benefits__card')
    const isTouch = window.matchMedia('(hover: none)').matches

    if (isTouch) {
      /* Mobile: IntersectionObserver activates the most-visible slide */
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-active', entry.isIntersecting)
          })
        },
        {
          root: section.querySelector('.everybody-benefits__slides'),
          threshold: 0.6,
        }
      )

      cards.forEach((card) => observer.observe(card))
    } else {
      /* Desktop: hover activates */
      cards.forEach((card) => {
        card.addEventListener('mouseenter', () => card.classList.add('is-active'))
        card.addEventListener('mouseleave', () => card.classList.remove('is-active'))
      })
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fancy-text"] && !Shopify.designMode) return;
  try {
    
  const element = document.querySelector('.fancy-text')
  const observer = new window.IntersectionObserver(
    function (entries, obs) {
      if (entries[0].isIntersecting) {
        setTimeout(() => {
          element.classList.add('seen')
        }, 200)

        obs.disconnect()
      }
    },
    { threshold: 0.1 }
  )
  observer.observe(element)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  let inputElement = document.querySelector('.footer-newsletter-input')
  inputElement.addEventListener('input', () => {
    if (inputElement.value !== '') {
      inputElement.classList.add('dirty')
    } else {
      inputElement.classList.remove('dirty')
    }
  })
  const footerNewsletterForm = document.getElementById('footer-newsletter-form')
  const newsletterPopup = document.getElementById('newsletter-popup')
  footerNewsletterForm.addEventListener('submit', function (event) {
    event.preventDefault() // Prevent the default form submission
    const formData = new FormData(footerNewsletterForm)

    fetch('/contact#contact_form', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          newsletterPopup.style.display = 'flex'
          document.body.style.overflow = 'hidden'
          footerNewsletterForm.reset()
        } else {
          throw new Error('Network response was not ok')
        }
      })
      .catch((error) => {
        Toastify({
          text: 'There was an error submitting the form. Please try again later.',
          duration: 3000,
          newWindow: true,
          close: false,
          gravity: 'bottom', // `top` or `bottom`
          position: 'left', // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: 'white',
            color: 'black',
            borderRadius: '8px',
          },
          onClick: function () {}, // Callback after click
        }).showToast()
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequency-journey-new"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.frequency-journey-carousel', {
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
    centeredSlides: true,
    centeredSlidesBounds: true,
  })

  const createOdometer = (element, value) => {
    const od = new Odometer({
      el: element,
      value: 0,
      animation: 'count',
      duration: 1000,
      format: 'ddd',
    })
    // Only update when visible
    const observer = new window.IntersectionObserver(
      function (entries, obs) {
        if (entries[0].isIntersecting) {
          setTimeout(() => {
            od.update(value)
          }, 200)

          obs.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    observer.observe(element)
  }
  const odometer = document.querySelectorAll('.frequency-new-odometer')
  odometer.forEach((odometer) => {
    createOdometer(odometer, odometer.dataset.freq)
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequency-library-page"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    'use strict'

    /* ── Backend-connected catalog ───────────────────────────────────────────
     The Frequency Library API (docs/frequency-library-api.md) does the
     filtering, search and pagination. On load we fetch the facets once
     (/categories, /families, /devices) plus the catalog total; every filter
     change then asks /frequencies for exactly the page on screen. Each item is
     mapped onto the shape the UI expects:
       hz ← valueHz · desc ← description · benefit/family ← first category/family name
       benefitsAll/familiesAll ← every name · devices ← compatible device ids
     Device compatibility comes from the API — the theme never derives it from Hz. */
    function prettySlug(s) {
      return String(s || '')
        .replace(/[-_]+/g, ' ')
        .replace(/\b\w/g, function (c) {
          return c.toUpperCase()
        })
    }
    function fetchJSON(url, signal) {
      return fetch(url, { headers: { Accept: 'application/json' }, signal: signal }).then(function (r) {
        if (!r.ok) {
          var err = new Error('HTTP ' + r.status + ' for ' + url)
          err.status = r.status
          throw err
        }
        return r.json()
      })
    }
    function mapFreq(it) {
      var cats = it.categories || [],
        fams = it.families || [],
        devs = it.devices || []
      var benefitsAll = cats.map(function (c) {
        return c.name || prettySlug(c.id)
      })
      var familiesAll = fams.map(function (f) {
        return f.name || prettySlug(f.id)
      })
      return {
        id: it.id,
        hz: typeof it.valueHz === 'number' ? it.valueHz : parseFloat(it.valueHz) || 0,
        name: it.name || '',
        desc: it.description || '',
        benefit: benefitsAll[0] || '',
        family: familiesAll[0] || '',
        benefitsAll: benefitsAll,
        familiesAll: familiesAll,
        devices: devs.map(function (d) {
          return d.id
        }),
        deviceNames: devs.map(function (d) {
          return d.name || d.id
        }),
      }
    }
    /* { data: [{ id, name, frequencyCount }] } → chip list; empty facets are hidden */
    function mapFacets(j) {
      var list = [],
        names = {}
      ;((j && j.data) || []).forEach(function (x) {
        if (!x || !x.id) return
        names[x.id] = x.name || prettySlug(x.id)
        if (x.frequencyCount !== 0) list.push({ id: x.id, name: names[x.id] })
      })
      return { list: list, names: names }
    }
    function buildMeta(apiBase) {
      return Promise.all([
        fetchJSON(apiBase + '/categories'),
        fetchJSON(apiBase + '/families'),
        fetchJSON(apiBase + '/devices'),
        fetchJSON(apiBase + '/frequencies?pageSize=1'),
      ]).then(function (res) {
        var cats = mapFacets(res[0]),
          fams = mapFacets(res[1])
        var devices = ((res[2] && res[2].data) || []).map(function (d) {
          return { id: d.id, name: d.name || d.id, minHz: d.minHz, maxHz: d.maxHz, count: d.frequencyCount }
        })
        if (!res[3] || typeof res[3].total !== 'number') throw new Error('Unexpected /frequencies response')
        return {
          benefits: cats.list,
          families: fams.list,
          benefitNames: cats.names,
          familyNames: fams.names,
          devices: devices,
          total: res[3].total,
        }
      })
    }
    function loadMeta(apiBase) {
      if (!META_PROMISE) {
        META_PROMISE = buildMeta(apiBase)
        META_PROMISE.catch(function () {
          META_PROMISE = null
        })
      }
      return META_PROMISE
    }
    /* the whole catalog, walked at the API's max page size. Only the
       not-in-library drawer needs it (for "closest we do have"), so it is
       fetched lazily, once. */
    function loadCatalog(apiBase) {
      if (!CATALOG_PROMISE) {
        var items = []
        var page = function (p) {
          return fetchJSON(apiBase + '/frequencies?pageSize=200&page=' + p).then(function (j) {
            if (!j || !Array.isArray(j.data)) throw new Error('Unexpected /frequencies response')
            items = items.concat(j.data.map(mapFreq))
            return p < (j.totalPages || 0) ? page(p + 1) : items
          })
        }
        CATALOG_PROMISE = page(1)
        CATALOG_PROMISE.catch(function () {
          CATALOG_PROMISE = null
        })
      }
      return CATALOG_PROMISE
    }

    function formatHz(hz) {
      var n = Math.round(hz * 100) / 100
      var parts = n.toFixed(2).split('.')
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      var dec = parts[1].replace(/0+$/, '')
      return dec ? whole + '.' + dec : whole
    }
    function runsOnAll(f) {
      var all = (META && META.devices) || []
      return (
        all.length > 0 &&
        all.every(function (d) {
          return f.devices.indexOf(d.id) >= 0
        })
      )
    }
    /* "v2 & v3", "v1, v2 & v3" */
    function joinNames(names) {
      if (names.length <= 1) return names.join('')
      return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1]
    }
    function deviceBadge(f) {
      if (!f.devices.length) return 'No device yet'
      if (runsOnAll(f)) return 'All devices'
      if (f.devices.length === 1) return f.deviceNames[0] + ' only'
      return joinNames(f.deviceNames)
    }
    function badgeClass(f) {
      if (runsOnAll(f)) return 'all'
      return f.devices.indexOf('v2') >= 0 ? 'v2' : 'v3'
    }
    function compatLine(f) {
      if (!f.devices.length) return 'none of the current devices'
      return f.devices.length === 1 ? f.deviceNames[0] + ' only' : joinNames(f.deviceNames)
    }
    function deviceById(id) {
      var list = (META && META.devices) || []
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === id) return list[i]
      }
      return null
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]
      })
    }
    function commaNum(n) {
      return n.toLocaleString ? n.toLocaleString() : String(n)
    }

    var META = null,
      META_PROMISE = null,
      CATALOG_PROMISE = null
    /* every frequency we've seen, by id — the detail drawer opens from here */
    var FREQS = {}
    /* list responses by request URL, for instant back-and-forth paging */
    var LIST_CACHE = {}
    var SEARCH_DEBOUNCE = 250

    function initFreqLib(root) {
      if (root.dataset.flInit) return
      root.dataset.flInit = '1'
      var apiBase = (root.dataset.apiBase || 'https://frequency-library.theschumann.com/api').replace(/\/+$/, '')

      var compareUrl = root.dataset.compareUrl || '#freq-compare'
      var communityUrl = root.dataset.communityUrl || 'https://www.facebook.com/groups/966262492721317/'
      var PER_DESKTOP = parseInt(root.dataset.perPage, 10) || 20
      var PER_MOBILE = parseInt(root.dataset.perPageMobile, 10) || 10
      var mqMobile = window.matchMedia('(max-width: 860px)')
      function pageSize() {
        return mqMobile.matches ? PER_MOBILE : PER_DESKTOP
      }
      var onPageSizeChange = function () {
        if (!META) return
        page = 1
        fetchList()
      }
      if (mqMobile.addEventListener) mqMobile.addEventListener('change', onPageSizeChange)
      else if (mqMobile.addListener) mqMobile.addListener(onPageSizeChange)
      var density = root.dataset.density || 'comfortable'
      var view = root.dataset.defaultView === 'grid' ? 'grid' : 'list'

      var qs = function (s, ctx) {
        return (ctx || root).querySelector(s)
      }
      var qsa = function (s, ctx) {
        return Array.prototype.slice.call((ctx || root).querySelectorAll(s))
      }

      var countEl = qs('.fl-cat-count')
      var activeEl = qs('.fl-active')
      var regionEl = qs('.fl-results-region')
      var searchInput = qs('.fl-search-input')

      /* state — benefits/families are keyed by API id */
      var query = '',
        benefits = {},
        families = {},
        device = null,
        page = 1
      /* the page on screen: { items, page, pageSize, total, totalPages } */
      var RESULTS = null,
        loading = false,
        listError = false
      var fetchTimer = null,
        skelTimer = null,
        listSeq = 0,
        listCtrl = null

      function setHas(o) {
        for (var k in o) {
          if (o[k]) return true
        }
        return false
      }
      function setKeys(o) {
        var a = []
        for (var k in o) {
          if (o[k]) a.push(k)
        }
        return a
      }
      function benefitName(id) {
        return (META && META.benefitNames[id]) || prettySlug(id)
      }
      function familyName(id) {
        return (META && META.familyNames[id]) || prettySlug(id)
      }

      /* ── render filter chips (benefit / family) ── */
      function chipsHTML(list, group, store) {
        return list
          .map(function (x) {
            return (
              '<button class="fl-chip' +
              (store[x.id] ? ' fl-on' : '') +
              '" data-chip="' +
              group +
              '" data-val="' +
              esc(x.id) +
              '" aria-pressed="' +
              (store[x.id] ? 'true' : 'false') +
              '">' +
              esc(x.name) +
              '</button>'
            )
          })
          .join('')
      }
      function renderChips() {
        qsa('.fl-chips[data-group="benefit"]').forEach(function (box) {
          box.innerHTML = chipsHTML(META.benefits, 'benefit', benefits)
        })
        qsa('.fl-chips[data-group="family"]').forEach(function (box) {
          box.innerHTML = chipsHTML(META.families, 'family', families)
        })
      }

      /* ── fetch the page on screen ── */
      function listUrl() {
        var p = ['page=' + page, 'pageSize=' + pageSize(), 'sort=valueHz', 'order=asc']
        var cat = setKeys(benefits),
          fam = setKeys(families),
          q = query.trim()
        if (cat.length) p.push('category=' + cat.map(encodeURIComponent).join(','))
        if (fam.length) p.push('family=' + fam.map(encodeURIComponent).join(','))
        if (device) p.push('device=' + encodeURIComponent(device))
        if (q) p.push('q=' + encodeURIComponent(q))
        return apiBase + '/frequencies?' + p.join('&')
      }
      function fetchList() {
        clearTimeout(fetchTimer)
        clearTimeout(skelTimer)
        if (listCtrl) listCtrl.abort()
        listCtrl = null
        var seq = ++listSeq
        var url = listUrl()
        if (LIST_CACHE[url]) {
          RESULTS = LIST_CACHE[url]
          loading = false
          listError = false
          render()
          return
        }
        /* keep the current results up for fast responses; skeletons only if it drags */
        skelTimer = setTimeout(function () {
          if (seq !== listSeq) return
          loading = true
          render()
        }, 150)
        var ctrl = window.AbortController ? new AbortController() : null
        listCtrl = ctrl
        fetchJSON(url, ctrl ? ctrl.signal : undefined).then(
          function (j) {
            if (seq !== listSeq) return
            clearTimeout(skelTimer)
            if (!j || !Array.isArray(j.data)) throw new Error('Unexpected /frequencies response')
            /* the filters shrank the result set under the current page */
            if (!j.data.length && j.total > 0 && page > j.totalPages) {
              page = j.totalPages
              fetchList()
              return
            }
            var items = j.data.map(function (it) {
              var f = mapFreq(it)
              FREQS[f.id] = f
              return f
            })
            RESULTS = LIST_CACHE[url] = {
              items: items,
              page: j.page || page,
              pageSize: j.pageSize || pageSize(),
              total: j.total || 0,
              totalPages: j.totalPages || 0,
            }
            loading = false
            listError = false
            render()
          }
        ).catch(function (err) {
          if (seq !== listSeq || (err && err.name === 'AbortError')) return
          clearTimeout(skelTimer)
          loading = false
          listError = true
          render()
        })
      }

      /* ── item markup ── */
      function rowHTML(f) {
        var b = deviceBadge(f),
          bc = badgeClass(f)
        return (
          '<button class="fl-frow" data-open="' +
          esc(f.id) +
          '">' +
          '<span class="fl-hz">' +
          formatHz(f.hz) +
          '<small>Hz</small></span>' +
          '<span class="fl-mid"><span class="fl-name">' +
          esc(f.name) +
          '</span><span class="fl-desc">' +
          esc(f.desc) +
          '</span></span>' +
          '<span class="fl-rt"><span class="fl-tags"><span class="fl-tag">' +
          esc(f.benefit) +
          '</span><span class="fl-tag fl-fam">' +
          esc(f.family) +
          '</span></span>' +
          '<span class="fl-dbadge fl-' +
          bc +
          '">' +
          esc(b) +
          '</span></span>' +
          '</button>'
        )
      }
      function cardHTML(f) {
        var b = deviceBadge(f),
          bc = badgeClass(f)
        return (
          '<button class="fl-fcard" data-open="' +
          esc(f.id) +
          '">' +
          '<span class="fl-top"><span class="fl-hz">' +
          formatHz(f.hz) +
          '<small>Hz</small></span>' +
          '<span class="fl-dbadge fl-' +
          bc +
          '">' +
          esc(b) +
          '</span></span>' +
          '<span class="fl-name">' +
          esc(f.name) +
          '</span>' +
          '<span class="fl-desc">' +
          esc(f.desc) +
          '</span>' +
          '<span class="fl-tags"><span class="fl-tag">' +
          esc(f.benefit) +
          '</span><span class="fl-tag fl-fam">' +
          esc(f.family) +
          '</span></span>' +
          '</button>'
        )
      }
      function skeletons(n) {
        var s = ''
        for (var i = 0; i < n; i++) {
          s +=
            '<div class="fl-skel" aria-hidden="true"><div class="fl-bar" style="width:70px"></div>' +
            '<div style="display:flex;flex-direction:column;gap:8px"><div class="fl-bar" style="width:40%"></div><div class="fl-bar" style="width:70%"></div></div>' +
            '<div class="fl-bar" style="width:80px"></div></div>'
        }
        return s
      }
      function paginationHTML(pageCount) {
        if (pageCount <= 1) return ''
        var pages = []
        for (var p = 1; p <= pageCount; p++) {
          if (p === 1 || p === pageCount || (p >= page - 1 && p <= page + 1)) pages.push(p)
          else if (pages[pages.length - 1] !== '…') pages.push('…')
        }
        var html = '<nav class="fl-pager" aria-label="Pagination">'
        html +=
          '<button class="fl-pg-btn fl-nav" ' +
          (page === 1 ? 'disabled' : '') +
          ' data-page="' +
          (page - 1) +
          '" aria-label="Previous page"><i class="ph ph-caret-left"></i></button>'
        pages.forEach(function (p) {
          if (p === '…') html += '<span class="fl-pg-ellip" aria-hidden="true">…</span>'
          else
            html +=
              '<button class="fl-pg-btn' +
              (p === page ? ' fl-on' : '') +
              '" ' +
              (p === page ? 'aria-current="page"' : '') +
              ' data-page="' +
              p +
              '">' +
              p +
              '</button>'
        })
        html +=
          '<button class="fl-pg-btn fl-nav" ' +
          (page === pageCount ? 'disabled' : '') +
          ' data-page="' +
          (page + 1) +
          '" aria-label="Next page"><i class="ph ph-caret-right"></i></button>'
        html += '</nav>'
        return html
      }

      /* mobile dropdown trigger label — selected count summary */
      function ddLabel(group, store, allText, nameOf) {
        var box = qs('[data-dd="' + group + '"]')
        if (!box) return
        var out = qs('.fl-dd-current', box)
        if (!out) return
        var keys = setKeys(store)
        out.textContent = keys.length === 0 ? allText : keys.length === 1 ? nameOf(keys[0]) : keys.length + ' selected'
      }

      /* ── active-filter pills + control states ── */
      function renderControls() {
        // search
        if (document.activeElement !== searchInput) searchInput.value = query
        // chips on-state
        qsa('.fl-chip').forEach(function (c) {
          var on = c.dataset.chip === 'benefit' ? benefits[c.dataset.val] : families[c.dataset.val]
          c.classList.toggle('fl-on', !!on)
          c.setAttribute('aria-pressed', on ? 'true' : 'false')
        })
        // mobile dropdown toggle labels (selected count)
        ddLabel('benefit', benefits, 'All benefits', benefitName)
        ddLabel('family', families, 'All families', familyName)
        // segment
        qsa('.fl-seg button').forEach(function (b) {
          var on = device === b.dataset.device
          b.classList.toggle('fl-on', on)
          b.setAttribute('aria-pressed', on ? 'true' : 'false')
        })
        // clear buttons
        qs('[data-clear="benefit"]').hidden = !setHas(benefits)
        qs('[data-clear="family"]').hidden = !setHas(families)
        qs('[data-clear="device"]').hidden = !device
        // view toggle
        qsa('.fl-view-toggle button').forEach(function (b) {
          var on = b.dataset.view === view
          b.classList.toggle('fl-on', on)
          b.setAttribute('aria-pressed', on ? 'true' : 'false')
        })

        // active pills
        var hasFilters = query || setHas(benefits) || setHas(families) || device
        if (!hasFilters) {
          activeEl.innerHTML = '<span class="fl-hint">Search or filter to narrow 1,000+ frequencies.</span>'
          return
        }
        var html = ''
        setKeys(benefits).forEach(function (b) {
          var name = esc(benefitName(b))
          html +=
            '<span class="fl-af-pill">' +
            name +
            '<button data-remove="benefit" data-val="' +
            esc(b) +
            '" aria-label="Remove ' +
            name +
            '"><i class="ph ph-x"></i></button></span>'
        })
        setKeys(families).forEach(function (f) {
          var name = esc(familyName(f))
          html +=
            '<span class="fl-af-pill">' +
            name +
            '<button data-remove="family" data-val="' +
            esc(f) +
            '" aria-label="Remove ' +
            name +
            '"><i class="ph ph-x"></i></button></span>'
        })
        if (device) {
          var d = deviceById(device)
          html +=
            '<span class="fl-af-pill">Runs on ' +
            esc(d ? d.name : device) +
            '<button data-remove="device" aria-label="Clear device"><i class="ph ph-x"></i></button></span>'
        }
        html += '<button class="fl-fg-clear" data-clear="all" style="margin-left:4px">Clear all</button>'
        activeEl.innerHTML = html
      }

      /* "Everything from 0.1 to 1,000 Hz." — read from /devices, so it follows the API */
      function tierRange(id, lead) {
        var d = deviceById(id)
        if (!d || d.minHz == null || d.maxHz == null) return ''
        return lead + ' ' + formatHz(d.minHz) + ' to ' + formatHz(d.maxHz) + ' Hz.'
      }
      function upsellHTML(results) {
        var v1 = deviceById('v1')
        var v1Count = v1 && v1.count != null ? v1.count : results.total
        return (
          '<div class="fl-upsell"><p class="fl-eyebrow">One library. Two devices.</p>' +
          '<h3>v1 runs ' +
          commaNum(v1Count) +
          ' of these. <em>v3 unlocks more.</em></h3>' +
          '<div class="fl-u-tiers">' +
          '<div class="fl-u-tier fl-lit"><p class="fl-tname">v1</p><p class="fl-tcount">Runs the core 7.83 Hz, ' +
          results.total +
          ' frequency here.</p></div>' +
          '<div class="fl-u-tier"><p class="fl-tname">v3</p><p class="fl-tcount">' +
          tierRange('v3', 'The full library,') +
          '</p></div>' +
          '</div>' +
          '<a class="fl-btn" href="' +
          esc(compareUrl) +
          '">Compare devices</a></div>'
        )
      }

      /* ── main render ── */
      function render() {
        if (!META) {
          renderLoading()
          return
        }
        renderControls()
        if (listError) {
          renderError()
          return
        }
        if (!RESULTS || loading) {
          if (!RESULTS && countEl) countEl.textContent = ''
          regionEl.innerHTML = '<div class="fl-results fl-list">' + skeletons(8) + '</div>'
          return
        }
        var results = RESULTS
        var pageCount = Math.max(1, results.totalPages)
        var start = (results.page - 1) * results.pageSize

        countEl.innerHTML =
          'Showing <b>' + commaNum(results.total) + '</b> of ' + commaNum(META.total) + ' frequencies'

        var compactCls = density === 'compact' && view === 'list' ? ' fl-compact' : ''
        var itemsHTML = function (arr) {
          return arr.map(view === 'grid' ? cardHTML : rowHTML).join('')
        }

        if (device === 'v1' && results.total > 0) {
          regionEl.innerHTML =
            '<div class="fl-results fl-' +
            view +
            compactCls +
            '" style="margin-bottom:28px">' +
            itemsHTML(results.items) +
            '</div>' +
            upsellHTML(results)
          return
        }
        if (results.total === 0) {
          regionEl.innerHTML =
            '<div class="fl-empty"><i class="ph ph-magnifying-glass"></i>' +
            '<h3>No frequencies match those filters.</h3>' +
            '<p>Try clearing one, or search a different benefit.</p>' +
            '<button class="fl-btn-ghost" data-clear="all">Clear all filters</button></div>'
          return
        }
        var html = '<div class="fl-results fl-' + view + compactCls + '">' + itemsHTML(results.items) + '</div>'
        if (pageCount > 1) {
          html +=
            '<div class="fl-pager-row"><p class="fl-pager-info">Showing <b>' +
            commaNum(start + 1) +
            '–' +
            commaNum(start + results.items.length) +
            '</b> of ' +
            commaNum(results.total) +
            '</p>' +
            paginationHTML(pageCount) +
            '</div>'
        }
        regionEl.innerHTML = html
      }

      /* a filter changed: update the controls now, refetch (debounced for typing) */
      function commit(resetPage, delay) {
        if (resetPage !== false) page = 1
        renderControls()
        clearTimeout(fetchTimer)
        if (delay) fetchTimer = setTimeout(fetchList, delay)
        else fetchList()
        queueUrlSync()
      }

      function clearAll() {
        query = ''
        benefits = {}
        families = {}
        device = null
        renderChips()
        commit()
      }

      function goToPage(p) {
        var pageCount = Math.max(1, (RESULTS && RESULTS.totalPages) || 1)
        page = Math.min(Math.max(1, p), pageCount)
        fetchList()
        scrollToCatalog()
      }

      /* ── events ── */
      searchInput.addEventListener('input', function () {
        query = searchInput.value
        commit(true, SEARCH_DEBOUNCE)
      })

      root.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('button, a, [data-open]') : null
        if (!t) return

        if (t.hasAttribute('data-retry')) {
          if (META) {
            listError = false
            fetchList()
          } else boot()
          return
        }

        if (t.dataset.ddToggle) {
          var box = t.closest('.fl-fg-dd')
          var willOpen = !box.classList.contains('fl-open')
          qsa('.fl-fg-dd').forEach(function (o) {
            o.classList.remove('fl-open')
            var tg = qs('.fl-dd-toggle', o)
            if (tg) tg.setAttribute('aria-expanded', 'false')
          })
          if (willOpen) {
            box.classList.add('fl-open')
            t.setAttribute('aria-expanded', 'true')
          }
          return
        }

        if (t.dataset.chip) {
          var grp = t.dataset.chip === 'benefit' ? benefits : families
          var v = t.dataset.val
          if (grp[v]) delete grp[v]
          else grp[v] = 1
          commit()
          return
        }
        if (t.dataset.device) {
          device = device === t.dataset.device ? null : t.dataset.device
          commit()
          return
        }
        if (t.dataset.view) {
          view = t.dataset.view
          render()
          return
        }
        if (t.dataset.remove) {
          var r = t.dataset.remove
          if (r === 'benefit') delete benefits[t.dataset.val]
          else if (r === 'family') delete families[t.dataset.val]
          else if (r === 'device') device = null
          commit()
          return
        }
        if (t.dataset.clear) {
          var c = t.dataset.clear
          if (c === 'all') {
            clearAll()
          } else if (c === 'benefit') {
            benefits = {}
            renderChips()
            commit()
          } else if (c === 'family') {
            families = {}
            renderChips()
            commit()
          } else if (c === 'device') {
            device = null
            commit()
          }
          return
        }
        if (t.dataset.page) {
          e.preventDefault()
          goToPage(parseInt(t.dataset.page, 10))
          return
        }
        if (t.dataset.open) {
          openDetail(t.dataset.open, t)
          return
        }
      })

      /* close mobile filter dropdowns on outside click */
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.fl-fg-dd')) return
        qsa('.fl-fg-dd.fl-open').forEach(function (o) {
          o.classList.remove('fl-open')
          var tg = qs('.fl-dd-toggle', o)
          if (tg) tg.setAttribute('aria-expanded', 'false')
        })
      })

      /* ── detail drawer / modal ── */
      var scrim = qs('.fl-scrim')
      var drawer = qs('.fl-drawer')
      var dInner = qs('.fl-d-inner')
      var lastFocus = null
      var currentDetailId = null
      var currentMissingKey = null
      /* a ?f= key still being resolved against the API — kept in the URL meanwhile */
      var pendingKey = null,
        resolveSeq = 0
      var pushedDetail = false
      var baseTitle = document.title
      var urlTimer = null
      var hideTimer = null

      function detailInner(f) {
        var compat = compatLine(f),
          b = deviceBadge(f),
          bc = badgeClass(f),
          isV1 = f.devices.indexOf('v1') >= 0
        return (
          '<div class="fl-d-head"><p class="fl-eyebrow" style="color:var(--accent)">' +
          esc(f.family) +
          '</p>' +
          '<button class="fl-d-close" data-close aria-label="Close detail"><i class="ph ph-x"></i></button></div>' +
          '<div class="fl-d-body">' +
          '<p class="fl-d-hz">' +
          formatHz(f.hz) +
          '<small>Hz</small></p>' +
          '<p class="fl-d-name">' +
          esc(f.name) +
          '</p>' +
          '<div class="fl-d-tags"><span class="fl-tag">' +
          esc(f.benefit) +
          '</span><span class="fl-tag fl-fam">' +
          esc(f.family) +
          '</span></div>' +
          '<div class="fl-d-compat"><i class="ph ph-broadcast" style="color:var(--accent)"></i><span>Runs on: <b>' +
          esc(compat) +
          '</b></span><span style="margin-left:auto"><span class="fl-dbadge fl-' +
          bc +
          '">' +
          esc(b) +
          '</span></span></div>' +
          '<p class="fl-d-desc">' +
          esc(f.desc) +
          '</p>' +
          '<div class="fl-d-run"><h4>How to run this on TheSchumann</h4><ol class="fl-d-steps">' +
          '<li><span class="fl-sn"></span><span>Power on your device.</span></li>' +
          '<li><span class="fl-sn"></span><span>Set the frequency to ' +
          formatHz(f.hz) +
          ' Hz.</span></li>' +
          '<li><span class="fl-sn"></span><span>Start your session.</span></li></ol>' +
          (isV1 ? '<p class="fl-d-note"><i class="ph ph-info"></i> v1 is preset to 7.83 Hz.</p>' : '') +
          '</div>' +
          '<div class="fl-d-cta"><a class="fl-btn" href="' +
          esc(compareUrl) +
          '">Don\'t have the right device? Choose yours</a>' +
          '<p class="fl-d-mini">For general wellness and relaxation. Not a medical device.</p></div>' +
          '</div>'
        )
      }
      /* ?f= pointed at something we don't have — don't dead-end, hand them the community */
      function missingInner(raw, near) {
        var n = parseHzKey(raw)
        var shown = n !== null ? exactHz(n) : prettySlug(String(raw).slice(0, 40))
        return (
          '<div class="fl-d-head"><p class="fl-eyebrow" style="color:var(--accent)">Not in the library yet</p>' +
          '<button class="fl-d-close" data-close aria-label="Close detail"><i class="ph ph-x"></i></button></div>' +
          '<div class="fl-d-body">' +
          (n !== null ? '<p class="fl-d-hz">' + esc(shown) + '<small>Hz</small></p>' : '') +
          '<p class="fl-d-name">' +
          (n !== null
            ? "We don't have information on this frequency"
            : "We don't have information on “" + esc(shown) + '”') +
          '</p>' +
          '<p class="fl-d-desc">Our library covers the frequencies we can describe properly, what they\'re ' +
          "commonly used for, and which device runs them. This one isn't in it yet.</p>" +
          '<p class="fl-d-desc">People in our community run far more than we\'ve catalogued, and they talk about ' +
          "what they actually notice. That's the best place to ask about this one.</p>" +
          (near
            ? '<div class="fl-d-compat"><i class="ph ph-arrow-bend-down-right" style="color:var(--accent)"></i>' +
              '<span>Closest we do have: <b>' +
              formatHz(near.hz) +
              ' Hz — ' +
              esc(near.name) +
              '</b></span>' +
              '<button class="fl-btn-ghost" data-open="' +
              esc(near.id) +
              '" style="margin-left:auto;padding:6px 12px;font-size:13px">Open</button></div>'
            : '') +
          '<div class="fl-d-cta">' +
          '<a class="fl-btn" href="' +
          esc(communityUrl) +
          '" target="_blank" rel="noopener">Ask the community on Facebook<i class="ph ph-arrow-up-right"></i></a>' +
          '<button class="fl-btn-ghost" data-close>Browse the full library</button>' +
          '<p class="fl-d-mini">Private, moderated group. Members share their own experience — general wellness ' +
          'and relaxation, not medical advice.</p>' +
          '</div></div>'
        )
      }
      /* group the thousands like formatHz, but never round — this is the value
         the visitor asked for, and it has to read back as what they typed */
      function exactHz(n) {
        var parts = String(n).split('.')
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
      }
      function nearestFreq(list, n) {
        var best = null,
          bestD = Infinity
        for (var i = 0; i < list.length; i++) {
          var d = Math.abs(list[i].hz - n)
          if (d < bestD) {
            bestD = d
            best = list[i]
          }
        }
        /* "closest we do have" only earns the name within 10% (or 0.5 Hz at the
           low end) — offering 7.83 Hz to someone who asked for 123.45 is noise */
        return best && bestD <= Math.max(0.5, n * 0.1) ? best : null
      }
      function openMissing(raw, viaHistory) {
        currentDetailId = null
        currentMissingKey = raw
        if (viaHistory) pushedDetail = false
        else {
          writeUrl(true, null, raw)
          pushedDetail = true
        }
        setDetailTitle(null)
        lastFocus = document.activeElement
        var n = parseHzKey(raw)
        if (n === null) {
          showDrawer(missingInner(raw, null))
          return
        }
        /* the nearest match needs the whole catalog — fetched once, only for this */
        var show = function (near) {
          if (currentMissingKey === raw) showDrawer(missingInner(raw, near))
        }
        loadCatalog(apiBase).then(
          function (list) {
            list.forEach(function (f) {
              FREQS[f.id] = f
            })
            show(nearestFreq(list, n))
          },
          function () {
            show(null)
          }
        )
      }
      function showDrawer(html) {
        dInner.innerHTML = html
        clearTimeout(hideTimer)
        scrim.hidden = false
        drawer.hidden = false
        requestAnimationFrame(function () {
          scrim.classList.add('fl-show')
          drawer.classList.add('fl-show')
          var close = qs('.fl-d-close')
          if (close) close.focus()
        })
      }
      function openDetail(id, originEl, viaHistory) {
        var f = FREQS[id]
        if (!f) return
        pendingKey = null
        currentDetailId = f.id
        currentMissingKey = null
        if (viaHistory) pushedDetail = false
        else {
          writeUrl(true, f.id)
          pushedDetail = true
        }
        setDetailTitle(f)
        lastFocus = originEl || document.activeElement
        showDrawer(detailInner(f))
      }
      function closeDetail(viaHistory) {
        scrim.classList.remove('fl-show')
        drawer.classList.remove('fl-show')
        clearTimeout(hideTimer)
        hideTimer = setTimeout(function () {
          scrim.hidden = true
          drawer.hidden = true
        }, 320)
        if (lastFocus && lastFocus.focus) lastFocus.focus()
        currentDetailId = null
        currentMissingKey = null
        setDetailTitle(null)
        if (viaHistory) pushedDetail = false
        else if (pushedDetail) {
          pushedDetail = false
          try {
            window.history.back()
          } catch (e) {}
        } else writeUrl(false, null)
      }
      scrim.addEventListener('click', function () {
        closeDetail()
      })
      drawer.addEventListener('click', function (e) {
        var c = e.target.closest ? e.target.closest('[data-close]') : null
        if (c) closeDetail()
      })
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('fl-show')) closeDetail()
      })

      /* ── URL state: ?f=<hz-or-id> deep link, ?q=<terms> search prefill,
         ?category=<id>[,<id>] benefit filter, push/popstate ── */
      function readParams() {
        try {
          return new URLSearchParams(window.location.search)
        } catch (e) {
          return null
        }
      }
      function slugify(str) {
        return String(str)
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+/, '')
          .replace(/-+$/, '')
      }
      /* the canonical ?f= value is the Hz number: "7.83", "432", "9999.99".
         Written verbatim so it always round-trips through the strict match below. */
      function hzKey(f) {
        return String(f.hz)
      }
      /* "432", "7.83", "432hz", "432 Hz", "9,999.99" → the Hz number, else null.
         Formatting is forgiving; the value is not (see resolveKey). */
      function parseHzKey(key) {
        var t = String(key).toLowerCase().replace(/[\s,]/g, '').replace(/hz$/, '')
        return /^\d*\.?\d+$/.test(t) ? parseFloat(t) : null
      }
      function findHz(list, n) {
        for (var i = 0; i < list.length; i++) {
          if (list[i].hz === n) return list[i]
        }
        return null
      }
      /* a ?f= key → Promise<frequency | null>. Accepts the Hz value ("7.83") or
         the API id ("schumann-resonance"); a legacy "frequency-" prefix and
         name-like spellings are slugified down to the id. null = not in the
         library; a rejection = the API couldn't answer. */
      function resolveKey(raw) {
        var n = parseHzKey(raw)
        if (n !== null) {
          /* strict: the Hz value must match exactly — 888.001 is not 888.
             q matches the Hz digits as a substring, so filter for the exact value */
          var known = []
          for (var id in FREQS) known.push(FREQS[id])
          var hit = findHz(known, n)
          if (hit) return Promise.resolve(hit)
          return fetchJSON(apiBase + '/frequencies?pageSize=200&q=' + encodeURIComponent(String(n))).then(
            function (j) {
              var list = ((j && j.data) || []).map(function (it) {
                var f = mapFreq(it)
                FREQS[f.id] = f
                return f
              })
              return findHz(list, n)
            }
          )
        }
        var key = slugify(String(raw).replace(/^frequency-/i, ''))
        if (!key) return Promise.resolve(null)
        if (FREQS[key]) return Promise.resolve(FREQS[key])
        return fetchJSON(apiBase + '/frequencies/' + encodeURIComponent(key)).then(
          function (it) {
            var f = mapFreq(it)
            FREQS[f.id] = f
            return f
          },
          function (err) {
            /* 404 = renamed or removed */
            if (err && err.status === 404) return null
            throw err
          }
        )
      }
      /* what we put in the URL for an open detail — Hz, with the id as a fallback */
      function urlKeyFor(id) {
        return FREQS[id] ? hzKey(FREQS[id]) : String(id)
      }
      /* "healing-and-recovery,focus-and-productivity" → { id: 1, … }.
         Takes API ids or display names; anything not in the catalog is dropped. */
      function benefitsFromParam(raw) {
        var out = {}
        if (!raw || !META) return out
        String(raw)
          .split(',')
          .forEach(function (part) {
            var key = part.trim().toLowerCase()
            if (!key) return
            for (var i = 0; i < META.benefits.length; i++) {
              var b = META.benefits[i]
              if (b.id === key || b.name.toLowerCase() === key || slugify(b.name) === key) out[b.id] = 1
            }
          })
        return out
      }
      function benefitsToParam() {
        return setKeys(benefits).join(',')
      }
      function writeUrl(push, detailId, rawKey) {
        var p = readParams()
        if (!p || !window.history || !window.history.pushState) return
        if (query) p.set('q', query)
        else p.delete('q')
        var cat = benefitsToParam()
        if (cat) p.set('category', cat)
        else p.delete('category')
        if (detailId) p.set('f', urlKeyFor(detailId))
        else if (rawKey) p.set('f', rawKey)
        else p.delete('f')
        var search = p.toString()
        var url = window.location.pathname + (search ? '?' + search : '') + window.location.hash
        try {
          if (push) window.history.pushState({ fl: 1 }, '', url)
          else window.history.replaceState({ fl: 1 }, '', url)
        } catch (e) {}
      }
      /* filter changes aren't history entries — they just keep the URL shareable */
      function queueUrlSync() {
        clearTimeout(urlTimer)
        urlTimer = setTimeout(function () {
          writeUrl(false, currentDetailId, currentMissingKey || pendingKey)
        }, 300)
      }
      function setDetailTitle(f) {
        document.title = f ? f.name + ' — ' + formatHz(f.hz) + ' Hz · ' + baseTitle : baseTitle
      }
      /* open whatever ?f= names, once the API has resolved it */
      function openFromKey(raw) {
        var seq = ++resolveSeq
        pendingKey = raw
        resolveKey(raw).then(
          function (f) {
            if (seq !== resolveSeq) return
            pendingKey = null
            if (f) {
              if (currentDetailId !== f.id) openDetail(f.id, null, true)
            } else if (currentMissingKey !== raw) openMissing(raw, true)
          },
          function (err) {
            if (seq !== resolveSeq) return
            pendingKey = null
            if (window.console) console.warn('[frequency-library] could not resolve ?f=' + raw, err)
          }
        )
      }
      /* back/forward: make the UI match whatever the URL now says */
      function syncFromUrl() {
        var p = readParams()
        if (!p) return
        var q = p.get('q') || ''
        var cat = benefitsFromParam(p.get('category'))
        if (q !== query || setKeys(cat).join('|') !== setKeys(benefits).join('|')) {
          query = q
          searchInput.value = q
          benefits = cat
          page = 1
          if (META) {
            renderControls()
            fetchList()
          }
        }
        var raw = p.get('f')
        if (raw) {
          if (currentMissingKey === raw) return
          if (currentDetailId && urlKeyFor(currentDetailId) === raw) return
          openFromKey(raw)
        } else {
          resolveSeq++
          pendingKey = null
          if (currentDetailId || currentMissingKey) closeDetail(true)
        }
      }
      /* on load: ?q= pre-fills the search and ?category= the benefit chips (before the first fetch) …
         returns true when either applied, so boot can scroll the catalog into view */
      function applyUrlOnLoad() {
        var p = readParams()
        if (!p) return false
        var applied = false
        var q = p.get('q') || ''
        if (q && q !== query) {
          query = q
          searchInput.value = q
          page = 1
          applied = true
        }
        var cat = benefitsFromParam(p.get('category'))
        if (setHas(cat)) {
          benefits = cat
          page = 1
          applied = true
        }
        return applied
      }
      function scrollToCatalog() {
        var lib = qs('.fl-catalog') || root
        var top = lib.getBoundingClientRect().top + window.pageYOffset - 70
        window.scrollTo({ top: top, behavior: 'smooth' })
      }
      /* … and ?f= opens that frequency's detail view */
      function openDetailFromUrl() {
        var p = readParams()
        if (!p) return
        var raw = p.get('f')
        if (raw) openFromKey(raw)
      }
      window.addEventListener('popstate', syncFromUrl)

      /* ── FAQ accordion ── */
      qsa('.fl-faq-item').forEach(function (item) {
        var q = qs('.fl-faq-q', item)
        var a = qs('.fl-faq-a', item)
        var inner = qs('.fl-faq-inner', item)
        function setH() {
          a.style.maxHeight = item.classList.contains('fl-open') ? inner.scrollHeight + 'px' : '0px'
        }
        if (item.classList.contains('fl-open')) requestAnimationFrame(setH)
        q.addEventListener('click', function () {
          var willOpen = !item.classList.contains('fl-open')
          qsa('.fl-faq-item').forEach(function (other) {
            other.classList.remove('fl-open')
            qs('.fl-faq-q', other).setAttribute('aria-expanded', 'false')
            qs('.fl-faq-a', other).style.maxHeight = '0px'
          })
          if (willOpen) {
            item.classList.add('fl-open')
            q.setAttribute('aria-expanded', 'true')
            a.style.maxHeight = inner.scrollHeight + 'px'
          }
        })
      })
      window.addEventListener('resize', function () {
        var open = qs('.fl-faq-item.fl-open')
        if (open) qs('.fl-faq-a', open).style.maxHeight = qs('.fl-faq-inner', open).scrollHeight + 'px'
      })

      /* ── floating CTA reveal ── */
      var floating = qs('.fl-floating')
      if (floating) {
        var onScroll = function () {
          var sentinel = qs('#fl-hero-sentinel')
          var bottom = sentinel ? sentinel.getBoundingClientRect().bottom : 600
          floating.classList.toggle('fl-show', bottom < 0)
        }
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)
      }

      /* ── smooth in-page anchors ── */
      qsa('a[href^="#freq-"]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var tgt = document.getElementById(a.getAttribute('href').slice(1))
          if (tgt) {
            e.preventDefault()
            window.scrollTo({ top: tgt.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' })
          }
        })
      })

      function renderLoading() {
        if (countEl) countEl.textContent = ''
        if (activeEl) activeEl.innerHTML = '<span class="fl-hint">Loading the frequency library…</span>'
        regionEl.innerHTML = '<div class="fl-results fl-list">' + skeletons(8) + '</div>'
      }
      function renderError() {
        if (countEl) countEl.textContent = ''
        regionEl.innerHTML =
          '<div class="fl-empty"><i class="ph ph-wifi-slash"></i>' +
          "<h3>We couldn't load the frequency library.</h3>" +
          '<p>Check your connection and try again.</p>' +
          '<button class="fl-btn-ghost" data-retry>Retry</button></div>'
      }
      function boot() {
        renderLoading()
        loadMeta(apiBase).then(
          function (m) {
            META = m
            renderChips()
            var filtered = applyUrlOnLoad()
            renderControls()
            fetchList()
            if (filtered) scrollToCatalog()
            openDetailFromUrl()
          },
          function () {
            renderError()
            if (activeEl) activeEl.innerHTML = ''
          }
        )
      }

      /* boot */
      boot()
    }

    function initAll() {
      var roots = document.querySelectorAll('.fl-root')
      for (var i = 0; i < roots.length; i++) initFreqLib(roots[i])
    }
    if (document.readyState !== 'loading') initAll()
    else document.addEventListener('DOMContentLoaded', initAll)
    document.addEventListener('shopify:section:load', initAll)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section-2"] && !Shopify.designMode) return;
  try {
    
  class HeroVideoCard extends HTMLElement {
    connectedCallback() {
      this.lightbox = this.querySelector('[data-hero-video-lightbox]');
      this.video = this.querySelector('video');
      if (!this.lightbox) return;

      // The desktop trigger lives inside the hero <section>, outside this
      // element, so triggers are matched by section id rather than descendants.
      this.triggers = document.querySelectorAll(
        '[data-hero-video-open="' + this.dataset.sectionId + '"]'
      );
      this.onTrigger = (event) => this.open(event.currentTarget);
      this.triggers.forEach((trigger) => trigger.addEventListener('click', this.onTrigger));

      this.onLightboxClick = (event) => {
        if (!event.target.closest('.hero-2-video-frame')) this.close();
      };
      this.lightbox.addEventListener('click', this.onLightboxClick);

      this.onKeydown = (event) => {
        if (event.key === 'Escape') this.close();
      };
    }

    disconnectedCallback() {
      if (this.triggers) {
        this.triggers.forEach((trigger) => trigger.removeEventListener('click', this.onTrigger));
      }
      if (this.lightbox) this.lightbox.removeEventListener('click', this.onLightboxClick);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.classList.remove('hero-2-video-open');
    }

    open(trigger) {
      this.lastTrigger = trigger;
      this.lightbox.hidden = false;
      document.documentElement.classList.add('hero-2-video-open');
      document.addEventListener('keydown', this.onKeydown);
      if (this.video) {
        const played = this.video.play();
        if (played && typeof played.catch === 'function') played.catch(() => {});
      }
      const close = this.querySelector('[data-hero-video-close]');
      if (close) close.focus();
    }

    close() {
      if (this.lightbox.hidden) return;
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }
      this.lightbox.hidden = true;
      document.documentElement.classList.remove('hero-2-video-open');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.lastTrigger) this.lastTrigger.focus();
    }
  }

  if (!customElements.get('hero-video-card')) {
    customElements.define('hero-video-card', HeroVideoCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instructions-section"] && !Shopify.designMode) return;
  try {
    
  const deviceIds = ['first', 'second', 'third']
  const deviceEls = {}
  const deviceInstructionEls = {}
  deviceIds.forEach((id) => {
    deviceEls[id] = document.getElementById(`${id}-device`)
    deviceInstructionEls[id] = document.getElementById(`${id}-device-instructions`)
  })
  const dropdown = document.getElementById('device-dropdown')
  const selectedClass = 'selected-device'

  const mobileIcons = document.querySelectorAll('[data-mobile-icon]')

  function selectDevice(deviceId) {
    deviceIds.forEach((id) => {
      deviceEls[id]?.classList.remove(selectedClass)
      deviceInstructionEls[id]?.classList.remove(selectedClass)
    })
    deviceEls[deviceId]?.classList.add(selectedClass)
    deviceInstructionEls[deviceId]?.classList.add(selectedClass)
    if (dropdown && dropdown.value !== deviceId) dropdown.value = deviceId
    mobileIcons.forEach((icon) => {
      icon.classList.toggle('active', icon.dataset.mobileIcon === deviceId)
    })
  }

  // Set initial active icon
  mobileIcons.forEach((icon) => {
    icon.classList.toggle('active', icon.dataset.mobileIcon === 'first')
  })

  deviceIds.forEach((id) => {
    deviceEls[id]?.addEventListener('click', () => selectDevice(id))
  })

  dropdown?.addEventListener('change', () => selectDevice(dropdown.value))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-page-new"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    var root = document.currentScript && document.currentScript.closest ? document.currentScript.closest('.lpn') : null

    function init(scope) {
      if (!scope || scope.dataset.lpnInit) return
      scope.dataset.lpnInit = '1'

      // Smooth-scroll the in-page anchor CTAs (account for sticky header offset).
      scope.querySelectorAll('.lpn-js-scroll').forEach(function (link) {
        link.addEventListener('click', function (e) {
          var id = (link.getAttribute('href') || '').replace(/^#/, '')
          var target = id && scope.querySelector('#' + CSS.escape(id))
          if (!target) return
          e.preventDefault()
          target.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      })

      // Mobile sticky CTA: reveal after the hero scrolls out of view.
      var sticky = scope.querySelector('[data-lpn-sticky]')
      var hero = scope.querySelector('.lpn-hero')
      if (sticky && hero && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            sticky.classList.toggle('is-visible', !entries[0].isIntersecting)
          },
          { rootMargin: '-40% 0px 0px 0px' }
        )
        io.observe(hero)
      }
    }

    if (root) {
      init(root)
    } else {
      document.querySelectorAll('.lpn').forEach(init)
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["meet-us-section"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.meet-us-carousel', {
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
    },
    navigation: {
      nextEl: '.swiper-custom-button-next',
      prevEl: '.swiper-custom-button-prev',
    },
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-new"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nl-new').forEach((root) => {
    const form = root.querySelector('.nl-new__form-shell')
    if (!form) return
    const fields = form.querySelector('.nl-new__form')
    const input = form.querySelector('.nl-new__input')
    const submitBtn = form.querySelector('.nl-new__submit')
    const error = form.querySelector('[data-nl-error]')
    const body = form.querySelector('[data-nl-body]')
    const success = form.querySelector('[data-nl-success]')
    const emailOut = form.querySelector('[data-nl-email]')
    const INVALID_MSG = 'Enter a valid email address, like name@example.com.'
    const GENERIC_MSG = 'Something went wrong. Please try again in a moment.'
    const VERIFY_MSG = "We couldn't verify your signup. Please try again."
    const OFFLINE_MSG = 'You appear to be offline. Check your connection and try again.'
    const isValid = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim())
    let tried = false

    // JS handles validation; without JS the browser's native validation applies.
    form.noValidate = true

    const showError = (message) => {
      fields.classList.toggle('is-invalid', Boolean(message))
      error.hidden = !message
      if (message) error.textContent = message
      input.setAttribute('aria-invalid', message ? 'true' : 'false')
    }

    const showSuccess = (email) => {
      emailOut.textContent = email
      body.hidden = true
      success.hidden = false
    }

    // Pull the server-rendered error (e.g. from form.errors) out of the returned page.
    const readServerError = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html')
      const returned = doc.getElementById(form.id)
      if (!returned) return null
      if (returned.querySelector('[data-nl-success]:not([hidden])')) return { success: true }
      const err = returned.querySelector('[data-nl-error]:not([hidden])')
      return err ? { error: err.textContent.trim() } : null
    }

    input.addEventListener('input', () => {
      if (tried) showError(isValid(input.value) ? '' : INVALID_MSG)
    })

    const nativeSubmit = HTMLFormElement.prototype.submit.bind(form)
    let sending = false

    const send = async () => {
      if (sending) return
      const email = input.value.trim()
      sending = true
      submitBtn.disabled = true

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'text/html' },
        })
        const url = new URL(response.url, window.location.origin)

        // Shopify escalated to its full-page bot challenge; only a real navigation can complete it.
        if (url.pathname.includes('/challenge')) {
          nativeSubmit()
          return
        }

        // 400 = captcha token missing, expired or rejected. The next submit fetches a fresh one.
        if (response.status === 400) throw new Error(VERIFY_MSG)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)

        if (url.searchParams.get('customer_posted') === 'true') {
          showSuccess(email)
          return
        }

        const result = readServerError(await response.text())
        if (result?.success) {
          showSuccess(email)
        } else {
          showError(result?.error || GENERIC_MSG)
          input.focus()
        }
      } catch (err) {
        console.error('[Newsletter new] Error:', err)
        if (navigator.onLine === false) showError(OFFLINE_MSG)
        else showError(err.message === VERIFY_MSG ? VERIFY_MSG : GENERIC_MSG)
      } finally {
        sending = false
        submitBtn.disabled = false
      }
    }

    // Shopify's spam protection (captcha-bootstrap + hCaptcha in content_for_header) intercepts submits on
    // /contact forms, attaches a token, then calls form.submit(), which would reload the page. The hCaptcha
    // script captures form.submit when it binds (on first focus), so overriding it here routes that final
    // step through fetch while keeping the token.
    form.submit = send

    form.addEventListener('submit', (event) => {
      event.preventDefault()
      if (sending || !isValid(input.value)) {
        // Stop the captcha listeners too, so an invalid email never triggers a challenge or a submit.
        event.stopImmediatePropagation()
        if (!sending) {
          tried = true
          showError(INVALID_MSG)
          input.focus()
        }
        return
      }
      showError('')
      // The captcha scripts run after this listener and call form.submit() themselves. If neither is active,
      // send directly.
      setTimeout(() => {
        if (!sending && !form.hasAttribute('data-hcaptcha-bound')) send()
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  let newsletterInputElement = document.querySelector('.newsletter--input')
  newsletterInputElement.addEventListener('input', () => {
    if (newsletterInputElement.value !== '') {
      newsletterInputElement.classList.add('dirty')
    } else {
      newsletterInputElement.classList.remove('dirty')
    }
  })
  const newsletterForm = document.getElementById('newsletter_form')
  const newsletterPopup = document.getElementById('newsletter-popup')

  newsletterForm.addEventListener('submit', function (event) {
    event.preventDefault() // Prevent the default form submission
    const formData = new FormData(newsletterForm)

    fetch(window.Shopify.routes.root + 'apps/api/forms', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        return response.json()
      })
      .then((response) => {
        console.log('[Newsletter] Form response:', response)
        if (response.success) {
          newsletterInputElement.value = ''
          newsletterInputElement.classList.remove('dirty')
          newsletterPopup.style.display = 'flex'
          document.body.style.overflow = 'hidden'
        } else {
          throw new Error(response.error || 'An error occurred')
        }
      })
      .catch((error) => {
        console.error('[Newsletter] Error:', error)
        Toastify({
          text: 'There was an error submitting the form. Please try again later.',
          duration: 3000,
          newWindow: true,
          close: false,
          gravity: 'bottom', // `top` or `bottom`
          position: 'left', // `left`, `center` or `right`
          stopOnFocus: true, // Prevents dismissing of toast on hover
          style: {
            background: 'white',
            color: 'black',
            borderRadius: '8px',
          },
          onClick: function () {}, // Callback after click
        }).showToast()
      })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyBar = document.querySelector('[data-sticky-cta]')
    if (!stickyBar) return

    /* Pick the rendered main ATC button. The canonical primary lives inside
       #product-atc-component (rendered by v3-atc / prd-atc blocks). When present,
       we track that one — the IntersectionObserver will pick up its real viewport
       intersection regardless of where it sits at load time. */
    function isVisible(el) {
      if (!el || el.offsetParent === null) return false
      const r = el.getBoundingClientRect()
      return r.width > 0 && r.height > 0
    }

    function findMainButton() {
      const primary = document.querySelector('#product-atc-component .product-add-to-cart-button')
      if (primary) return primary

      const candidates = Array.from(document.querySelectorAll('.product-add-to-cart-button'))
      const visible = candidates.filter(isVisible)
      return visible[0] || candidates[0] || null
    }

    let mainButton = findMainButton()

    /* ── Slide-in: show whenever main ATC is not in the viewport ─────── */
    let isFooterVisible = false
    let isButtonVisible = true /* assume visible until we know otherwise */

    function applyVisibility() {
      const shouldShow = !isButtonVisible && !isFooterVisible
      stickyBar.classList.toggle('active', shouldShow)
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true')
    }

    function recomputeButtonVisibility() {
      if (!mainButton) {
        /* No main button means we cannot tie visibility to it — keep sticky hidden. */
        isButtonVisible = true
        applyVisibility()
        return
      }
      const r = mainButton.getBoundingClientRect()
      const vh = window.innerHeight || document.documentElement.clientHeight
      isButtonVisible = r.bottom > 0 && r.top < vh && r.width > 0 && r.height > 0
      applyVisibility()
    }

    if (mainButton) {
      const observer = new IntersectionObserver(
        function (entries) {
          for (const e of entries) {
            if (e.target === mainButton) isButtonVisible = e.isIntersecting
          }
          applyVisibility()
        },
        { root: null, threshold: 0 }
      )
      observer.observe(mainButton)

      const footer = document.querySelector('footer')
      if (footer) {
        new IntersectionObserver(
          function (entries) {
            isFooterVisible = entries[0].isIntersecting
            applyVisibility()
          },
          { root: null, threshold: 0.01 }
        ).observe(footer)
      }

      /* Initial pass — IntersectionObserver fires async; compute once now so
         the sticky bar appears immediately if the button is already off-screen
         on load (e.g. anchor link, restored scroll position). */
      recomputeButtonVisibility()
    } else {
      /* If the main ATC isn't on the page at all, the sticky cannot anchor to
         it — keep it hidden to avoid permanently covering content. */
      isButtonVisible = true
      applyVisibility()
    }

    /* Resize / orientation: re-measure in case layout shifted the button. */
    window.addEventListener('resize', recomputeButtonVisibility, { passive: true })

    /* Scroll fallback: IntersectionObserver should normally handle this, but
       if the wrong element was initially observed (e.g. a stale .product-add-to-cart-button
       in a hidden block) or IO doesn't fire reliably, this guarantees visibility
       stays correct. rAF-throttled to keep it cheap. */
    let scrollTicking = false
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return
        scrollTicking = true
        window.requestAnimationFrame(function () {
          recomputeButtonVisibility()
          scrollTicking = false
        })
      },
      { passive: true }
    )

    /* Layout can shift after async content (e.g. variant selectors, gallery)
       — rebind to the right button if it appears later. */
    if (!mainButton) {
      const mo = new MutationObserver(function () {
        const found = findMainButton()
        if (found) {
          mainButton = found
          mo.disconnect()
          new IntersectionObserver(
            function (entries) {
              isButtonVisible = entries[0].isIntersecting
              applyVisibility()
            },
            { root: null, threshold: 0 }
          ).observe(mainButton)
          recomputeButtonVisibility()
        }
      })
      mo.observe(document.body, { childList: true, subtree: true })
    }

    /* ── Variant bottom sheet ─────────────────────────────────────────── */
    const sheet = document.querySelector('[data-sticky-sheet]')
    const trigger = stickyBar.querySelector('[data-sticky-variant-trigger]')
    const stickyAtc = stickyBar.querySelector('[data-sticky-add-to-cart]')
    const stickyButton = stickyBar.querySelector('.prod__cta-button')
    const stickyThumbImg = stickyBar.querySelector('.prod__cta-thumb-img')
    const stickyVariantTitle = stickyBar.querySelector('[data-sticky-variant-title]')
    const stickyCurrentPrice = stickyBar.querySelector('[data-sticky-current-price]')
    const stickyComparePrice = stickyBar.querySelector('[data-sticky-compare-price]')

    let _moneyIntl = null
    function moneyFmt(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return ''
      if (!_moneyIntl) {
        const currency =
          (window.theme && window.theme.currency) ||
          (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
          'USD'
        try {
          _moneyIntl = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: currency,
          })
        } catch (e) {
          _moneyIntl = {
            format: function (v) {
              return '$' + v.toFixed(2)
            },
          }
        }
      }
      return _moneyIntl.format(cents / 100)
    }

    function openSheet() {
      if (!sheet) return
      sheet.setAttribute('aria-hidden', 'false')
      document.documentElement.style.overflow = 'hidden'
    }

    function closeSheet() {
      if (!sheet) return
      sheet.setAttribute('aria-hidden', 'true')
      document.documentElement.style.overflow = ''
    }

    if (trigger && sheet) {
      trigger.addEventListener('click', openSheet)
      sheet.querySelectorAll('[data-sticky-sheet-close]').forEach(function (el) {
        el.addEventListener('click', closeSheet)
      })
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sheet.getAttribute('aria-hidden') === 'false') closeSheet()
      })
    }

    /* Sync sticky UI to a given variant id. Pulls metadata from sheet items
       (or directly from the picked button) so it works even when the user
       opts a variant via another selector on the page. */
    function syncStickyTo(variantId, sourceBtn) {
      if (!variantId) return
      const btn = sourceBtn || (sheet && sheet.querySelector('[data-sticky-sheet-variant="' + variantId + '"]'))
      if (!btn) return

      const variantTitle = btn.getAttribute('data-variant-title') || ''
      const price = parseInt(btn.getAttribute('data-price'), 10)
      const compareRaw = btn.getAttribute('data-compare-at-price')
      const compare = compareRaw ? parseInt(compareRaw, 10) : 0
      const image = btn.getAttribute('data-image')
      const soldOut = btn.hasAttribute('data-sold-out')

      if (stickyAtc) {
        stickyAtc.setAttribute('variant-id', variantId)
        if (soldOut) stickyAtc.setAttribute('sold-out', '')
        else stickyAtc.removeAttribute('sold-out')
        if (variantTitle) stickyAtc.setAttribute('data-variant-title', variantTitle)
        if (!isNaN(price)) stickyAtc.setAttribute('data-price', price)
        if (compare) stickyAtc.setAttribute('data-compare-at-price', compare)
        else stickyAtc.removeAttribute('data-compare-at-price')
        if (image) stickyAtc.setAttribute('data-image', image)
      }

      if (stickyButton) {
        stickyButton.disabled = soldOut
        const text = stickyButton.querySelector('.prod__cta-button-text')
        if (text) text.textContent = soldOut ? 'Out of stock' : 'Add to Cart'
      }

      if (stickyVariantTitle && variantTitle) stickyVariantTitle.textContent = variantTitle
      if (stickyThumbImg && image) {
        stickyThumbImg.src = image
        stickyThumbImg.removeAttribute('srcset')
      }
      if (stickyCurrentPrice && !isNaN(price)) {
        stickyCurrentPrice.textContent = moneyFmt(price)
      }
      if (stickyComparePrice) {
        if (compare && compare > price) {
          stickyComparePrice.textContent = moneyFmt(compare)
          stickyComparePrice.hidden = false
        } else {
          stickyComparePrice.textContent = ''
          stickyComparePrice.hidden = true
        }
      }

      if (sheet) {
        sheet.querySelectorAll('[data-sticky-sheet-variant]').forEach(function (item) {
          const active = item.getAttribute('data-sticky-sheet-variant') === String(variantId)
          item.classList.toggle('is-active', active)
          item.setAttribute('aria-pressed', active ? 'true' : 'false')
        })
      }

      stickyBar.querySelectorAll('[data-sticky-pill-variant]').forEach(function (item) {
        const active = item.getAttribute('data-sticky-pill-variant') === String(variantId)
        item.classList.toggle('is-active', active)
        item.setAttribute('aria-checked', active ? 'true' : 'false')
      })
    }

    function selectVariantFrom(item, opts) {
      const id = item.getAttribute('data-sticky-sheet-variant') || item.getAttribute('data-sticky-pill-variant')
      if (!id) return
      const soldOut = item.hasAttribute('data-sold-out')
      const variantTitle = item.getAttribute('data-variant-title') || ''
      const priceAttr = item.getAttribute('data-price')
      const compareAttr = item.getAttribute('data-compare-at-price')
      const imageAttr = item.getAttribute('data-image')

      /* Update every <add-to-cart> on the page so other selectors stay in sync.
         Propagating the full meta keeps the optimistic cart placeholder showing
         the *selected* variant's title/price/image rather than the default.

         Skip [data-fixed-variant] — side-product ATCs (bee bundles, pairs-well,
         bought-together) are bound to a specific variant and must not be
         clobbered, or clicking the bundle will add the current product. */
      document.querySelectorAll('add-to-cart:not([data-fixed-variant])').forEach(function (el) {
        el.setAttribute('variant-id', id)
        if (soldOut) el.setAttribute('sold-out', '')
        else el.removeAttribute('sold-out')
        if (variantTitle) el.setAttribute('data-variant-title', variantTitle)
        if (priceAttr) el.setAttribute('data-price', priceAttr)
        if (compareAttr) el.setAttribute('data-compare-at-price', compareAttr)
        else el.removeAttribute('data-compare-at-price')
        if (imageAttr) el.setAttribute('data-image', imageAttr)
      })

      /* Reflect into existing variant selectors that key off data-variant-id */
      document.querySelectorAll('[data-variant-id="' + id + '"]').forEach(function (other) {
        if (other.matches('.wb-variant-btn')) other.click()
      })

      syncStickyTo(id, item)
      document.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variantId: id } }))
      if (opts && opts.closeSheet) closeSheet()
    }

    if (sheet) {
      sheet.querySelectorAll('[data-sticky-sheet-variant]').forEach(function (item) {
        item.addEventListener('click', function () {
          selectVariantFrom(item, { closeSheet: true })
        })
      })
    }

    stickyBar.querySelectorAll('[data-sticky-pill-variant]').forEach(function (item) {
      item.addEventListener('click', function () {
        if (item.disabled || item.hasAttribute('data-sold-out')) return
        selectVariantFrom(item)
      })
    })

    /* When another selector on the page changes the variant, keep us in sync */
    document.addEventListener('variant:changed', function (e) {
      const id = e.detail && e.detail.variantId
      if (id) syncStickyTo(String(id))
    })

    /* Also watch the main ATC for variant-id mutations (other selectors poke it directly) */
    const otherAtc = document.querySelector('add-to-cart:not([data-sticky-add-to-cart])')
    if (otherAtc) {
      new MutationObserver(function (mutations) {
        for (const m of mutations) {
          if (m.attributeName === 'variant-id') {
            const id = otherAtc.getAttribute('variant-id')
            if (id) syncStickyTo(id)
          }
        }
      }).observe(otherAtc, { attributes: true, attributeFilter: ['variant-id'] })
    }

    /* ── Depth effect on mobile only (preserved from previous behavior) ── */
    const galleryOverlay = document.querySelector('[data-gallery-overlay]')
    const productInfo = document.querySelector('.product-utf-info')

    if (window.innerWidth <= 550) {
      let ticking = false
      function handleScroll() {
        if (ticking) return
        ticking = true
        window.requestAnimationFrame(function () {
          const scrollY = window.scrollY || window.pageYOffset
          const maxScroll = 300
          const scrollProgress = Math.min(scrollY / maxScroll, 1)
          if (galleryOverlay) {
            galleryOverlay.style.backgroundColor = `rgba(0, 0, 0, ${scrollProgress * 0.3})`
          }
          if (productInfo) {
            productInfo.classList.toggle('scrolled', scrollProgress > 0.15)
          }
          ticking = false
        })
      }
      window.addEventListener('scroll', handleScroll, { passive: true })
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schummi-ai"] && !Shopify.designMode) return;
  try {
    
  // Swiper is loaded with `defer` in the document head, so it may not be
  // defined yet when this section script runs. Initialising it unguarded would
  // throw a ReferenceError and abort the rest of this script — leaving the
  // submit button permanently disabled. Init it safely, retrying on window load.
  function initCommonQuestionsCarousel() {
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', initCommonQuestionsCarousel, { once: true })
      return
    }
    new Swiper('.schummi-common-questions-carousel', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })
  }
  initCommonQuestionsCarousel()
  const submitButton = document.getElementById('schummi-ai-chat-submit')
  const landingDiv = document.getElementById('schummi-ai-chat-landing')
  const inputForm = document.getElementById('schummi-ai-chat-input')
  const inputElement = document.getElementById('schummi-ai-chat-input-element')
  const conversationIdInput = document.getElementById('conversation_id')
  const chat = document.getElementById('schummi-ai-chat')
  const chatWrapper = document.querySelector('.schummi-ai-chat-wrapper')
  const commonQuestions = chatWrapper.querySelectorAll('.schummi-common-question')
  var disabled = true
  commonQuestions.forEach((question) => {
    question.addEventListener('click', () => {
      if (inputForm.input.value.trim() === '' && !disabled) {
        inputForm.input.value = question.textContent
        const formData = new FormData(inputForm)
        conversation.push({ message: inputForm.input.value, answer: '...' })
        sendMessage(formData)
        renderConversation()
      }
    })
  })
  let conversation = []
  async function getConversation(conversationId) {
    try {
      const response = await fetch(
        window.Shopify.routes.root + 'apps/api/responses?id=' + conversationId,
        { method: 'GET' }
      )
      const data = await response.json()
      // Handle proxy response format
      if (data.success && data.data && data.data.conversation) {
        conversation = data.data.conversation
      } else if (data.conversation) {
        // Fallback for direct response format
        conversation = data.conversation
      } else {
        conversation = []
      }
      renderConversation()
    } catch (error) {
      console.error('Error fetching conversation:', error)
      conversation = [{ message: 'Sorry, something went wrong.', answer: '' }]
      renderConversation()
    } finally {
      setLoadingState(false)
      disabled = false
    }
  }
  function renderConversation() {
    landingDiv.style.display = 'none'
    chat.style.display = 'block'
    chat.innerHTML = ''
    conversation.forEach((entry) => {
      const messageDiv = document.createElement('div')
      const answerDiv = document.createElement('div')
      messageDiv.classList.add('schummi-ai-message')
      answerDiv.classList.add('schummi-ai-answer')

      messageDiv.textContent = entry.message
      answerDiv.textContent = entry.answer
      chat.appendChild(messageDiv)
      chat.appendChild(answerDiv)
    })
    chatWrapper.scrollTop = chatWrapper.scrollHeight
    inputForm.input.value = ''
  }
  function setLoadingState(isLoading) {
    if (isLoading) {
      inputForm.querySelector('button').disabled = true
      inputForm.querySelector('button').style.opacity = '0.5'
    } else {
      inputForm.querySelector('button').disabled = false
      inputForm.querySelector('button').style.opacity = '1'
    }
  }

  function saveConversationId(id) {
    localStorage.setItem('schummi_conversation_id', id)
  }

  async function loadConversationId() {
    const conversationId = localStorage.getItem('schummi_conversation_id')
    if (conversationId) {
      conversationIdInput.value = conversationId
      await getConversation(conversationId)
      submitButton.disabled = false
    } else {
      submitButton.disabled = false
      disabled = false
    }
  }

  function addAnswerToConversation(text) {
    conversation[conversation.length - 1].answer = text
  }

  async function sendMessage(formData) {
    setLoadingState(true)
    fetch(window.Shopify.routes.root + 'apps/api/responses', {
      method: 'POST',
      body: formData,
    })
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        setLoadingState(false)
        disabled = false
        
        // Handle proxy response format
        if (data.success && data.data) {
          addAnswerToConversation(data.data.outputText || data.data.output_text || '')
          saveConversationId(data.data.conversationId || data.data.conversation_id)
        } else if (data.outputText || data.output_text) {
          // Fallback for direct response format
          addAnswerToConversation(data.outputText || data.output_text)
          if (data.conversationId || data.conversation_id) {
            saveConversationId(data.conversationId || data.conversation_id)
          }
        } else {
          console.error('Unexpected response format:', data)
          addAnswerToConversation('Sorry, I could not process that response.')
        }
        
        renderConversation()
      })
      .catch((error) => {
        console.error('Error sending message:', error)
        setLoadingState(false)
        disabled = false
        addAnswerToConversation('Sorry, something went wrong.')
        renderConversation()
      })
  }
  // Keep focus on the input when the submit button is tapped. On iOS Safari,
  // tapping the button would otherwise blur the input first — dismissing the
  // keyboard and firing the scroll handler below, which shifts the layout so
  // the first tap misses the button and a second tap is needed. Preventing the
  // default on mousedown stops the focus change while still allowing the click.
  submitButton.addEventListener('mousedown', (event) => {
    event.preventDefault()
  })
  inputForm.addEventListener('submit', (event) => {
    event.preventDefault()
    // Bail while a request is in flight or the chat isn't ready yet — pressing
    // Enter would otherwise bypass the disabled submit button.
    if (submitButton.disabled || disabled) return
    const formData = new FormData(inputForm)
    if (formData.get('input').trim() === '') return
    conversation.push({ message: event.target.input.value, answer: '...' })
    sendMessage(formData)

    renderConversation()
  })
  inputElement.addEventListener('blur', () => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  })
  loadConversationId()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schummi-chat-ai-page"] && !Shopify.designMode) return;
  try {
    
  ;(function () {
    /* ── Inline SVG icon set (no external icon font) ───────────── */
    var ICONS = {
      cpu: '<svg viewBox="0 0 24 24" fill="none"><rect x="6" y="6" width="12" height="12" rx="2" stroke="currentColor" stroke-width="1.8"/><rect x="9.5" y="9.5" width="5" height="5" rx="1" stroke="currentColor" stroke-width="1.8"/><path d="M9 6V3M15 6V3M9 21v-3M15 21v-3M6 9H3M6 15H3M21 9h-3M21 15h-3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      broadcast:
        '<svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="2" fill="currentColor"/><path d="M7.05 16.95a7 7 0 010-9.9M16.95 7.05a7 7 0 010 9.9M4.22 19.78a11 11 0 010-15.56M19.78 4.22a11 11 0 010 15.56" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      drop: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3s6 6.5 6 10.5a6 6 0 01-12 0C6 9.5 12 3 12 3z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      rows: '<svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="5" rx="1.5" stroke="currentColor" stroke-width="1.8"/><rect x="3" y="14" width="18" height="5" rx="1.5" stroke="currentColor" stroke-width="1.8"/></svg>',
      sliders:
        '<svg viewBox="0 0 24 24" fill="none"><path d="M4 7h10M18 7h2M4 17h2M10 17h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="16" cy="7" r="2.2" stroke="currentColor" stroke-width="1.8"/><circle cx="8" cy="17" r="2.2" stroke="currentColor" stroke-width="1.8"/></svg>',
      package:
        '<svg viewBox="0 0 24 24" fill="none"><path d="M21 8l-9-5-9 5 9 5 9-5zM3 8v8l9 5 9-5V8M12 13v8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      'arrow-up-right':
        '<svg viewBox="0 0 24 24" fill="none"><path d="M7 17L17 7M8 7h9v9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    }
    function makeIcon(name) {
      var tpl = document.createElement('template')
      tpl.innerHTML = (ICONS[name] || '').trim()
      return tpl.content.firstChild
    }

    /* ── Empty-state starter prompts ────────────────────────────── */
    var STARTERS = [
      { icon: 'cpu', label: 'Which device is right for me?', text: 'Which Schumann device is right for me?' },
      { icon: 'broadcast', label: 'What is the 7.83 Hz resonance?', text: 'What is the 7.83 Hz Schumann resonance?' },
      { icon: 'drop', label: 'How does the Water Bottle work?', text: 'How does the Frequency Water Bottle work?' },
      { icon: 'rows', label: 'Compare V1, V2 Pro & V3 Max', text: 'Compare the V1, V2 Pro and V3 Max.' },
      { icon: 'sliders', label: 'How do I set up my device?', text: 'How do I set up my device?' },
      { icon: 'package', label: 'Shipping & returns', text: 'What are your shipping and return policies?' },
    ]

    /* ── Live backend ───────────────────────────────────────────── */
    var ENDPOINT = 'https://agent.theschumann.com/api/chat'
    var ERROR_REPLY = 'Sorry, something went wrong — please try again.'

    /* ── Product catalog (for recommendation cards) ─────────────────
       The agent's `recommendation` event carries only the display NAME, so we
       resolve it to live Shopify data (image / price / url) rendered into the
       section body as JSON in `script.sca-product` tags. */
    function normName(s) {
      return (s || '').toString().toLowerCase().replace(/\s+/g, ' ').trim()
    }
    /* Display name → Shopify handle. Mirrors schummi-ai-agent's PRODUCT_CATALOG
       so cards still resolve if a catalog name drifts from the storefront title. */
    var NAME_TO_HANDLE = {
      'v3 max': 'the-schumann-v3',
      'v2 pro': 'the-schumann-v2',
      'v1 classic': 'the-schumann-v1',
      'emf nano shield': 'emf-sticker',
      'frequency water bottle': 'frequency-water-bottle',
      'charging station': 'charger-dock',
      'frequency guide book': 'frequency-guide-book',
      'schumann tote bag': 'tote-bag',
      'the schumann e-book': 'e-book',
      'schumann v3 pouch': 'schumann-v3-pouch',
    }
    var PRODUCTS_BY_HANDLE = {}
    var PRODUCTS_BY_NAME = {}
    ;(function loadCatalog() {
      var nodes = document.querySelectorAll('script.sca-product')
      for (var i = 0; i < nodes.length; i++) {
        var handle = nodes[i].getAttribute('data-handle')
        var data
        try {
          data = JSON.parse(nodes[i].textContent)
        } catch (e) {
          continue
        }
        if (!data) continue
        data.handle = handle
        if (handle) PRODUCTS_BY_HANDLE[handle] = data
        if (data.name) PRODUCTS_BY_NAME[normName(data.name)] = data
      }
    })()

    /* Resolve a recommendation's product name to a card. Tries the alias map,
       then a direct name match; falls back to a minimal card with no image. */
    function resolveProduct(name) {
      var key = normName(name)
      var handle = NAME_TO_HANDLE[key]
      var found = (handle && PRODUCTS_BY_HANDLE[handle]) || PRODUCTS_BY_NAME[key]
      if (found) return found
      return { name: name || 'Recommended product', url: '/collections/all', image: null, price: '' }
    }

    /* ── markdown-lite → DOM ────────────────────────────────────── */
    function appendInline(parent, text) {
      var parts = text.split(/(\*\*[^*]+\*\*)/g)
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i]
        if (/^\*\*[^*]+\*\*$/.test(p)) {
          var strong = document.createElement('strong')
          strong.textContent = p.slice(2, -2)
          parent.appendChild(strong)
        } else if (p) {
          parent.appendChild(document.createTextNode(p))
        }
      }
    }

    function buildRichText(text) {
      var wrap = document.createElement('div')
      wrap.className = 'sca-rt'
      var lines = text.split('\n')
      var i = 0
      while (i < lines.length) {
        var line = lines[i]
        if (/^\s*-\s+/.test(line)) {
          var ul = document.createElement('ul')
          while (i < lines.length && /^\s*-\s+/.test(lines[i])) {
            var li = document.createElement('li')
            appendInline(li, lines[i].replace(/^\s*-\s+/, ''))
            ul.appendChild(li)
            i++
          }
          wrap.appendChild(ul)
        } else if (/^\s*\d+\.\s+/.test(line)) {
          var ol = document.createElement('ol')
          while (i < lines.length && /^\s*\d+\.\s+/.test(lines[i])) {
            var oli = document.createElement('li')
            appendInline(oli, lines[i].replace(/^\s*\d+\.\s+/, ''))
            ol.appendChild(oli)
            i++
          }
          wrap.appendChild(ol)
        } else if (line.trim() === '') {
          i++
        } else {
          var p = document.createElement('p')
          appendInline(p, line)
          wrap.appendChild(p)
          i++
        }
      }
      return wrap
    }

    /* ── Per-instance app ───────────────────────────────────────── */
    var STORE = 'sca_msgs_v1'
    var SESSION_KEY = 'sca_session_id'
    var SESSION_TTL_MS = 7 * 24 * 60 * 60 * 1000 /* 7 days */

    /* Read the stored session id, honouring a 7-day TTL. Returns null when
       missing, expired, or stored in the legacy bare-string format. */
    function readSession() {
      try {
        var raw = localStorage.getItem(SESSION_KEY)
        if (!raw) return null
        var rec = JSON.parse(raw)
        if (rec && rec.id && typeof rec.exp === 'number' && rec.exp > Date.now()) {
          return rec.id
        }
      } catch (e) {}
      return null
    }

    function initRoot(root) {
      if (root.dataset.scaReady) return
      root.dataset.scaReady = '1'

      var faceUrl = root.dataset.face || ''
      var scroll = root.querySelector('[data-sca-scroll]')
      var emptyEl = root.querySelector('[data-sca-empty]')
      var starterGrid = root.querySelector('[data-sca-starters]')
      var form = root.querySelector('[data-sca-form]')
      var input = root.querySelector('[data-sca-input]')
      var send = root.querySelector('[data-sca-send]')

      var messages = []
      try {
        var s = JSON.parse(localStorage.getItem(STORE))
        if (Array.isArray(s)) messages = s
      } catch (e) {}
      var sessionId = readSession()
      var typing = false
      var inFlight = false
      var inner = null

      function persist() {
        try {
          localStorage.setItem(STORE, JSON.stringify(messages))
        } catch (e) {}
      }
      function saveSession(id) {
        if (!id) return
        sessionId = id
        try {
          /* Rolling 7-day TTL: refreshed on every meta frame that carries an id. */
          localStorage.setItem(SESSION_KEY, JSON.stringify({ id: id, exp: Date.now() + SESSION_TTL_MS }))
        } catch (e) {}
      }
      function scrollToEnd() {
        if (scroll) scroll.scrollTop = scroll.scrollHeight
      }

      function avatar() {
        var span = document.createElement('span')
        span.className = 'sca-av'
        span.setAttribute('aria-hidden', 'true')
        if (faceUrl) {
          var img = document.createElement('img')
          img.src = faceUrl
          img.alt = ''
          span.appendChild(img)
        }
        return span
      }

      /* A suggested-product card: thumbnail, name, price, optional discount badge.
         The whole card links to the product page (same tab). */
      function productCard(p) {
        var a = document.createElement('a')
        a.className = 'sca-product-card'
        a.href = p.url || '#'
        a.setAttribute('rel', 'noopener')

        if (p.image) {
          var thumb = document.createElement('span')
          thumb.className = 'sca-pc-thumb'
          var img = document.createElement('img')
          img.src = p.image
          img.alt = ''
          img.loading = 'lazy'
          thumb.appendChild(img)
          a.appendChild(thumb)
        }

        var info = document.createElement('span')
        info.className = 'sca-pc-info'

        var name = document.createElement('span')
        name.className = 'sca-pc-name'
        name.textContent = p.name || ''
        info.appendChild(name)

        var meta = document.createElement('span')
        meta.className = 'sca-pc-meta'
        if (p.price) {
          var price = document.createElement('span')
          price.className = 'sca-pc-price'
          price.textContent = p.price
          meta.appendChild(price)
        }
        if (p.discountPercent > 0 && p.discountCode) {
          var badge = document.createElement('span')
          badge.className = 'sca-pc-badge'
          badge.textContent = 'Save ' + p.discountPercent + '% · ' + p.discountCode
          meta.appendChild(badge)
        }
        info.appendChild(meta)
        a.appendChild(info)

        var cta = makeIcon('arrow-up-right')
        if (cta) {
          cta.setAttribute('aria-hidden', 'true')
          cta.classList.add('sca-pc-cta')
          a.appendChild(cta)
        }
        return a
      }

      function messageRow(msg) {
        var row = document.createElement('div')
        if (msg.role === 'user') {
          row.className = 'sca-row is-user'
          var bub = document.createElement('div')
          bub.className = 'sca-bubble-user'
          bub.textContent = msg.content
          row.appendChild(bub)
          return row
        }
        row.className = 'sca-row'
        row.appendChild(avatar())
        var body = document.createElement('div')
        body.className = 'sca-bubble-assistant'
        var who = document.createElement('p')
        who.className = 'sca-who'
        who.textContent = 'Schummi'
        body.appendChild(who)
        body.appendChild(buildRichText(msg.content))
        if (msg.product) body.appendChild(productCard(msg.product))
        if (msg.follow && msg.follow.length) {
          var follows = document.createElement('div')
          follows.className = 'sca-follows'
          msg.follow.forEach(function (f) {
            var chip = document.createElement('button')
            chip.type = 'button'
            chip.className = 'sca-chip'
            var ic = makeIcon('arrow-up-right')
            if (ic) {
              ic.setAttribute('aria-hidden', 'true')
              chip.appendChild(ic)
            }
            chip.appendChild(document.createTextNode(f))
            chip.addEventListener('click', function () {
              send_(f)
            })
            follows.appendChild(chip)
          })
          body.appendChild(follows)
        }
        row.appendChild(body)
        return row
      }

      function typingRow() {
        var row = document.createElement('div')
        row.className = 'sca-row'
        row.appendChild(avatar())
        var body = document.createElement('div')
        body.className = 'sca-bubble-assistant'
        var who = document.createElement('p')
        who.className = 'sca-who'
        who.textContent = 'Schummi'
        body.appendChild(who)
        var t = document.createElement('div')
        t.className = 'sca-typing'
        t.setAttribute('aria-label', 'Schummi is typing')
        t.innerHTML = '<span></span><span></span><span></span>'
        body.appendChild(t)
        row.appendChild(body)
        return row
      }

      function render() {
        var isEmpty = messages.length === 0 && !typing
        if (emptyEl) emptyEl.style.display = isEmpty ? '' : 'none'

        if (isEmpty) {
          if (inner) {
            inner.remove()
            inner = null
          }
          return
        }
        if (!inner) {
          inner = document.createElement('div')
          inner.className = 'sca-msg-inner'
          scroll.appendChild(inner)
        }
        inner.innerHTML = ''
        messages.forEach(function (m) {
          inner.appendChild(messageRow(m))
        })
        if (typing) inner.appendChild(typingRow())
        scrollToEnd()
      }

      /* Parse one SSE frame (its "event:" + "data:" lines) into { event, data },
         or null when there's no parseable JSON payload. */
      function parseFrame(frame) {
        var event = 'message'
        var dataLines = []
        var lines = frame.split('\n')
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i]
          if (line.indexOf('event:') === 0) {
            event = line.slice(6).trim()
          } else if (line.indexOf('data:') === 0) {
            dataLines.push(line.slice(5).trim())
          }
        }
        if (!dataLines.length) return null
        try {
          return { event: event, data: JSON.parse(dataLines.join('\n')) }
        } catch (e) {
          return null
        }
      }

      function send_(text) {
        var t = (text || '').trim()
        if (!t || inFlight) return
        messages.push({ role: 'user', content: t })
        persist()
        typing = true
        inFlight = true
        render()
        syncSend()

        /* The assistant message is created lazily on the first delta so the
           typing indicator shows until tokens actually start arriving. */
        var reply = null
        function ensureReply() {
          if (!reply) {
            typing = false
            reply = { role: 'assistant', content: '' }
            messages.push(reply)
          }
          return reply
        }
        function appendDelta(chunk) {
          if (!chunk) return
          ensureReply()
          reply.content += chunk
          render()
        }
        function attachProduct(rec) {
          if (!rec || !rec.product) return
          var card = resolveProduct(rec.product)
          ensureReply()
          reply.product = {
            name: card.name,
            url: card.url,
            image: card.image || null,
            price: card.price || '',
            discountCode: rec.discountCode || null,
            discountPercent: typeof rec.discountPercent === 'number' ? rec.discountPercent : 0,
          }
          render()
        }
        function finish(failed) {
          typing = false
          inFlight = false
          if (!reply) {
            messages.push({ role: 'assistant', content: ERROR_REPLY })
          } else if (failed && !reply.content) {
            reply.content = ERROR_REPLY
          }
          persist()
          render()
          syncSend()
        }

        fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ session_id: sessionId, message: t }),
        })
          .then(function (res) {
            if (!res.ok || !res.body) throw new Error('HTTP ' + res.status)
            var reader = res.body.getReader()
            var decoder = new TextDecoder()
            var buffer = ''

            function pump() {
              return reader.read().then(function (r) {
                buffer += decoder
                  .decode(r.value || new Uint8Array(), { stream: !r.done })
                  .replace(/\r/g, '')
                var idx
                while ((idx = buffer.indexOf('\n\n')) !== -1) {
                  var frame = buffer.slice(0, idx)
                  buffer = buffer.slice(idx + 2)
                  if (!frame.trim()) continue
                  var parsed = parseFrame(frame)
                  if (!parsed) continue
                  if (parsed.event === 'meta') {
                    saveSession(parsed.data.session_id)
                  } else if (parsed.event === 'delta') {
                    appendDelta(parsed.data.text)
                  } else if (parsed.event === 'recommendation') {
                    attachProduct(parsed.data)
                  } else if (parsed.event === 'error') {
                    throw new Error(parsed.data.message || 'stream error')
                  }
                }
                if (r.done) return
                return pump()
              })
            }
            return pump()
          })
          .then(function () {
            finish(false)
          })
          .catch(function (err) {
            console.error('Schummi chat request failed:', err)
            finish(true)
          })
      }

      /* Starters */
      STARTERS.forEach(function (s) {
        var btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'sca-starter'
        var ic = document.createElement('span')
        ic.className = 'sca-starter__ic'
        var glyph = makeIcon(s.icon)
        if (glyph) {
          glyph.setAttribute('aria-hidden', 'true')
          ic.appendChild(glyph)
        }
        var tx = document.createElement('span')
        tx.className = 'sca-starter__tx'
        tx.textContent = s.label
        btn.appendChild(ic)
        btn.appendChild(tx)
        btn.addEventListener('click', function () {
          send_(s.text)
        })
        starterGrid.appendChild(btn)
      })

      /* Composer behaviour */
      function grow() {
        input.style.height = 'auto'
        input.style.height = Math.min(input.scrollHeight, 160) + 'px'
      }
      function syncSend() {
        send.disabled = inFlight || input.value.trim() === ''
      }

      input.addEventListener('input', function () {
        grow()
        syncSend()
      })
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault()
          submit()
        }
      })
      function submit() {
        var v = input.value
        if (!v.trim()) return
        send_(v)
        input.value = ''
        grow()
        syncSend()
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault()
        submit()
      })

      /* History is restored from localStorage only (loaded into `messages`
         above); the stored session_id is still sent to /api/chat so the backend
         keeps its own server-side conversation memory for the thread. */
      render()

      /* `?q=` seeds the composer. The navbar's no-match state links here with
         whatever was searched (see assets/header-search.js), so the customer
         arrives with the question already typed. It is PREFILLED, not sent:
         they get to edit or expand it, and a reload can't fire a duplicate
         request off a URL that still carries the param. */
      try {
        var seeded = new URLSearchParams(window.location.search).get('q')
        if (seeded && !input.value.trim()) {
          input.value = seeded.slice(0, 300)
          grow()
          syncSend()
          input.focus()
        }
      } catch (e) {}
    }

    function initAll() {
      var roots = document.querySelectorAll('.sca-root')
      for (var i = 0; i < roots.length; i++) initRoot(roots[i])
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll)
    } else {
      initAll()
    }
    /* Theme editor: re-init when the section is re-rendered */
    document.addEventListener('shopify:section:load', initAll)
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spinning-bar"] && !Shopify.designMode) return;
  try {
    
  const barContainer = document.querySelector('.bar-container')
  const group = barContainer.querySelector('.bar-group')

  function updateBar() {
    const barStyle = window.getComputedStyle(group).width
    barContainer.style.setProperty('--dist', barStyle)
  }

  updateBar()
  new ResizeObserver(updateBar).observe(group)
  document.fonts && document.fonts.ready.then(updateBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-page-contact"] && !Shopify.designMode) return;
  try {
    
  const contactForm = document.getElementById('contact_form')
  contactForm.addEventListener('submit', function (e) {
    e.preventDefault()
    const formData = new FormData(contactForm)
     fetch(window.Shopify.routes.root + 'apps/api/forms', {
       method: 'POST',
       body: formData,
     })
       .then((response) => {
         return response.json()
       })
       .then((response) => {
         console.log('[Support Contact] Form response:', response)
         if (response.success) {
           Toastify({
             text: 'Your message has been sent successfully!',
             duration: 3000,
             newWindow: true,
             close: false,
             gravity: 'bottom', // `top` or `bottom`
             position: 'left', // `left`, `center` or `right`
             stopOnFocus: true, // Prevents dismissing of toast on hover
             style: {
               background: 'white',
               color: 'black',
               borderRadius: '8px',
             },
             onClick: function () {}, // Callback after click
           }).showToast()
         } else {
           throw new Error(response.error || 'An error occurred')
         }
       })
       .catch((error) => {
         console.error('[Support Contact] Error:', error)
         Toastify({
           text: 'There was an error sending your message.',
           duration: 3000,
           newWindow: true,
           close: false,
           gravity: 'bottom', // `top` or `bottom`
           position: 'left', // `left`, `center` or `right`
           stopOnFocus: true, // Prevents dismissing of toast on hover
           style: {
             background: 'white',
             color: 'black',
             borderRadius: '8px',
           },
           onClick: function () {}, // Callback after click
         }).showToast()
       })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-page"] && !Shopify.designMode) return;
  try {
    
    // Drilldown navigation for nested link lists
    document.addEventListener('DOMContentLoaded', function () {
      const cardsContainer = document.getElementById('support-cards')
      const linkData = JSON.parse(document.getElementById('support-link-data').textContent)
      let stack = []
      const defaultLinks = linkData
      function addIconToLinks(id) {
        const deviceSvg =
          '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" fill="none"><path fill="#000" d="m22.119 6.563.18.009c.059.001.117.002.175-.002.506-.03 1.006.044 1.482.113l.234.034c.44.061.901.16 1.45.311.43.119.894.253 1.344.421.63.236 1.248.518 1.838.838.84.457 1.577.945 2.252 1.493a14.729 14.729 0 0 1 1.654 1.572c.422.47.838 1.015 1.271 1.666.634.953 1.147 1.991 1.566 3.172a13.93 13.93 0 0 1 .755 3.585c.083 1.076.056 2.038-.085 2.938-.083.535-.205 1.24-.4 1.932-.178.63-.4 1.248-.677 1.889a13.55 13.55 0 0 1-1.545 2.677c-.487.659-.989 1.239-1.533 1.773a14.507 14.507 0 0 1-4.312 2.895c-.844.373-1.708.657-2.57.844-1.07.232-2.033.345-2.943.346-.508 0-.958-.012-1.376-.04-.77-.049-1.556-.18-2.404-.402a14.654 14.654 0 0 1-1.926-.648c-.982-.41-1.93-.94-2.817-1.575a13.821 13.821 0 0 1-2.058-1.82 13.315 13.315 0 0 1-1.498-1.936c-.36-.568-.683-1.16-.96-1.76a14.077 14.077 0 0 1-1.018-3.19c-.127-.643-.201-1.335-.227-2.114-.025-.761.03-1.506.082-2.067a13.14 13.14 0 0 1 .305-1.75c.181-.782.435-1.555.756-2.296.342-.793.771-1.57 1.275-2.31a14.467 14.467 0 0 1 2.277-2.582c.534-.485 1.126-.898 1.579-1.202a12.614 12.614 0 0 1 2.2-1.176 14.2 14.2 0 0 1 3.806-1.005 12.71 12.71 0 0 1 1.798-.101l.06.002c.507.012 1.039.025 1.562.108.103.017.206.032.31.048.342.052.7.106 1.045.186l.338.083c.344.089.707.2 1.12.339a13.89 13.89 0 0 1 6.734 5.001c.47.65.892 1.369 1.255 2.136.267.566.502 1.164.7 1.783l.084.266.077.271c.176.642.307 1.337.402 2.115.048.399.071.827.07 1.31-.001.466-.028.956-.085 1.542-.056.577-.16 1.176-.325 1.884-.096.406-.226.833-.399 1.304a13.903 13.903 0 0 1-.93 2.045c-.34.605-.752 1.213-1.223 1.806a13.246 13.246 0 0 1-1.822 1.886 13.51 13.51 0 0 1-1.6 1.176c-.453.28-.948.576-1.473.822-.717.335-1.471.61-2.305.84-1.1.304-2.236.469-3.378.49a13.203 13.203 0 0 1-2.373-.159 14.3 14.3 0 0 1-2.916-.791 13.465 13.465 0 0 1-2.624-1.39 12.332 12.332 0 0 1-1.53-1.218 14.466 14.466 0 0 1-1.541-1.689 13.006 13.006 0 0 1-1.197-1.844 12.734 12.734 0 0 1-1.116-2.824c-.17-.66-.296-1.222-.358-1.81a11.35 11.35 0 0 0-.034-.282c-.023-.182-.048-.375-.055-.565a19.3 19.3 0 0 1-.01-1.258c.024-.759.096-1.456.22-2.13.096-.523.215-1.002.364-1.463.2-.614.41-1.165.642-1.684a13.145 13.145 0 0 1 2.04-3.183 12.404 12.404 0 0 1 1.792-1.708 14.747 14.747 0 0 1 2.032-1.329c.45-.242.928-.46 1.463-.666a13.545 13.545 0 0 1 2.338-.674c.35-.067.67-.125 1-.16a12.31 12.31 0 0 1 1.094-.071l.152-.003c.404-.007.826-.016 1.242.017h.01l.01.002c.82.067 1.572.188 2.3.369.721.18 1.414.413 2.06.692a13.462 13.462 0 0 1 4.706 3.413 12.738 12.738 0 0 1 1.79 2.613c.433.844.752 1.643.973 2.441.134.486.283 1.068.364 1.674.056.427.092.854.12 1.215.032.433.039.867.019 1.287-.044.941-.182 1.871-.41 2.763-.177.69-.397 1.338-.654 1.926a13.005 13.005 0 0 1-1.41 2.475 13.314 13.314 0 0 1-3.192 3.12c-.664.446-1.24.78-1.812 1.054-.866.413-1.75.73-2.63.938-.974.232-1.948.359-2.894.377-.425.008-.986.01-1.541-.052-.849-.094-1.544-.224-2.188-.41a14.164 14.164 0 0 1-2.057-.756 13.17 13.17 0 0 1-2.105-1.246 12.548 12.548 0 0 1-3.916-4.561c-.355-.696-.642-1.401-.85-2.096-.333-1.118-.506-2.146-.529-3.143l-.003-.132c-.012-.482-.024-.986.025-1.484l.005-.054c.042-.423.085-.865.162-1.298a12.381 12.381 0 0 1 .921-3.033c.29-.636.607-1.22.97-1.784.35-.544.75-1.066 1.19-1.551l.224-.243c.516-.549.995-.982 1.489-1.349.484-.36.897-.637 1.3-.873a13.029 13.029 0 0 1 3.782-1.495c.56-.121 1.121-.207 1.717-.262.623-.058 1.247-.05 1.88-.037.283.006.56.043.824.078.476.064.988.141 1.484.27.693.18 1.364.41 1.994.682.862.372 1.705.853 2.507 1.429.65.467 1.26 1.012 1.862 1.664a12.33 12.33 0 0 1 1.858 2.636 13.446 13.446 0 0 1 1.169 3.203l.058.27.045.232c.1.546.156 1.123.173 1.755.013.453.021.865-.01 1.282a13.164 13.164 0 0 1-.625 3.194 12.578 12.578 0 0 1-.773 1.81c-.26.496-.547.968-.85 1.403-.56.8-1.198 1.52-1.896 2.136a13.09 13.09 0 0 1-2.482 1.744c-.93.5-1.945.892-3.015 1.165a12.71 12.71 0 0 1-2.063.332c-.536.046-1.058.054-1.552.023a13.655 13.655 0 0 1-1.986-.243l-.302-.07a12.767 12.767 0 0 1-1.202-.342 12.996 12.996 0 0 1-2.03-.914 12.727 12.727 0 0 1-2.983-2.32 14.158 14.158 0 0 1-.901-1.08 9.78 9.78 0 0 1-.779-1.17 12.427 12.427 0 0 1-.96-2.095 12.934 12.934 0 0 1-.425-1.484 11.517 11.517 0 0 1-.27-2.944c.037-.809.107-1.769.342-2.724.1-.405.232-.84.416-1.367.227-.647.536-1.303.918-1.951.28-.473.6-.942.983-1.435a11.889 11.889 0 0 1 3.764-3.163c.615-.33 1.175-.58 1.71-.764 1.05-.36 2.026-.573 2.982-.652.723-.06 1.391-.072 2.043-.037.765.042 1.511.201 2.072.334.768.183 1.52.444 2.236.778.921.429 1.782.966 2.557 1.597.551.449 1.06.935 1.514 1.446.478.537.909 1.13 1.318 1.814a11.984 11.984 0 0 1 1.644 4.993c.065.71.077 1.367.035 2.008-.032.483-.097.965-.192 1.43a13.32 13.32 0 0 1-.265 1.113c-.136.46-.313.94-.539 1.47a11.747 11.747 0 0 1-2.866 4.017 11.834 11.834 0 0 1-2.436 1.74c-.84.45-1.637.777-2.436.999a13.93 13.93 0 0 1-1.905.383 11.952 11.952 0 0 1-7.048-1.261 11.643 11.643 0 0 1-3.108-2.366 12.799 12.799 0 0 1-.888-1.06c-.33-.44-.633-.91-.898-1.395-.237-.436-.454-.92-.662-1.48a12.095 12.095 0 0 1-.65-2.644 11.094 11.094 0 0 1-.086-1.968c.043-.901.15-1.69.327-2.41.175-.712.4-1.38.688-2.042a11.747 11.747 0 0 1 2.332-3.453 11.273 11.273 0 0 1 1.86-1.54 11.845 11.845 0 0 1 2.827-1.38 10.348 10.348 0 0 1 1.612-.414c.482-.077 1.06-.159 1.659-.17.431-.01.862-.001 1.264.008.317.007.632.06.93.11.098.018.2.035.298.05.446.068.88.167 1.29.294 1.09.337 2.033.763 2.88 1.302a11.73 11.73 0 0 1 3.505 3.382 11.639 11.639 0 0 1 1.867 4.952c.077.581.11 1.068.105 1.53-.004.457-.009.934-.09 1.404l-.05.308c-.043.263-.087.539-.148.806-.096.417-.213.821-.348 1.201a11.75 11.75 0 0 1-1.818 3.322c-.44.57-.941 1.1-1.488 1.575a11.713 11.713 0 0 1-4.72 2.501c-.868.234-1.775.361-2.77.39-.471.014-.928-.021-1.31-.057h-.007a10.13 10.13 0 0 1-1.833-.327 12.493 12.493 0 0 1-1.459-.499 11.206 11.206 0 0 1-3.737-2.553 11.165 11.165 0 0 1-2.375-3.717c-.21-.522-.378-1.11-.53-1.849a10.075 10.075 0 0 1-.207-1.892 12.98 12.98 0 0 1 .162-2.317c.14-.847.377-1.69.702-2.504.233-.583.53-1.157.908-1.755.252-.398.56-.806.97-1.28a10.85 10.85 0 0 1 2.185-1.938 10.7 10.7 0 0 1 2.403-1.225c.611-.216 1.13-.364 1.633-.466a11.263 11.263 0 0 1 3.257-.18c.384.029.78.085 1.21.174a11.277 11.277 0 0 1 4.035 1.677 11.365 11.365 0 0 1 2.034 1.753c.447.485.863 1.04 1.237 1.65a11.058 11.058 0 0 1 1.455 3.802c.142.782.2 1.508.177 2.221-.02.607-.072 1.14-.163 1.63-.065.35-.143.758-.257 1.15-.219.751-.521 1.484-.897 2.178a10.609 10.609 0 0 1-1.351 1.937c-.702.8-1.475 1.475-2.298 2.007a10.5 10.5 0 0 1-2.043 1.044 11.76 11.76 0 0 1-2.89.692c-.532.057-1.094.072-1.822.048a9.535 9.535 0 0 1-2.076-.32 10.644 10.644 0 0 1-2.232-.846l-.296-.159a10.476 10.476 0 0 1-2.216-1.635c-.483-.47-.912-.965-1.312-1.514a10.355 10.355 0 0 1-1.283-2.389A10.11 10.11 0 0 1 11.235 21v-.136c0-.692.086-1.406.27-2.243.154-.7.38-1.389.675-2.047.387-.869.903-1.696 1.533-2.457a10.47 10.47 0 0 1 2.073-1.898c.69-.482 1.42-.874 2.17-1.164a11.055 11.055 0 0 1 4.45-.744c.99.038 1.991.226 2.974.56 1.018.345 1.971.84 2.831 1.473a10.614 10.614 0 0 1 4.097 6.304c.183.843.262 1.677.233 2.478-.037 1.022-.18 1.925-.434 2.762a10.477 10.477 0 0 1-1.062 2.381c-.342.565-.75 1.11-1.214 1.623a10.078 10.078 0 0 1-1.87 1.611c-.463.31-.994.598-1.621.879-.642.286-1.316.508-2.002.659a9.543 9.543 0 0 1-2.02.223c-.802.002-1.532-.06-2.23-.19-.538-.1-1.07-.248-1.628-.449a9.716 9.716 0 0 1-2.128-1.075 10.607 10.607 0 0 1-1.454-1.166l-.182-.18a10.514 10.514 0 0 1-1.504-1.913 9.782 9.782 0 0 1-1.01-2.24 10.696 10.696 0 0 1-.424-2.177 12.67 12.67 0 0 1-.014-1.696c.008-.174.034-.351.059-.518l.026-.19c.044-.334.114-.685.213-1.07.123-.48.296-.976.512-1.476.41-.95.957-1.82 1.623-2.589a9.752 9.752 0 0 1 1.942-1.724 11.498 11.498 0 0 1 1.745-.96 9.81 9.81 0 0 1 3.386-.806c.609-.037 1.269-.054 1.921.065l.34.06c.32.055.654.113.98.195.78.199 1.536.498 2.25.89a10.307 10.307 0 0 1 2.28 1.708 10.065 10.065 0 0 1 1.764 2.355 9.924 9.924 0 0 1 1.177 5.064 9.758 9.758 0 0 1-.365 2.373 9.898 9.898 0 0 1-.711 1.834 9.651 9.651 0 0 1-1.328 1.943c-.73.824-1.498 1.47-2.347 1.973-.892.53-1.766.898-2.669 1.125-.612.154-1.222.252-1.865.298a9.832 9.832 0 0 1-3.302-.33 10.178 10.178 0 0 1-2.25-.944c-.494-.282-.98-.619-1.446-1.001-.34-.28-.68-.611-1.035-1.01-.197-.223-.376-.461-.57-.724a9.439 9.439 0 0 1-1.043-1.838 9.096 9.096 0 0 1-.66-2.293 9.157 9.157 0 0 1-.124-1.354c0-.524.037-1.066.108-1.612.063-.477.168-.972.313-1.47.179-.617.452-1.189.695-1.662.402-.785.948-1.532 1.668-2.286a8.976 8.976 0 0 1 1.672-1.346 9.114 9.114 0 0 1 1.497-.774c.56-.226 1.141-.403 1.727-.525a9.153 9.153 0 0 1 2.497-.184c.373.025.716.06 1.048.109a8.772 8.772 0 0 1 1.622.403 9.055 9.055 0 0 1 2.08 1.041 9.624 9.624 0 0 1 2.703 2.726 9.5 9.5 0 0 1 1.32 3.13c.14.628.21 1.29.214 2.024a9.46 9.46 0 0 1-.231 2.077 8.96 8.96 0 0 1-.623 1.81 9.38 9.38 0 0 1-1.41 2.186 9.599 9.599 0 0 1-2.438 2.025 9.805 9.805 0 0 1-2.5 1.02 8.741 8.741 0 0 1-2.335.273c-.457-.008-.995-.025-1.521-.13a10.49 10.49 0 0 1-1.665-.45 9.068 9.068 0 0 1-2.861-1.718 9.147 9.147 0 0 1-2.67-4.184c-.283-.916-.405-1.887-.376-2.968a9.045 9.045 0 0 1 .286-2.031 9.2 9.2 0 0 1 .78-2.026 8.76 8.76 0 0 1 .945-1.422 9.262 9.262 0 0 1 1.806-1.695 8.915 8.915 0 0 1 1.993-1.07 9.148 9.148 0 0 1 2.215-.544c.5-.057 1.009-.078 1.515-.062a8.01 8.01 0 0 1 1.675.238c.57.14 1.08.312 1.56.526.361.162.734.364 1.172.634a8.602 8.602 0 0 1 2.556 2.438 8.743 8.743 0 0 1 1.425 3.402c.143.763.19 1.501.142 2.256-.023.367-.078.76-.168 1.199-.056.276-.129.604-.237.92a9.164 9.164 0 0 1-1.115 2.256 8.79 8.79 0 0 1-1.226 1.438 8.554 8.554 0 0 1-2.401 1.617 9.975 9.975 0 0 1-1.462.538 8.854 8.854 0 0 1-2.48.297 8.465 8.465 0 0 1-2.24-.337 8.74 8.74 0 0 1-2.519-1.197 8.51 8.51 0 0 1-3.382-4.755 8.236 8.236 0 0 1-.305-1.912 9.234 9.234 0 0 1 .079-1.675c.096-.662.235-1.24.423-1.768a8.212 8.212 0 0 1 .983-1.907 9.38 9.38 0 0 1 1.165-1.356 8 8 0 0 1 1.905-1.37 8.348 8.348 0 0 1 3.09-.922 8.834 8.834 0 0 1 2.652.142c.865.182 1.7.5 2.482.945A8.363 8.363 0 0 1 29.1 16.47a8.26 8.26 0 0 1 1.023 2.543 8.61 8.61 0 0 1 .2 1.79c.004.409-.028.821-.094 1.226a8.93 8.93 0 0 1-.303 1.311 8.31 8.31 0 0 1-1.021 2.1 8.176 8.176 0 0 1-1.434 1.624 8.33 8.33 0 0 1-1.865 1.224 8.28 8.28 0 0 1-1.59.578 9.108 9.108 0 0 1-2.223.253 7.857 7.857 0 0 1-1.75-.212 7.675 7.675 0 0 1-2.107-.833 8.407 8.407 0 0 1-1.413-1.004l-.168-.155a7.925 7.925 0 0 1-.97-1.104 8.515 8.515 0 0 1-.966-1.743 7.815 7.815 0 0 1-.431-1.472 7.888 7.888 0 0 1-.148-1.289c-.014-.512.04-1.028.09-1.52l.008-.076c.027-.261.08-.53.156-.8.129-.455.297-.995.56-1.516.287-.568.589-1.05.924-1.475a7.963 7.963 0 0 1 3.927-2.65 8.321 8.321 0 0 1 2.742-.313c.339.015.702.061 1.107.142.85.169 1.663.471 2.417.898a7.968 7.968 0 0 1 2.373 2.063c.43.555.774 1.143 1.018 1.748.23.572.391 1.13.493 1.704.113.636.146 1.255.1 1.894a7.966 7.966 0 0 1-.276 1.57 7.38 7.38 0 0 1-.859 1.949 7.606 7.606 0 0 1-1.743 1.948 7.949 7.949 0 0 1-2.362 1.285 7.93 7.93 0 0 1-2.477.412c-.657.01-1.3-.069-1.966-.24a7.422 7.422 0 0 1-1.81-.725 7.683 7.683 0 0 1-1.784-1.386 7.424 7.424 0 0 1-1.618-2.576 7.364 7.364 0 0 1-.459-2.238l-.005-.317c.004-.693.07-1.315.202-1.9a7.28 7.28 0 0 1 .398-1.223 6.996 6.996 0 0 1 1.49-2.243 7.443 7.443 0 0 1 2.625-1.727 7.108 7.108 0 0 1 2.244-.486 7.697 7.697 0 0 1 2.325.23c.756.2 1.424.482 2.04.864 1.379.853 2.382 2.04 2.978 3.524.488 1.214.64 2.471.45 3.735-.08.538-.18.967-.314 1.348a7.164 7.164 0 0 1-1.22 2.16 7.087 7.087 0 0 1-1.945 1.654 7.084 7.084 0 0 1-2.599.91 7.886 7.886 0 0 1-2.007.014 6.712 6.712 0 0 1-1.87-.503 7.023 7.023 0 0 1-3.694-3.665 6.945 6.945 0 0 1-.449-4.18c.095-.44.209-.83.349-1.19a6.752 6.752 0 0 1 1.692-2.498 7.03 7.03 0 0 1 2.296-1.434c.838-.322 1.725-.476 2.71-.468.426.003.881.067 1.432.199.709.17 1.362.44 1.941.802.865.54 1.542 1.188 2.068 1.979.452.68.766 1.39.957 2.167.112.455.171.947.192 1.591.017.514-.063 1.007-.187 1.58a5.635 5.635 0 0 1-.45 1.255 6.934 6.934 0 0 1-1.52 2.062 6.86 6.86 0 0 1-2.778 1.57 6.569 6.569 0 0 1-2.05.256 6.244 6.244 0 0 1-1.68-.264 6.51 6.51 0 0 1-2.329-1.256 6.42 6.42 0 0 1-1.687-2.216 6.139 6.139 0 0 1-.566-2.788c.018-.644.081-1.134.208-1.585a6.57 6.57 0 0 1 .78-1.789c.48-.75 1.033-1.34 1.69-1.802.872-.614 1.784-.988 2.787-1.141a6.42 6.42 0 0 1 2.473.082c.72.168 1.396.458 2.01.861a6.01 6.01 0 0 1 1.76 1.778c.949 1.472 1.23 3.092.833 4.81a5.822 5.822 0 0 1-.883 1.994 6.551 6.551 0 0 1-2.745 2.274c-.68.299-1.423.47-2.205.506a6.055 6.055 0 0 1-3.022-.65 5.69 5.69 0 0 1-1.985-1.683 5.617 5.617 0 0 1-.896-1.76 6.247 6.247 0 0 1-.253-1.664c-.01-.5.042-1.01.16-1.52a5.64 5.64 0 0 1 .806-1.902c.36-.54.755-.983 1.21-1.352.45-.365.958-.657 1.552-.892a5.932 5.932 0 0 1 2.3-.41c.43.008.852.065 1.258.169a5.776 5.776 0 0 1 1.94.893 5.555 5.555 0 0 1 1.817 2.152c.261.55.427 1.082.506 1.623.036.25.047.503.058.743.005.12.01.242.019.36a.12.12 0 0 1-.11.128h-.002a.12.12 0 0 1-.127-.112c-.008-.122-.013-.246-.019-.365a7.293 7.293 0 0 0-.056-.72 5.42 5.42 0 0 0-.484-1.556 5.318 5.318 0 0 0-1.742-2.06 5.542 5.542 0 0 0-1.86-.856 5.235 5.235 0 0 0-1.202-.162 5.692 5.692 0 0 0-2.21.394 5.558 5.558 0 0 0-1.489.856 5.759 5.759 0 0 0-1.162 1.298 5.408 5.408 0 0 0-.772 1.825 6.07 6.07 0 0 0 .036 2.87l.054.192.071.22c.178.512.442 1.004.787 1.465a5.452 5.452 0 0 0 1.902 1.613c.446.227.903.39 1.4.497a5.935 5.935 0 0 0 3.624-.358 6.317 6.317 0 0 0 2.644-2.192c.405-.588.69-1.232.847-1.913.383-1.654.113-3.21-.801-4.627a5.77 5.77 0 0 0-1.69-1.708 5.998 5.998 0 0 0-1.934-.828 6.181 6.181 0 0 0-2.382-.08c-.965.148-1.843.508-2.686 1.101-.63.444-1.162 1.01-1.626 1.736a6.335 6.335 0 0 0-.752 1.726c-.12.427-.182.897-.2 1.526a5.9 5.9 0 0 0 .544 2.682 6.185 6.185 0 0 0 3.871 3.345 6.017 6.017 0 0 0 1.617.253 6.331 6.331 0 0 0 1.976-.246 6.622 6.622 0 0 0 2.681-1.516 6.701 6.701 0 0 0 1.47-1.992c.212-.443.353-.835.431-1.2.122-.566.198-1.037.182-1.523-.02-.631-.079-1.106-.186-1.542a6.552 6.552 0 0 0-.924-2.093c-.505-.76-1.158-1.385-1.995-1.908a6.281 6.281 0 0 0-1.87-.772c-.538-.13-.975-.19-1.379-.192-.957-.008-1.815.14-2.623.451a6.8 6.8 0 0 0-2.219 1.386 6.516 6.516 0 0 0-1.633 2.41 7.498 7.498 0 0 0-.338 1.153c-.12.56-.16 1.13-.122 1.744.049.789.235 1.56.556 2.292a6.78 6.78 0 0 0 3.569 3.54 6.465 6.465 0 0 0 1.805.487 7.643 7.643 0 0 0 1.947-.014 6.845 6.845 0 0 0 2.513-.88 6.843 6.843 0 0 0 1.88-1.6 6.926 6.926 0 0 0 1.178-2.087 6.98 6.98 0 0 0 .304-1.304 6.845 6.845 0 0 0-.435-3.61c-.577-1.437-1.547-2.584-2.883-3.411a7.168 7.168 0 0 0-1.976-.836 7.447 7.447 0 0 0-2.254-.223 6.868 6.868 0 0 0-2.169.47 7.203 7.203 0 0 0-2.54 1.673 6.693 6.693 0 0 0-1.304 1.86l-.137.308c-.17.403-.295.79-.384 1.183a8.549 8.549 0 0 0-.197 1.85c-.005.814.141 1.623.45 2.471.329.905.856 1.744 1.567 2.493a7.44 7.44 0 0 0 1.728 1.343c.534.303 1.124.54 1.753.702a7.088 7.088 0 0 0 1.903.232 7.694 7.694 0 0 0 2.403-.399c.83-.283 1.6-.702 2.29-1.247a7.371 7.371 0 0 0 1.69-1.888 7.15 7.15 0 0 0 .83-1.886 7.739 7.739 0 0 0 .27-1.523 7.398 7.398 0 0 0-.098-1.836 8.232 8.232 0 0 0-.48-1.656 7.093 7.093 0 0 0-.983-1.69 7.738 7.738 0 0 0-4.65-2.874 7.111 7.111 0 0 0-1.07-.139 8.084 8.084 0 0 0-2.664.304 7.447 7.447 0 0 0-1.977.913 7.73 7.73 0 0 0-1.831 1.656c-.324.41-.619.88-.9 1.435-.252.501-.416 1.025-.543 1.474a4.479 4.479 0 0 0-.147.76l-.008.075c-.051.493-.103.996-.09 1.49.012.396.06.817.145 1.25.102.526.239.993.416 1.427a8.27 8.27 0 0 0 .94 1.695c.264.368.572.718.941 1.07.422.404.924.772 1.535 1.125a7.436 7.436 0 0 0 2.043.807 7.626 7.626 0 0 0 1.697.207 8.861 8.861 0 0 0 2.166-.247 8.041 8.041 0 0 0 1.544-.561c.634-.301 1.244-.701 1.81-1.19a7.943 7.943 0 0 0 1.393-1.578 8.072 8.072 0 0 0 .991-2.039c.118-.365.212-.77.295-1.276.064-.391.095-.79.09-1.184a8.379 8.379 0 0 0-.193-1.742 8.028 8.028 0 0 0-.993-2.469 8.126 8.126 0 0 0-2.92-2.842 8.346 8.346 0 0 0-2.413-.92 8.598 8.598 0 0 0-2.58-.138 8.11 8.11 0 0 0-3.003.895 7.762 7.762 0 0 0-1.848 1.33c-.467.459-.84.89-1.137 1.322a7.973 7.973 0 0 0-.955 1.85 8.918 8.918 0 0 0-.411 1.723 9.007 9.007 0 0 0-.077 1.632 8.38 8.38 0 0 0 1.181 3.922 8.27 8.27 0 0 0 2.404 2.558c.73.508 1.555.9 2.45 1.166a8.238 8.238 0 0 0 2.178.327 8.622 8.622 0 0 0 2.413-.29c.427-.115.88-.282 1.428-.526a8.316 8.316 0 0 0 2.334-1.573c.437-.41.838-.88 1.194-1.399a8.933 8.933 0 0 0 1.085-2.197 7.32 7.32 0 0 0 .23-.892 8.47 8.47 0 0 0 .162-1.166l.014-.275c.02-.64-.03-1.27-.151-1.921a8.51 8.51 0 0 0-1.387-3.311 8.36 8.36 0 0 0-2.485-2.371 9.801 9.801 0 0 0-1.146-.619 8.466 8.466 0 0 0-1.112-.404l-.406-.109a7.784 7.784 0 0 0-1.627-.231c-.494-.016-.992.004-1.48.06a8.91 8.91 0 0 0-2.157.53c-.662.25-1.315.6-1.94 1.042a9.024 9.024 0 0 0-1.759 1.651c-.34.415-.65.88-.92 1.385a8.957 8.957 0 0 0-.759 1.973 8.792 8.792 0 0 0-.28 1.977c-.028 1.057.093 2.003.368 2.892a8.913 8.913 0 0 0 2.6 4.077 8.83 8.83 0 0 0 2.787 1.673c.459.17.96.306 1.627.439.505.1 1.025.117 1.479.125a8.503 8.503 0 0 0 2.27-.266 9.571 9.571 0 0 0 2.441-.995 9.366 9.366 0 0 0 2.378-1.974 9.137 9.137 0 0 0 1.98-3.892 9.222 9.222 0 0 0 .226-2.024 9.174 9.174 0 0 0-.208-1.973 9.255 9.255 0 0 0-1.288-3.052 9.391 9.391 0 0 0-2.635-2.659 8.813 8.813 0 0 0-2.026-1.014 8.522 8.522 0 0 0-1.578-.393 13.7 13.7 0 0 0-1.03-.107 8.928 8.928 0 0 0-2.432.18c-.572.12-1.14.292-1.686.513-.38.154-.752.335-1.108.54l-.35.214c-.656.42-1.188.848-1.629 1.31-.706.738-1.239 1.468-1.629 2.23-.24.468-.506 1.023-.679 1.619-.14.487-.243.97-.304 1.435a12.21 12.21 0 0 0-.106 1.582c0 .454.058.9.12 1.317.119.78.335 1.53.644 2.234a9.21 9.21 0 0 0 1.016 1.791c.194.262.366.493.556.707.349.391.68.713 1.01.985.454.374.93.704 1.412.979.685.39 1.425.7 2.197.92a9.58 9.58 0 0 0 3.22.321 10.45 10.45 0 0 0 1.824-.29c.879-.221 1.73-.58 2.605-1.098.826-.49 1.575-1.12 2.29-1.927a9.415 9.415 0 0 0 1.295-1.896 9.635 9.635 0 0 0 .693-1.79 9.526 9.526 0 0 0 .356-2.313 9.68 9.68 0 0 0-1.148-4.943 9.82 9.82 0 0 0-1.721-2.299 10.08 10.08 0 0 0-2.228-1.67 9.336 9.336 0 0 0-2.194-.867 12.78 12.78 0 0 0-.961-.192l-.342-.06c-.625-.114-1.262-.098-1.864-.062h-.001a9.568 9.568 0 0 0-3.304.787c-.59.26-1.165.576-1.709.94a9.508 9.508 0 0 0-1.895 1.682c-.65.75-1.183 1.6-1.584 2.528a9.8 9.8 0 0 0-.5 1.44 8.773 8.773 0 0 0-.234 1.236c-.024.167-.049.334-.057.495-.022.457-.04 1.057.014 1.664.063.72.203 1.437.414 2.129.23.754.562 1.49.987 2.185a10.29 10.29 0 0 0 3.07 3.186A9.463 9.463 0 0 0 18.54 30.4c.546.197 1.066.34 1.59.438.682.127 1.397.188 2.186.186a9.312 9.312 0 0 0 1.97-.217 10.15 10.15 0 0 0 1.955-.645 10.582 10.582 0 0 0 1.586-.858 9.846 9.846 0 0 0 1.825-1.573c.454-.502.853-1.036 1.188-1.587.437-.72.787-1.504 1.037-2.327.248-.814.387-1.697.424-2.7v-.001a9.715 9.715 0 0 0-.228-2.42 10.375 10.375 0 0 0-4.005-6.162 10.202 10.202 0 0 0-2.766-1.44 10.268 10.268 0 0 0-4.403-.503 10.82 10.82 0 0 0-2.858.685c-.732.283-1.446.665-2.12 1.137a10.247 10.247 0 0 0-2.026 1.854 10.456 10.456 0 0 0-1.5 2.402c-.287.644-.51 1.317-.66 2.002-.18.823-.264 1.52-.264 2.192V21c0 .245 0 .495.012.74.025.48.084.954.175 1.41.114.575.28 1.143.49 1.686.34.88.75 1.643 1.254 2.335.392.538.812 1.023 1.285 1.483a10.228 10.228 0 0 0 2.167 1.598c.76.426 1.591.756 2.471.983.733.189 1.395.29 2.024.311.72.024 1.271.01 1.789-.046.954-.102 1.88-.323 2.833-.678a10.26 10.26 0 0 0 1.995-1.021c.804-.52 1.561-1.18 2.25-1.964.506-.577.95-1.215 1.32-1.894.368-.679.663-1.396.877-2.13.11-.381.188-.78.252-1.127.088-.477.14-.998.16-1.594a10.143 10.143 0 0 0-.175-2.17c-.24-1.32-.72-2.57-1.423-3.72a10.406 10.406 0 0 0-1.208-1.614 11.142 11.142 0 0 0-1.993-1.716 11.033 11.033 0 0 0-3.95-1.642 9.037 9.037 0 0 0-1.18-.169c-.535-.038-.97-.05-1.369-.038-.61.02-1.223.092-1.822.213-.49.1-.999.245-1.602.458-.796.28-1.564.673-2.35 1.197a10.603 10.603 0 0 0-2.138 1.895c-.403.469-.704.867-.948 1.254-.37.586-.661 1.147-.888 1.716a11.82 11.82 0 0 0-.688 2.454 12.77 12.77 0 0 0-.16 2.275c.01.618.077 1.24.203 1.847.15.729.315 1.303.518 1.809a10.919 10.919 0 0 0 5.984 6.14c.508.216 1.03.374 1.431.488.527.15 1.113.254 1.79.318l.008.001.295.026c.306.024.642.04.984.03a11.611 11.611 0 0 0 2.716-.382 11.468 11.468 0 0 0 4.626-2.45 10.666 10.666 0 0 0 1.455-1.541 11.512 11.512 0 0 0 1.782-3.256c.132-.371.246-.767.34-1.174l.079-.394.066-.398.051-.31c.077-.448.083-.91.087-1.364a10.51 10.51 0 0 0-.104-1.498 11.36 11.36 0 0 0-1.828-4.851 11.505 11.505 0 0 0-3.435-3.314c-.827-.527-1.75-.944-2.823-1.275a8.8 8.8 0 0 0-1.255-.286 17.603 17.603 0 0 1-.303-.05 6.188 6.188 0 0 0-.894-.108 30.524 30.524 0 0 0-1.255-.008c-.583.011-1.148.09-1.625.167-.46.074-.96.202-1.576.406-.969.32-1.9.775-2.77 1.351-.667.443-1.28.95-1.82 1.508a11.498 11.498 0 0 0-2.284 3.383 12.355 12.355 0 0 0-.677 2.004 12.347 12.347 0 0 0-.32 2.364c-.026.546-.008 1.111.055 1.682l.03.244.048.336c.124.782.322 1.54.588 2.256a11.1 11.1 0 0 0 .65 1.45c.258.474.554.934.877 1.364.28.371.572.721.871 1.04a11.407 11.407 0 0 0 4.599 2.992 11.703 11.703 0 0 0 5.354.563 13.64 13.64 0 0 0 1.872-.378c.78-.217 1.562-.537 2.388-.979a11.598 11.598 0 0 0 2.386-1.704 11.51 11.51 0 0 0 2.809-3.936c.223-.522.396-.995.53-1.444.109-.37.19-.758.26-1.093.092-.455.155-.925.186-1.399.041-.627.03-1.27-.035-1.97a11.749 11.749 0 0 0-1.61-4.893 11.839 11.839 0 0 0-1.118-1.578l-.173-.2c-.445-.5-.945-.978-1.486-1.418a11.992 11.992 0 0 0-2.508-1.566 11.501 11.501 0 0 0-2.19-.762c-.556-.133-1.286-.29-2.03-.329a14.666 14.666 0 0 0-2.011.036c-.934.077-1.89.287-2.923.64-.522.179-1.07.424-1.676.748a11.652 11.652 0 0 0-3.688 3.099c-.377.487-.693.948-.966 1.41a10.793 10.793 0 0 0-.899 1.91 14.7 14.7 0 0 0-.41 1.346c-.23.932-.299 1.874-.335 2.678-.042.905.047 1.875.264 2.883.096.443.233.92.418 1.457.233.675.54 1.347.943 2.055.231.407.487.791.759 1.141.304.392.58.74.886 1.062a12.486 12.486 0 0 0 2.926 2.275c.605.341 1.257.635 1.995.898.38.136.784.237 1.18.335.784.196 1.572.265 2.244.307.481.03.991.022 1.517-.024a12.47 12.47 0 0 0 2.024-.325 13.065 13.065 0 0 0 2.962-1.144c.855-.46 1.652-1.02 2.436-1.713a11.833 11.833 0 0 0 1.858-2.093c.298-.426.579-.89.835-1.378a12.32 12.32 0 0 0 .759-1.775c.143-.424.264-.88.38-1.436.11-.523.186-1.08.233-1.7.03-.403.022-.806.01-1.257-.02-.71-.09-1.347-.214-1.946a13.171 13.171 0 0 0-1.205-3.41 12.098 12.098 0 0 0-1.822-2.585 12.072 12.072 0 0 0-1.826-1.633 13.158 13.158 0 0 0-2.462-1.403 13.694 13.694 0 0 0-1.96-.67c-.482-.126-.983-.201-1.455-.264a7.275 7.275 0 0 0-.797-.077c-.632-.014-1.245-.021-1.853.035a14.1 14.1 0 0 0-1.69.258c-.603.13-1.208.315-1.852.565a12.82 12.82 0 0 0-3.138 1.762c-.55.408-1.083.903-1.679 1.56-.431.476-.824.987-1.166 1.52a13.604 13.604 0 0 0-.953 1.755 12.177 12.177 0 0 0-.904 2.976c-.075.423-.117.857-.159 1.28l-.006.053c-.047.482-.036.974-.024 1.456l.003.131c.02.852.153 1.73.405 2.673l.116.408.08.256c.194.597.447 1.201.752 1.8a12.337 12.337 0 0 0 1.652 2.473c.67.77 1.408 1.444 2.19 2.002.722.514 1.399.914 2.068 1.224.623.288 1.285.532 2.023.745.628.18 1.31.307 2.147.4.54.06 1.09.06 1.511.051a13.453 13.453 0 0 0 2.844-.37c.861-.205 1.73-.516 2.582-.922.56-.268 1.126-.596 1.782-1.037a11.87 11.87 0 0 0 1.198-.937l.259-.234a13.255 13.255 0 0 0 1.675-1.891c.531-.725.996-1.543 1.384-2.43.25-.576.467-1.211.64-1.89.225-.876.36-1.79.404-2.715.02-.41.013-.834-.02-1.259-.027-.358-.062-.78-.118-1.2-.078-.59-.224-1.16-.357-1.642a12.493 12.493 0 0 0-.956-2.396 12.509 12.509 0 0 0-1.754-2.564 13.188 13.188 0 0 0-2.25-2.017l-.358-.246a13.058 13.058 0 0 0-2.015-1.09 13.072 13.072 0 0 0-2.024-.68 13.725 13.725 0 0 0-1.962-.335l-.3-.028c-.408-.034-.827-.025-1.237-.017l-.152.002a12.07 12.07 0 0 0-1.074.07c-.32.034-.632.092-.98.158-.754.142-1.527.365-2.297.66-.526.204-.996.418-1.436.655-.683.368-1.355.808-1.999 1.307a12.16 12.16 0 0 0-1.757 1.676 12.909 12.909 0 0 0-2.003 3.125c-.23.51-.437 1.053-.633 1.66-.147.45-.264.92-.358 1.434-.121.66-.192 1.345-.215 2.094-.014.425-.002.846.01 1.242.006.178.03.36.053.542.013.094.025.191.035.288l.025.213c.066.498.179.99.326 1.563.239.926.597 1.833 1.096 2.772.327.616.723 1.225 1.175 1.81.446.576.956 1.135 1.517 1.66.455.428.96.829 1.5 1.194a13.23 13.23 0 0 0 2.578 1.366c.91.356 1.874.618 2.866.778.74.12 1.503.17 2.33.156a13.393 13.393 0 0 0 3.32-.482 14.278 14.278 0 0 0 2.267-.826c.513-.24.998-.53 1.449-.809.504-.311 1.018-.689 1.572-1.155a12.993 12.993 0 0 0 1.788-1.853 13.53 13.53 0 0 0 1.202-1.774c.341-.607.64-1.264.914-2.01.17-.464.297-.881.39-1.277.163-.7.265-1.287.32-1.852.056-.58.083-1.064.084-1.521.002-.474-.021-.892-.068-1.28a14.509 14.509 0 0 0-.396-2.08l-.076-.266c-.21-.702-.47-1.38-.77-2.016a13.201 13.201 0 0 0-1.233-2.097 13.55 13.55 0 0 0-2.227-2.41 13.662 13.662 0 0 0-4.391-2.506 14.516 14.516 0 0 0-1.434-.416c-.336-.077-.686-.13-1.027-.182-.104-.016-.208-.031-.311-.048-.507-.08-1.024-.093-1.53-.106h-.062a12.479 12.479 0 0 0-1.764.098 13.958 13.958 0 0 0-3.743.988 12.38 12.38 0 0 0-2.159 1.154c-.45.301-1.03.708-1.551 1.18a14.22 14.22 0 0 0-2.24 2.541 13.684 13.684 0 0 0-1.253 2.27 13.194 13.194 0 0 0-.743 2.254 12.895 12.895 0 0 0-.3 1.719 16.63 16.63 0 0 0-.08 2.038c.025.767.097 1.447.221 2.077a13.83 13.83 0 0 0 1.947 4.867 13.593 13.593 0 0 0 3.494 3.69 14.069 14.069 0 0 0 2.77 1.55c.603.25 1.24.465 1.895.636a12.38 12.38 0 0 0 2.357.396c.412.027.858.04 1.361.039.892-.001 1.838-.112 2.893-.341a13.199 13.199 0 0 0 2.525-.829 14.257 14.257 0 0 0 4.24-2.847 14.565 14.565 0 0 0 1.509-1.745 13.32 13.32 0 0 0 1.518-2.63c.273-.632.492-1.24.667-1.86.19-.673.305-1.339.393-1.904.137-.88.164-1.822.082-2.882a13.691 13.691 0 0 0-.74-3.524 14.047 14.047 0 0 0-1.54-3.119 14.168 14.168 0 0 0-1.251-1.64 14.551 14.551 0 0 0-1.627-1.545 14.218 14.218 0 0 0-2.215-1.469 14.352 14.352 0 0 0-1.808-.824c-.44-.165-.895-.297-1.324-.415-.54-.148-.99-.245-1.42-.305l-.235-.034c-.474-.069-.954-.139-1.433-.11-.13.006-.26 0-.382-.007-.088-.005-.176-.01-.262-.01a15.3 15.3 0 0 0-1.643.104 13.898 13.898 0 0 0-3.202.766c-.645.232-1.312.538-2.042.934-.523.285-1.06.634-1.692 1.099a12.23 12.23 0 0 0-1.32 1.144c-.75.739-1.42 1.563-1.993 2.452-.385.596-.73 1.236-1.051 1.948l-.136.31c-.265.617-.462 1.269-.643 1.887-.18.618-.274 1.26-.35 1.868-.083.666-.115 1.36-.098 2.122.014.635.067 1.273.158 1.898.092.628.243 1.276.46 1.981a14.208 14.208 0 0 0 5.257 7.34c.646.471 1.266.855 1.896 1.173 1.104.557 2.255.97 3.42 1.228.283.063.47.202.568.441v.006l.183.02-.216.107a.115.115 0 0 1-.033.02v.002a.12.12 0 0 1-.056.009l-.288-.03.172-.085a.418.418 0 0 0-.121-.15.646.646 0 0 0-.257-.108 14.81 14.81 0 0 1-3.477-1.248 13.842 13.842 0 0 1-1.928-1.194 14.457 14.457 0 0 1-3.588-3.743 14.7 14.7 0 0 1-1.756-3.718 13.291 13.291 0 0 1-.468-2.017 15.733 15.733 0 0 1-.16-1.928c-.017-.772.015-1.477.1-2.156.076-.611.171-1.27.357-1.905.18-.62.381-1.283.652-1.914.364-.85.758-1.6 1.206-2.294a14.654 14.654 0 0 1 2.026-2.491 12.44 12.44 0 0 1 1.346-1.167 14.84 14.84 0 0 1 3.795-2.066 14.15 14.15 0 0 1 3.255-.779 15.553 15.553 0 0 1 1.67-.105c.093 0 .187.005.275.01Z"/><path fill="#000" d="M21.846 15.64a5.146 5.146 0 0 1 1.864.33 5.066 5.066 0 0 1 2.55 2.057c.606.94.876 1.986.8 3.106a5.126 5.126 0 0 1-.46 1.784c-.323.713-.799 1.319-1.454 1.85a4.88 4.88 0 0 1-1.564.838 5.135 5.135 0 0 1-2.334.22 4.637 4.637 0 0 1-1.402-.42 4.891 4.891 0 0 1-2.087-1.874 4.821 4.821 0 0 1-.696-2.513 4.679 4.679 0 0 1 .116-1.079l.041-.169a4.712 4.712 0 0 1 1.882-2.717 4.75 4.75 0 0 1 2.625-.876 4.476 4.476 0 0 1 1.993.379c.753.333 1.36.807 1.85 1.449.422.55.71 1.179.858 1.866.123.575.112 1.196-.03 1.896-.094.457-.28.914-.567 1.395a4.42 4.42 0 0 1-1.213 1.299c-.36.261-.734.462-1.114.595a4.71 4.71 0 0 1-1.502.275c-.5.008-.955-.053-1.39-.186a4.273 4.273 0 0 1-2.701-2.448 4.274 4.274 0 0 1-.298-1.155c-.06-.475-.025-.99.101-1.572.084-.386.226-.755.423-1.096a4.246 4.246 0 0 1 1.48-1.532l.155-.09a4.211 4.211 0 0 1 2.526-.514c.788.081 1.48.36 2.056.83.674.548 1.139 1.175 1.389 1.874.25.7.281 1.468.098 2.296-.16.715-.52 1.34-1.099 1.908-.726.714-1.644 1.097-2.726 1.141a3.517 3.517 0 0 1-1.924-.477c-1.233-.71-1.892-1.786-1.954-3.192a3.673 3.673 0 0 1 .41-1.884 3.592 3.592 0 0 1 1.712-1.635c.992-.458 1.964-.489 2.963-.091 1.003.399 1.693 1.142 2.047 2.201.261.781.225 1.584-.104 2.382-.224.541-.575 1-1.044 1.365-.932.724-1.97.942-3.076.645-.906-.244-1.584-.79-2.01-1.619a3.21 3.21 0 0 1-.28-2.192c.116-.54.334-1.002.651-1.374.572-.67 1.292-1.05 2.137-1.127.504-.045.953.01 1.371.172.627.243 1.1.61 1.44 1.123.576.868.696 1.771.35 2.677-.45 1.177-1.382 1.85-2.68 1.94a2.542 2.542 0 0 1-1.617-.452c-1.048-.713-1.462-2.008-1.033-3.22a2.468 2.468 0 0 1 1.264-1.426c.906-.441 1.781-.402 2.589.122.644.418 1.012 1.024 1.092 1.794.063.607-.092 1.159-.47 1.681-.233.324-.595.597-1.009.768l-.18.067c-.51.17-1.037.176-1.481.013-.923-.34-1.449-1.114-1.44-2.116.003-.449.145-.862.42-1.224.499-.66 1.18-.94 2.008-.83.46.06.857.289 1.18.673l.084.11c.404.568.542 1.482.007 2.179-.482.628-1.135.882-1.88.727-.459-.096-.8-.34-1.034-.741-.195-.334-.261-.688-.21-1.105a1.519 1.519 0 0 1 1.276-1.311c.532-.082 1 .093 1.344.504a1.3 1.3 0 0 1 .297 1.056 1.287 1.287 0 0 1-1.442 1.072 1.117 1.117 0 0 1-.7-.365 1.077 1.077 0 0 1-.25-.74 1.03 1.03 0 0 1 .254-.689c.162-.178.395-.293.682-.343a.77.77 0 0 1 .464.088.696.696 0 0 1 .329.322.909.909 0 0 1-.002.643.936.936 0 0 1-.404.506.566.566 0 0 1-.34.06.538.538 0 0 1-.311-.142.597.597 0 0 1-.177-.314.542.542 0 0 1 .058-.347.531.531 0 0 1 .212-.23.562.562 0 0 1 .305-.065c.077-.002.12.066.118.124a.118.118 0 0 1-.124.113.33.33 0 0 0-.182.035.296.296 0 0 0-.117.131.305.305 0 0 0-.036.197c.012.06.046.123.11.188a.305.305 0 0 0 .175.072.331.331 0 0 0 .194-.03.7.7 0 0 0 .293-.377.674.674 0 0 0 .008-.472.464.464 0 0 0-.219-.203.535.535 0 0 0-.313-.064c-.241.041-.423.135-.544.268a.794.794 0 0 0-.195.535.839.839 0 0 0 .194.579.88.88 0 0 0 .552.285 1.05 1.05 0 0 0 1.173-.875 1.065 1.065 0 0 0-.245-.865 1.168 1.168 0 0 0-1.125-.423 1.28 1.28 0 0 0-1.076 1.105c-.045.37.013.672.18.957.2.342.485.546.877.628.333.069.634.049.905-.056.272-.106.519-.298.737-.583.49-.637.326-1.502-.084-1.99-.287-.342-.633-.54-1.03-.592-.743-.098-1.34.149-1.787.738a1.782 1.782 0 0 0-.371 1.083c-.007.902.46 1.587 1.284 1.89.39.144.861.13 1.302-.01.44-.14.841-.404 1.093-.753.344-.477.482-.972.426-1.517l-.016-.13a2.09 2.09 0 0 0-.97-1.49c-.732-.475-1.52-.513-2.354-.107A2.223 2.223 0 0 0 19.642 20l-.041.108c-.394 1.112-.015 2.293.943 2.944.45.306.957.447 1.466.411.615-.043 1.127-.216 1.538-.512.41-.297.724-.722.936-1.276.316-.827.21-1.653-.326-2.46-.31-.469-.743-.806-1.327-1.032a2.752 2.752 0 0 0-1.265-.157c-.78.07-1.444.42-1.976 1.044-.289.339-.492.765-.6 1.27a2.974 2.974 0 0 0 .26 2.033 2.82 2.82 0 0 0 1.704 1.452l.155.046.193.046c.959.203 1.856-.014 2.675-.65.436-.339.763-.765.97-1.267.308-.747.34-1.491.098-2.216-.332-.994-.974-1.684-1.909-2.055-.936-.373-1.842-.345-2.774.086a3.356 3.356 0 0 0-1.601 1.529 3.435 3.435 0 0 0-.383 1.764c.059 1.34.656 2.317 1.835 2.995.56.322 1.163.472 1.795.446 1.04-.042 1.878-.394 2.57-1.073.548-.54.884-1.124 1.032-1.79.174-.787.142-1.51-.091-2.164-.234-.654-.67-1.246-1.314-1.77-.538-.438-1.187-.7-1.93-.777a3.986 3.986 0 0 0-2.533.57 4.005 4.005 0 0 0-1.397 1.447 3.57 3.57 0 0 0-.396 1.029c-.122.56-.153 1.047-.098 1.49.052.413.144.77.281 1.093a4.046 4.046 0 0 0 2.553 2.313 4.474 4.474 0 0 0 2.742-.086l.134-.05c.31-.123.62-.295.919-.513a4.187 4.187 0 0 0 1.15-1.23c.274-.46.45-.892.536-1.319.137-.672.147-1.26.032-1.798a4.406 4.406 0 0 0-.814-1.772 4.396 4.396 0 0 0-1.757-1.376 4.238 4.238 0 0 0-1.889-.358c-.93.035-1.769.315-2.495.832a4.472 4.472 0 0 0-1.83 2.745c-.075.33-.113.674-.11 1.024.007.879.23 1.683.662 2.39a4.656 4.656 0 0 0 1.987 1.785c.418.202.866.336 1.33.399a4.9 4.9 0 0 0 2.228-.212 4.641 4.641 0 0 0 1.488-.795c.628-.51 1.081-1.087 1.387-1.764a4.89 4.89 0 0 0 .439-1.703 4.758 4.758 0 0 0-.76-2.96 4.83 4.83 0 0 0-2.434-1.963 4.9 4.9 0 0 0-1.779-.315 5.064 5.064 0 0 0-1.974.398 5.101 5.101 0 0 0-2.302 1.928 4.84 4.84 0 0 0-.731 1.84 5.01 5.01 0 0 0-.053 1.536c.071.526.188.983.356 1.399a4.89 4.89 0 0 0 1.145 1.71 5.296 5.296 0 0 0 1.923 1.185 5.38 5.38 0 0 0 1.749.291 5.27 5.27 0 0 0 1.765-.296 5.336 5.336 0 0 0 1.521-.816c.461-.353.857-.77 1.174-1.237l.123-.187a5.221 5.221 0 0 0 .809-2.466v-.005a.473.473 0 0 1 .012-.093.184.184 0 0 1 .072-.107c.059-.04.127-.034.188-.015a.12.12 0 0 1 .078.149.118.118 0 0 1-.112.081v.006c-.02.292-.062.58-.13.872l-.076.294a5.556 5.556 0 0 1-.766 1.605 5.581 5.581 0 0 1-1.226 1.292 5.572 5.572 0 0 1-1.59.853 5.511 5.511 0 0 1-2.352.283H21.44a5.36 5.36 0 0 1-1.307-.28 5.53 5.53 0 0 1-2.008-1.237 5.13 5.13 0 0 1-1.201-1.793 5.772 5.772 0 0 1-.341-1.256l-.03-.2a5.244 5.244 0 0 1 .054-1.608 5.08 5.08 0 0 1 .767-1.93 5.337 5.337 0 0 1 4.472-2.434Zm.064 4.904h.002v-.03l-.002.03Zm.002 0h-.002l.002-.03v.03Z"/><path fill="#000" d="M42.524 4.132A3.359 3.359 0 0 0 39.165.774H4.632a3.359 3.359 0 0 0-3.358 3.358v33.939a3.359 3.359 0 0 0 3.358 3.358h34.533a3.359 3.359 0 0 0 3.359-3.358V4.132Zm.274 33.939a3.632 3.632 0 0 1-3.633 3.632H4.632A3.632 3.632 0 0 1 1 38.07V4.133A3.632 3.632 0 0 1 4.632.5h34.533a3.632 3.632 0 0 1 3.633 3.632v33.939Z"/><path fill="#000" d="M39.34 4.045a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM39.34 37.965a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.06 0 1.03 1.03 0 0 1 2.06 0ZM5.75 37.965a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM5.75 4.045a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM36.964 21.102c0-8.32-6.745-15.065-15.065-15.065S6.834 12.782 6.834 21.102 13.58 36.166 21.9 36.166s15.065-6.744 15.065-15.064Zm.31 0c0 8.491-6.883 15.375-15.375 15.375-8.491 0-15.375-6.884-15.375-15.375 0-8.492 6.884-15.376 15.375-15.376 8.492 0 15.375 6.885 15.375 15.376Z"/><path fill="#000" d="M38.452 21.102c0-9.142-7.41-16.554-16.553-16.554-9.142 0-16.553 7.412-16.553 16.554s7.411 16.553 16.553 16.553c9.142 0 16.553-7.411 16.553-16.553Zm.31 0c0 9.313-7.55 16.863-16.863 16.863-9.313 0-16.864-7.55-16.864-16.863 0-9.314 7.55-16.864 16.864-16.864s16.864 7.55 16.864 16.864Z"/><path stroke="#000" stroke-miterlimit="10" stroke-width=".2" d="m22.119 6.563.18.009c.059.001.117.002.175-.002.506-.03 1.006.044 1.482.113l.234.034c.44.061.901.16 1.45.311.43.119.894.253 1.344.421.63.236 1.248.518 1.838.838.84.457 1.577.945 2.252 1.493a14.729 14.729 0 0 1 1.654 1.572c.422.47.838 1.015 1.271 1.666.634.953 1.147 1.991 1.566 3.172a13.93 13.93 0 0 1 .755 3.585c.083 1.076.056 2.038-.085 2.938-.083.535-.205 1.24-.4 1.932-.178.63-.4 1.248-.677 1.889a13.55 13.55 0 0 1-1.545 2.677c-.487.659-.989 1.239-1.533 1.773a14.507 14.507 0 0 1-4.312 2.895c-.844.373-1.708.657-2.57.844-1.07.232-2.033.345-2.943.346-.508 0-.958-.012-1.376-.04-.77-.049-1.556-.18-2.404-.402a14.654 14.654 0 0 1-1.926-.648c-.982-.41-1.93-.94-2.817-1.575a13.821 13.821 0 0 1-2.058-1.82 13.315 13.315 0 0 1-1.498-1.936c-.36-.568-.683-1.16-.96-1.76a14.077 14.077 0 0 1-1.018-3.19c-.127-.643-.201-1.335-.227-2.114-.025-.761.03-1.506.082-2.067a13.14 13.14 0 0 1 .305-1.75c.181-.782.435-1.555.756-2.296.342-.793.771-1.57 1.275-2.31a14.467 14.467 0 0 1 2.277-2.582c.534-.485 1.126-.898 1.579-1.202a12.614 12.614 0 0 1 2.2-1.176 14.2 14.2 0 0 1 3.806-1.005 12.71 12.71 0 0 1 1.798-.101l.06.002c.507.012 1.039.025 1.562.108.103.017.206.032.31.048.342.052.7.106 1.045.186l.338.083c.344.089.707.2 1.12.339a13.89 13.89 0 0 1 6.734 5.001c.47.65.892 1.369 1.255 2.136.267.566.502 1.164.7 1.783l.084.266.077.271c.176.642.307 1.337.402 2.115.048.399.071.827.07 1.31-.001.466-.028.956-.085 1.542-.056.577-.16 1.176-.325 1.884-.096.406-.226.833-.399 1.304a13.903 13.903 0 0 1-.93 2.045c-.34.605-.752 1.213-1.223 1.806a13.246 13.246 0 0 1-1.822 1.886 13.51 13.51 0 0 1-1.6 1.176c-.453.28-.948.576-1.473.822-.717.335-1.471.61-2.305.84-1.1.304-2.236.469-3.378.49a13.203 13.203 0 0 1-2.373-.159 14.3 14.3 0 0 1-2.916-.791 13.465 13.465 0 0 1-2.624-1.39 12.332 12.332 0 0 1-1.53-1.218 14.466 14.466 0 0 1-1.541-1.689 13.006 13.006 0 0 1-1.197-1.844 12.734 12.734 0 0 1-1.116-2.824c-.17-.66-.296-1.222-.358-1.81a11.35 11.35 0 0 0-.034-.282c-.023-.182-.048-.375-.055-.565a19.3 19.3 0 0 1-.01-1.258c.024-.759.096-1.456.22-2.13.096-.523.215-1.002.364-1.463.2-.614.41-1.165.642-1.684a13.145 13.145 0 0 1 2.04-3.183 12.404 12.404 0 0 1 1.792-1.708 14.747 14.747 0 0 1 2.032-1.329c.45-.242.928-.46 1.463-.666a13.545 13.545 0 0 1 2.338-.674c.35-.067.67-.125 1-.16a12.31 12.31 0 0 1 1.094-.071l.152-.003c.404-.007.826-.016 1.242.017h.01l.01.002c.82.067 1.572.188 2.3.369.721.18 1.414.413 2.06.692a13.462 13.462 0 0 1 4.706 3.413 12.738 12.738 0 0 1 1.79 2.613c.433.844.752 1.643.973 2.441.134.486.283 1.068.364 1.674.056.427.092.854.12 1.215.032.433.039.867.019 1.287-.044.941-.182 1.871-.41 2.763-.177.69-.397 1.338-.654 1.926a13.005 13.005 0 0 1-1.41 2.475 13.314 13.314 0 0 1-3.192 3.12c-.664.446-1.24.78-1.812 1.054-.866.413-1.75.73-2.63.938-.974.232-1.948.359-2.894.377-.425.008-.986.01-1.541-.052-.849-.094-1.544-.224-2.188-.41a14.164 14.164 0 0 1-2.057-.756 13.17 13.17 0 0 1-2.105-1.246 12.548 12.548 0 0 1-3.916-4.561c-.355-.696-.642-1.401-.85-2.096-.333-1.118-.506-2.146-.529-3.143l-.003-.132c-.012-.482-.024-.986.025-1.484l.005-.054c.042-.423.085-.865.162-1.298a12.381 12.381 0 0 1 .921-3.033c.29-.636.607-1.22.97-1.784.35-.544.75-1.066 1.19-1.551l.224-.243c.516-.549.995-.982 1.489-1.349.484-.36.897-.637 1.3-.873a13.029 13.029 0 0 1 3.782-1.495c.56-.121 1.121-.207 1.717-.262.623-.058 1.247-.05 1.88-.037.283.006.56.043.824.078.476.064.988.141 1.484.27.693.18 1.364.41 1.994.682.862.372 1.705.853 2.507 1.429.65.467 1.26 1.012 1.862 1.664a12.33 12.33 0 0 1 1.858 2.636 13.446 13.446 0 0 1 1.169 3.203l.058.27.045.232c.1.546.156 1.123.173 1.755.013.453.021.865-.01 1.282a13.164 13.164 0 0 1-.625 3.194 12.578 12.578 0 0 1-.773 1.81c-.26.496-.547.968-.85 1.403-.56.8-1.198 1.52-1.896 2.136a13.09 13.09 0 0 1-2.482 1.744c-.93.5-1.945.892-3.015 1.165a12.71 12.71 0 0 1-2.063.332c-.536.046-1.058.054-1.552.023a13.655 13.655 0 0 1-1.986-.243l-.302-.07a12.767 12.767 0 0 1-1.202-.342 12.996 12.996 0 0 1-2.03-.914 12.727 12.727 0 0 1-2.983-2.32 14.158 14.158 0 0 1-.901-1.08 9.78 9.78 0 0 1-.779-1.17 12.427 12.427 0 0 1-.96-2.095 12.934 12.934 0 0 1-.425-1.484 11.517 11.517 0 0 1-.27-2.944c.037-.809.107-1.769.342-2.724.1-.405.232-.84.416-1.367.227-.647.536-1.303.918-1.951.28-.473.6-.942.983-1.435a11.889 11.889 0 0 1 3.764-3.163c.615-.33 1.175-.58 1.71-.764 1.05-.36 2.026-.573 2.982-.652.723-.06 1.391-.072 2.043-.037.765.042 1.511.201 2.072.334.768.183 1.52.444 2.236.778.921.429 1.782.966 2.557 1.597.551.449 1.06.935 1.514 1.446.478.537.909 1.13 1.318 1.814a11.984 11.984 0 0 1 1.644 4.993c.065.71.077 1.367.035 2.008-.032.483-.097.965-.192 1.43a13.32 13.32 0 0 1-.265 1.113c-.136.46-.313.94-.539 1.47a11.747 11.747 0 0 1-2.866 4.017 11.834 11.834 0 0 1-2.436 1.74c-.84.45-1.637.777-2.436.999a13.93 13.93 0 0 1-1.905.383 11.952 11.952 0 0 1-7.048-1.261 11.643 11.643 0 0 1-3.108-2.366 12.799 12.799 0 0 1-.888-1.06c-.33-.44-.633-.91-.898-1.395-.237-.436-.454-.92-.662-1.48a12.095 12.095 0 0 1-.65-2.644 11.094 11.094 0 0 1-.086-1.968c.043-.901.15-1.69.327-2.41.175-.712.4-1.38.688-2.042a11.747 11.747 0 0 1 2.332-3.453 11.273 11.273 0 0 1 1.86-1.54 11.845 11.845 0 0 1 2.827-1.38 10.348 10.348 0 0 1 1.612-.414c.482-.077 1.06-.159 1.659-.17.431-.01.862-.001 1.264.008.317.007.632.06.93.11.098.018.2.035.298.05.446.068.88.167 1.29.294 1.09.337 2.033.763 2.88 1.302a11.73 11.73 0 0 1 3.505 3.382 11.639 11.639 0 0 1 1.867 4.952c.077.581.11 1.068.105 1.53-.004.457-.009.934-.09 1.404l-.05.308c-.043.263-.087.539-.148.806-.096.417-.213.821-.348 1.201a11.75 11.75 0 0 1-1.818 3.322c-.44.57-.941 1.1-1.488 1.575a11.713 11.713 0 0 1-4.72 2.501c-.868.234-1.775.361-2.77.39-.471.014-.928-.021-1.31-.057h-.007a10.13 10.13 0 0 1-1.833-.327 12.493 12.493 0 0 1-1.459-.499 11.206 11.206 0 0 1-3.737-2.553 11.165 11.165 0 0 1-2.375-3.717c-.21-.522-.378-1.11-.53-1.849a10.075 10.075 0 0 1-.207-1.892 12.98 12.98 0 0 1 .162-2.317c.14-.847.377-1.69.702-2.504.233-.583.53-1.157.908-1.755.252-.398.56-.806.97-1.28a10.85 10.85 0 0 1 2.185-1.938 10.7 10.7 0 0 1 2.403-1.225c.611-.216 1.13-.364 1.633-.466a11.263 11.263 0 0 1 3.257-.18c.384.029.78.085 1.21.174a11.277 11.277 0 0 1 4.035 1.677 11.365 11.365 0 0 1 2.034 1.753c.447.485.863 1.04 1.237 1.65a11.058 11.058 0 0 1 1.455 3.802c.142.782.2 1.508.177 2.221-.02.607-.072 1.14-.163 1.63-.065.35-.143.758-.257 1.15-.219.751-.521 1.484-.897 2.178a10.609 10.609 0 0 1-1.351 1.937c-.702.8-1.475 1.475-2.298 2.007a10.5 10.5 0 0 1-2.043 1.044 11.76 11.76 0 0 1-2.89.692c-.532.057-1.094.072-1.822.048a9.535 9.535 0 0 1-2.076-.32 10.644 10.644 0 0 1-2.232-.846l-.296-.159a10.476 10.476 0 0 1-2.216-1.635c-.483-.47-.912-.965-1.312-1.514a10.355 10.355 0 0 1-1.283-2.389A10.11 10.11 0 0 1 11.235 21v-.136c0-.692.086-1.406.27-2.243.154-.7.38-1.389.675-2.047.387-.869.903-1.696 1.533-2.457a10.47 10.47 0 0 1 2.073-1.898c.69-.482 1.42-.874 2.17-1.164a11.055 11.055 0 0 1 4.45-.744c.99.038 1.991.226 2.974.56 1.018.345 1.971.84 2.831 1.473a10.614 10.614 0 0 1 4.097 6.304c.183.843.262 1.677.233 2.478-.037 1.022-.18 1.925-.434 2.762a10.477 10.477 0 0 1-1.062 2.381c-.342.565-.75 1.11-1.214 1.623a10.078 10.078 0 0 1-1.87 1.611c-.463.31-.994.598-1.621.879-.642.286-1.316.508-2.002.659a9.543 9.543 0 0 1-2.02.223c-.802.002-1.532-.06-2.23-.19-.538-.1-1.07-.248-1.628-.449a9.716 9.716 0 0 1-2.128-1.075 10.607 10.607 0 0 1-1.454-1.166l-.182-.18a10.514 10.514 0 0 1-1.504-1.913 9.782 9.782 0 0 1-1.01-2.24 10.696 10.696 0 0 1-.424-2.177 12.67 12.67 0 0 1-.014-1.696c.008-.174.034-.351.059-.518l.026-.19c.044-.334.114-.685.213-1.07.123-.48.296-.976.512-1.476.41-.95.957-1.82 1.623-2.589a9.752 9.752 0 0 1 1.942-1.724 11.498 11.498 0 0 1 1.745-.96 9.81 9.81 0 0 1 3.386-.806c.609-.037 1.269-.054 1.921.065l.34.06c.32.055.654.113.98.195.78.199 1.536.498 2.25.89a10.307 10.307 0 0 1 2.28 1.708 10.065 10.065 0 0 1 1.764 2.355 9.924 9.924 0 0 1 1.177 5.064 9.758 9.758 0 0 1-.365 2.373 9.898 9.898 0 0 1-.711 1.834 9.651 9.651 0 0 1-1.328 1.943c-.73.824-1.498 1.47-2.347 1.973-.892.53-1.766.898-2.669 1.125-.612.154-1.222.252-1.865.298a9.832 9.832 0 0 1-3.302-.33 10.178 10.178 0 0 1-2.25-.944c-.494-.282-.98-.619-1.446-1.001-.34-.28-.68-.611-1.035-1.01-.197-.223-.376-.461-.57-.724a9.439 9.439 0 0 1-1.043-1.838 9.096 9.096 0 0 1-.66-2.293 9.157 9.157 0 0 1-.124-1.354c0-.524.037-1.066.108-1.612.063-.477.168-.972.313-1.47.179-.617.452-1.189.695-1.662.402-.785.948-1.532 1.668-2.286a8.976 8.976 0 0 1 1.672-1.346 9.114 9.114 0 0 1 1.497-.774c.56-.226 1.141-.403 1.727-.525a9.153 9.153 0 0 1 2.497-.184c.373.025.716.06 1.048.109a8.772 8.772 0 0 1 1.622.403 9.055 9.055 0 0 1 2.08 1.041 9.624 9.624 0 0 1 2.703 2.726 9.5 9.5 0 0 1 1.32 3.13c.14.628.21 1.29.214 2.024a9.46 9.46 0 0 1-.231 2.077 8.96 8.96 0 0 1-.623 1.81 9.38 9.38 0 0 1-1.41 2.186 9.599 9.599 0 0 1-2.438 2.025 9.805 9.805 0 0 1-2.5 1.02 8.741 8.741 0 0 1-2.335.273c-.457-.008-.995-.025-1.521-.13a10.49 10.49 0 0 1-1.665-.45 9.068 9.068 0 0 1-2.861-1.718 9.147 9.147 0 0 1-2.67-4.184c-.283-.916-.405-1.887-.376-2.968a9.045 9.045 0 0 1 .286-2.031 9.2 9.2 0 0 1 .78-2.026 8.76 8.76 0 0 1 .945-1.422 9.262 9.262 0 0 1 1.806-1.695 8.915 8.915 0 0 1 1.993-1.07 9.148 9.148 0 0 1 2.215-.544c.5-.057 1.009-.078 1.515-.062a8.01 8.01 0 0 1 1.675.238c.57.14 1.08.312 1.56.526.361.162.734.364 1.172.634a8.602 8.602 0 0 1 2.556 2.438 8.743 8.743 0 0 1 1.425 3.402c.143.763.19 1.501.142 2.256-.023.367-.078.76-.168 1.199-.056.276-.129.604-.237.92a9.164 9.164 0 0 1-1.115 2.256 8.79 8.79 0 0 1-1.226 1.438 8.554 8.554 0 0 1-2.401 1.617 9.975 9.975 0 0 1-1.462.538 8.854 8.854 0 0 1-2.48.297 8.465 8.465 0 0 1-2.24-.337 8.74 8.74 0 0 1-2.519-1.197 8.51 8.51 0 0 1-3.382-4.755 8.236 8.236 0 0 1-.305-1.912 9.234 9.234 0 0 1 .079-1.675c.096-.662.235-1.24.423-1.768a8.212 8.212 0 0 1 .983-1.907 9.38 9.38 0 0 1 1.165-1.356 8 8 0 0 1 1.905-1.37 8.348 8.348 0 0 1 3.09-.922 8.834 8.834 0 0 1 2.652.142c.865.182 1.7.5 2.482.945A8.363 8.363 0 0 1 29.1 16.47a8.26 8.26 0 0 1 1.023 2.543 8.61 8.61 0 0 1 .2 1.79c.004.409-.028.821-.094 1.226a8.93 8.93 0 0 1-.303 1.311 8.31 8.31 0 0 1-1.021 2.1 8.176 8.176 0 0 1-1.434 1.624 8.33 8.33 0 0 1-1.865 1.224 8.28 8.28 0 0 1-1.59.578 9.108 9.108 0 0 1-2.223.253 7.857 7.857 0 0 1-1.75-.212 7.675 7.675 0 0 1-2.107-.833 8.407 8.407 0 0 1-1.413-1.004l-.168-.155a7.925 7.925 0 0 1-.97-1.104 8.515 8.515 0 0 1-.966-1.743 7.815 7.815 0 0 1-.431-1.472 7.888 7.888 0 0 1-.148-1.289c-.014-.512.04-1.028.09-1.52l.008-.076c.027-.261.08-.53.156-.8.129-.455.297-.995.56-1.516.287-.568.589-1.05.924-1.475a7.963 7.963 0 0 1 3.927-2.65 8.321 8.321 0 0 1 2.742-.313c.339.015.702.061 1.107.142.85.169 1.663.471 2.417.898a7.968 7.968 0 0 1 2.373 2.063c.43.555.774 1.143 1.018 1.748.23.572.391 1.13.493 1.704.113.636.146 1.255.1 1.894a7.966 7.966 0 0 1-.276 1.57 7.38 7.38 0 0 1-.859 1.949 7.606 7.606 0 0 1-1.743 1.948 7.949 7.949 0 0 1-2.362 1.285 7.93 7.93 0 0 1-2.477.412c-.657.01-1.3-.069-1.966-.24a7.422 7.422 0 0 1-1.81-.725 7.683 7.683 0 0 1-1.784-1.386 7.424 7.424 0 0 1-1.618-2.576 7.364 7.364 0 0 1-.459-2.238l-.005-.317c.004-.693.07-1.315.202-1.9a7.28 7.28 0 0 1 .398-1.223 6.996 6.996 0 0 1 1.49-2.243 7.443 7.443 0 0 1 2.625-1.727 7.108 7.108 0 0 1 2.244-.486 7.697 7.697 0 0 1 2.325.23c.756.2 1.424.482 2.04.864 1.379.853 2.382 2.04 2.978 3.524.488 1.214.64 2.471.45 3.735-.08.538-.18.967-.314 1.348a7.164 7.164 0 0 1-1.22 2.16 7.087 7.087 0 0 1-1.945 1.654 7.084 7.084 0 0 1-2.599.91 7.886 7.886 0 0 1-2.007.014 6.712 6.712 0 0 1-1.87-.503 7.023 7.023 0 0 1-3.694-3.665 6.945 6.945 0 0 1-.449-4.18c.095-.44.209-.83.349-1.19a6.752 6.752 0 0 1 1.692-2.498 7.03 7.03 0 0 1 2.296-1.434c.838-.322 1.725-.476 2.71-.468.426.003.881.067 1.432.199.709.17 1.362.44 1.941.802.865.54 1.542 1.188 2.068 1.979.452.68.766 1.39.957 2.167.112.455.171.947.192 1.591.017.514-.063 1.007-.187 1.58a5.635 5.635 0 0 1-.45 1.255 6.934 6.934 0 0 1-1.52 2.062 6.86 6.86 0 0 1-2.778 1.57 6.569 6.569 0 0 1-2.05.256 6.244 6.244 0 0 1-1.68-.264 6.51 6.51 0 0 1-2.329-1.256 6.42 6.42 0 0 1-1.687-2.216 6.139 6.139 0 0 1-.566-2.788c.018-.644.081-1.134.208-1.585a6.57 6.57 0 0 1 .78-1.789c.48-.75 1.033-1.34 1.69-1.802.872-.614 1.784-.988 2.787-1.141a6.42 6.42 0 0 1 2.473.082c.72.168 1.396.458 2.01.861a6.01 6.01 0 0 1 1.76 1.778c.949 1.472 1.23 3.092.833 4.81a5.822 5.822 0 0 1-.883 1.994 6.551 6.551 0 0 1-2.745 2.274c-.68.299-1.423.47-2.205.506a6.055 6.055 0 0 1-3.022-.65 5.69 5.69 0 0 1-1.985-1.683 5.617 5.617 0 0 1-.896-1.76 6.247 6.247 0 0 1-.253-1.664c-.01-.5.042-1.01.16-1.52a5.64 5.64 0 0 1 .806-1.902c.36-.54.755-.983 1.21-1.352.45-.365.958-.657 1.552-.892a5.932 5.932 0 0 1 2.3-.41c.43.008.852.065 1.258.169a5.776 5.776 0 0 1 1.94.893 5.555 5.555 0 0 1 1.817 2.152c.261.55.427 1.082.506 1.623.036.25.047.503.058.743.005.12.01.242.019.36a.12.12 0 0 1-.11.128h-.002a.12.12 0 0 1-.127-.112c-.008-.122-.013-.246-.019-.365a7.293 7.293 0 0 0-.056-.72 5.42 5.42 0 0 0-.484-1.556 5.318 5.318 0 0 0-1.742-2.06 5.542 5.542 0 0 0-1.86-.856 5.235 5.235 0 0 0-1.202-.162 5.692 5.692 0 0 0-2.21.394 5.558 5.558 0 0 0-1.489.856 5.759 5.759 0 0 0-1.162 1.298 5.408 5.408 0 0 0-.772 1.825 6.07 6.07 0 0 0 .036 2.87l.054.192.071.22c.178.512.442 1.004.787 1.465a5.452 5.452 0 0 0 1.902 1.613c.446.227.903.39 1.4.497a5.935 5.935 0 0 0 3.624-.358 6.317 6.317 0 0 0 2.644-2.192c.405-.588.69-1.232.847-1.913.383-1.654.113-3.21-.801-4.627a5.77 5.77 0 0 0-1.69-1.708 5.998 5.998 0 0 0-1.934-.828 6.181 6.181 0 0 0-2.382-.08c-.965.148-1.843.508-2.686 1.101-.63.444-1.162 1.01-1.626 1.736a6.335 6.335 0 0 0-.752 1.726c-.12.427-.182.897-.2 1.526a5.9 5.9 0 0 0 .544 2.682 6.185 6.185 0 0 0 3.871 3.345 6.017 6.017 0 0 0 1.617.253 6.331 6.331 0 0 0 1.976-.246 6.622 6.622 0 0 0 2.681-1.516 6.701 6.701 0 0 0 1.47-1.992c.212-.443.353-.835.431-1.2.122-.566.198-1.037.182-1.523-.02-.631-.079-1.106-.186-1.542a6.552 6.552 0 0 0-.924-2.093c-.505-.76-1.158-1.385-1.995-1.908a6.281 6.281 0 0 0-1.87-.772c-.538-.13-.975-.19-1.379-.192-.957-.008-1.815.14-2.623.451a6.8 6.8 0 0 0-2.219 1.386 6.516 6.516 0 0 0-1.633 2.41 7.498 7.498 0 0 0-.338 1.153c-.12.56-.16 1.13-.122 1.744.049.789.235 1.56.556 2.292a6.78 6.78 0 0 0 3.569 3.54 6.465 6.465 0 0 0 1.805.487 7.643 7.643 0 0 0 1.947-.014 6.845 6.845 0 0 0 2.513-.88 6.843 6.843 0 0 0 1.88-1.6 6.926 6.926 0 0 0 1.178-2.087 6.98 6.98 0 0 0 .304-1.304 6.845 6.845 0 0 0-.435-3.61c-.577-1.437-1.547-2.584-2.883-3.411a7.168 7.168 0 0 0-1.976-.836 7.447 7.447 0 0 0-2.254-.223 6.868 6.868 0 0 0-2.169.47 7.203 7.203 0 0 0-2.54 1.673 6.693 6.693 0 0 0-1.304 1.86l-.137.308c-.17.403-.295.79-.384 1.183a8.549 8.549 0 0 0-.197 1.85c-.005.814.141 1.623.45 2.471.329.905.856 1.744 1.567 2.493a7.44 7.44 0 0 0 1.728 1.343c.534.303 1.124.54 1.753.702a7.088 7.088 0 0 0 1.903.232 7.694 7.694 0 0 0 2.403-.399c.83-.283 1.6-.702 2.29-1.247a7.371 7.371 0 0 0 1.69-1.888 7.15 7.15 0 0 0 .83-1.886 7.739 7.739 0 0 0 .27-1.523 7.398 7.398 0 0 0-.098-1.836 8.232 8.232 0 0 0-.48-1.656 7.093 7.093 0 0 0-.983-1.69 7.738 7.738 0 0 0-4.65-2.874 7.111 7.111 0 0 0-1.07-.139 8.084 8.084 0 0 0-2.664.304 7.447 7.447 0 0 0-1.977.913 7.73 7.73 0 0 0-1.831 1.656c-.324.41-.619.88-.9 1.435-.252.501-.416 1.025-.543 1.474a4.479 4.479 0 0 0-.147.76l-.008.075c-.051.493-.103.996-.09 1.49.012.396.06.817.145 1.25.102.526.239.993.416 1.427a8.27 8.27 0 0 0 .94 1.695c.264.368.572.718.941 1.07.422.404.924.772 1.535 1.125a7.436 7.436 0 0 0 2.043.807 7.626 7.626 0 0 0 1.697.207 8.861 8.861 0 0 0 2.166-.247 8.041 8.041 0 0 0 1.544-.561c.634-.301 1.244-.701 1.81-1.19a7.943 7.943 0 0 0 1.393-1.578 8.072 8.072 0 0 0 .991-2.039c.118-.365.212-.77.295-1.276.064-.391.095-.79.09-1.184a8.379 8.379 0 0 0-.193-1.742 8.028 8.028 0 0 0-.993-2.469 8.126 8.126 0 0 0-2.92-2.842 8.346 8.346 0 0 0-2.413-.92 8.598 8.598 0 0 0-2.58-.138 8.11 8.11 0 0 0-3.003.895 7.762 7.762 0 0 0-1.848 1.33c-.467.459-.84.89-1.137 1.322a7.973 7.973 0 0 0-.955 1.85 8.918 8.918 0 0 0-.411 1.723 9.007 9.007 0 0 0-.077 1.632 8.38 8.38 0 0 0 1.181 3.922 8.27 8.27 0 0 0 2.404 2.558c.73.508 1.555.9 2.45 1.166a8.238 8.238 0 0 0 2.178.327 8.622 8.622 0 0 0 2.413-.29c.427-.115.88-.282 1.428-.526a8.316 8.316 0 0 0 2.334-1.573c.437-.41.838-.88 1.194-1.399a8.933 8.933 0 0 0 1.085-2.197 7.32 7.32 0 0 0 .23-.892 8.47 8.47 0 0 0 .162-1.166l.014-.275c.02-.64-.03-1.27-.151-1.921a8.51 8.51 0 0 0-1.387-3.311 8.36 8.36 0 0 0-2.485-2.371 9.801 9.801 0 0 0-1.146-.619 8.466 8.466 0 0 0-1.112-.404l-.406-.109a7.784 7.784 0 0 0-1.627-.231c-.494-.016-.992.004-1.48.06a8.91 8.91 0 0 0-2.157.53c-.662.25-1.315.6-1.94 1.042a9.024 9.024 0 0 0-1.759 1.651c-.34.415-.65.88-.92 1.385a8.957 8.957 0 0 0-.759 1.973 8.792 8.792 0 0 0-.28 1.977c-.028 1.057.093 2.003.368 2.892a8.913 8.913 0 0 0 2.6 4.077 8.83 8.83 0 0 0 2.787 1.673c.459.17.96.306 1.627.439.505.1 1.025.117 1.479.125a8.503 8.503 0 0 0 2.27-.266 9.571 9.571 0 0 0 2.441-.995 9.366 9.366 0 0 0 2.378-1.974 9.137 9.137 0 0 0 1.98-3.892 9.222 9.222 0 0 0 .226-2.024 9.174 9.174 0 0 0-.208-1.973 9.255 9.255 0 0 0-1.288-3.052 9.391 9.391 0 0 0-2.635-2.659 8.813 8.813 0 0 0-2.026-1.014 8.522 8.522 0 0 0-1.578-.393 13.7 13.7 0 0 0-1.03-.107 8.928 8.928 0 0 0-2.432.18c-.572.12-1.14.292-1.686.513-.38.154-.752.335-1.108.54l-.35.214c-.656.42-1.188.848-1.629 1.31-.706.738-1.239 1.468-1.629 2.23-.24.468-.506 1.023-.679 1.619-.14.487-.243.97-.304 1.435a12.21 12.21 0 0 0-.106 1.582c0 .454.058.9.12 1.317.119.78.335 1.53.644 2.234a9.21 9.21 0 0 0 1.016 1.791c.194.262.366.493.556.707.349.391.68.713 1.01.985.454.374.93.704 1.412.979.685.39 1.425.7 2.197.92a9.58 9.58 0 0 0 3.22.321 10.45 10.45 0 0 0 1.824-.29c.879-.221 1.73-.58 2.605-1.098.826-.49 1.575-1.12 2.29-1.927a9.415 9.415 0 0 0 1.295-1.896 9.635 9.635 0 0 0 .693-1.79 9.526 9.526 0 0 0 .356-2.313 9.68 9.68 0 0 0-1.148-4.943 9.82 9.82 0 0 0-1.721-2.299 10.08 10.08 0 0 0-2.228-1.67 9.336 9.336 0 0 0-2.194-.867 12.78 12.78 0 0 0-.961-.192l-.342-.06c-.625-.114-1.262-.098-1.864-.062h-.001a9.568 9.568 0 0 0-3.304.787c-.59.26-1.165.576-1.709.94a9.508 9.508 0 0 0-1.895 1.682c-.65.75-1.183 1.6-1.584 2.528a9.8 9.8 0 0 0-.5 1.44 8.773 8.773 0 0 0-.234 1.236c-.024.167-.049.334-.057.495-.022.457-.04 1.057.014 1.664.063.72.203 1.437.414 2.129.23.754.562 1.49.987 2.185a10.29 10.29 0 0 0 3.07 3.186A9.463 9.463 0 0 0 18.54 30.4c.546.197 1.066.34 1.59.438.682.127 1.397.188 2.186.186a9.312 9.312 0 0 0 1.97-.217 10.15 10.15 0 0 0 1.955-.645 10.582 10.582 0 0 0 1.586-.858 9.846 9.846 0 0 0 1.825-1.573c.454-.502.853-1.036 1.188-1.587.437-.72.787-1.504 1.037-2.327.248-.814.387-1.697.424-2.7v-.001a9.715 9.715 0 0 0-.228-2.42 10.375 10.375 0 0 0-4.005-6.162 10.202 10.202 0 0 0-2.766-1.44 10.268 10.268 0 0 0-4.403-.503 10.82 10.82 0 0 0-2.858.685c-.732.283-1.446.665-2.12 1.137a10.247 10.247 0 0 0-2.026 1.854 10.456 10.456 0 0 0-1.5 2.402c-.287.644-.51 1.317-.66 2.002-.18.823-.264 1.52-.264 2.192V21c0 .245 0 .495.012.74.025.48.084.954.175 1.41.114.575.28 1.143.49 1.686.34.88.75 1.643 1.254 2.335.392.538.812 1.023 1.285 1.483a10.228 10.228 0 0 0 2.167 1.598c.76.426 1.591.756 2.471.983.733.189 1.395.29 2.024.311.72.024 1.271.01 1.789-.046.954-.102 1.88-.323 2.833-.678a10.26 10.26 0 0 0 1.995-1.021c.804-.52 1.561-1.18 2.25-1.964.506-.577.95-1.215 1.32-1.894.368-.679.663-1.396.877-2.13.11-.381.188-.78.252-1.127.088-.477.14-.998.16-1.594a10.143 10.143 0 0 0-.175-2.17c-.24-1.32-.72-2.57-1.423-3.72a10.406 10.406 0 0 0-1.208-1.614 11.142 11.142 0 0 0-1.993-1.716 11.033 11.033 0 0 0-3.95-1.642 9.037 9.037 0 0 0-1.18-.169c-.535-.038-.97-.05-1.369-.038-.61.02-1.223.092-1.822.213-.49.1-.999.245-1.602.458-.796.28-1.564.673-2.35 1.197a10.603 10.603 0 0 0-2.138 1.895c-.403.469-.704.867-.948 1.254-.37.586-.661 1.147-.888 1.716a11.82 11.82 0 0 0-.688 2.454 12.77 12.77 0 0 0-.16 2.275c.01.618.077 1.24.203 1.847.15.729.315 1.303.518 1.809a10.919 10.919 0 0 0 5.984 6.14c.508.216 1.03.374 1.431.488.527.15 1.113.254 1.79.318l.008.001.295.026c.306.024.642.04.984.03a11.611 11.611 0 0 0 2.716-.382 11.468 11.468 0 0 0 4.626-2.45 10.666 10.666 0 0 0 1.455-1.541 11.512 11.512 0 0 0 1.782-3.256c.132-.371.246-.767.34-1.174l.079-.394.066-.398.051-.31c.077-.448.083-.91.087-1.364a10.51 10.51 0 0 0-.104-1.498 11.36 11.36 0 0 0-1.828-4.851 11.505 11.505 0 0 0-3.435-3.314c-.827-.527-1.75-.944-2.823-1.275a8.8 8.8 0 0 0-1.255-.286 17.603 17.603 0 0 1-.303-.05 6.188 6.188 0 0 0-.894-.108 30.524 30.524 0 0 0-1.255-.008c-.583.011-1.148.09-1.625.167-.46.074-.96.202-1.576.406-.969.32-1.9.775-2.77 1.351-.667.443-1.28.95-1.82 1.508a11.498 11.498 0 0 0-2.284 3.383 12.355 12.355 0 0 0-.677 2.004 12.347 12.347 0 0 0-.32 2.364c-.026.546-.008 1.111.055 1.682l.03.244.048.336c.124.782.322 1.54.588 2.256a11.1 11.1 0 0 0 .65 1.45c.258.474.554.934.877 1.364.28.371.572.721.871 1.04a11.407 11.407 0 0 0 4.599 2.992 11.703 11.703 0 0 0 5.354.563 13.64 13.64 0 0 0 1.872-.378c.78-.217 1.562-.537 2.388-.979a11.598 11.598 0 0 0 2.386-1.704 11.51 11.51 0 0 0 2.809-3.936c.223-.522.396-.995.53-1.444.109-.37.19-.758.26-1.093.092-.455.155-.925.186-1.399.041-.627.03-1.27-.035-1.97a11.749 11.749 0 0 0-1.61-4.893 11.839 11.839 0 0 0-1.118-1.578l-.173-.2c-.445-.5-.945-.978-1.486-1.418a11.992 11.992 0 0 0-2.508-1.566 11.501 11.501 0 0 0-2.19-.762c-.556-.133-1.286-.29-2.03-.329a14.666 14.666 0 0 0-2.011.036c-.934.077-1.89.287-2.923.64-.522.179-1.07.424-1.676.748a11.652 11.652 0 0 0-3.688 3.099c-.377.487-.693.948-.966 1.41a10.793 10.793 0 0 0-.899 1.91 14.7 14.7 0 0 0-.41 1.346c-.23.932-.299 1.874-.335 2.678-.042.905.047 1.875.264 2.883.096.443.233.92.418 1.457.233.675.54 1.347.943 2.055.231.407.487.791.759 1.141.304.392.58.74.886 1.062a12.486 12.486 0 0 0 2.926 2.275c.605.341 1.257.635 1.995.898.38.136.784.237 1.18.335.784.196 1.572.265 2.244.307.481.03.991.022 1.517-.024a12.47 12.47 0 0 0 2.024-.325 13.065 13.065 0 0 0 2.962-1.144c.855-.46 1.652-1.02 2.436-1.713a11.833 11.833 0 0 0 1.858-2.093c.298-.426.579-.89.835-1.378a12.32 12.32 0 0 0 .759-1.775c.143-.424.264-.88.38-1.436.11-.523.186-1.08.233-1.7.03-.403.022-.806.01-1.257-.02-.71-.09-1.347-.214-1.946a13.171 13.171 0 0 0-1.205-3.41 12.098 12.098 0 0 0-1.822-2.585 12.072 12.072 0 0 0-1.826-1.633 13.158 13.158 0 0 0-2.462-1.403 13.694 13.694 0 0 0-1.96-.67c-.482-.126-.983-.201-1.455-.264a7.275 7.275 0 0 0-.797-.077c-.632-.014-1.245-.021-1.853.035a14.1 14.1 0 0 0-1.69.258c-.603.13-1.208.315-1.852.565a12.82 12.82 0 0 0-3.138 1.762c-.55.408-1.083.903-1.679 1.56-.431.476-.824.987-1.166 1.52a13.604 13.604 0 0 0-.953 1.755 12.177 12.177 0 0 0-.904 2.976c-.075.423-.117.857-.159 1.28l-.006.053c-.047.482-.036.974-.024 1.456l.003.131c.02.852.153 1.73.405 2.673l.116.408.08.256c.194.597.447 1.201.752 1.8a12.337 12.337 0 0 0 1.652 2.473c.67.77 1.408 1.444 2.19 2.002.722.514 1.399.914 2.068 1.224.623.288 1.285.532 2.023.745.628.18 1.31.307 2.147.4.54.06 1.09.06 1.511.051a13.453 13.453 0 0 0 2.844-.37c.861-.205 1.73-.516 2.582-.922.56-.268 1.126-.596 1.782-1.037a11.87 11.87 0 0 0 1.198-.937l.259-.234a13.255 13.255 0 0 0 1.675-1.891c.531-.725.996-1.543 1.384-2.43.25-.576.467-1.211.64-1.89.225-.876.36-1.79.404-2.715.02-.41.013-.834-.02-1.259-.027-.358-.062-.78-.118-1.2-.078-.59-.224-1.16-.357-1.642a12.493 12.493 0 0 0-.956-2.396 12.509 12.509 0 0 0-1.754-2.564 13.188 13.188 0 0 0-2.25-2.017l-.358-.246a13.058 13.058 0 0 0-2.015-1.09 13.072 13.072 0 0 0-2.024-.68 13.725 13.725 0 0 0-1.962-.335l-.3-.028c-.408-.034-.827-.025-1.237-.017l-.152.002a12.07 12.07 0 0 0-1.074.07c-.32.034-.632.092-.98.158-.754.142-1.527.365-2.297.66-.526.204-.996.418-1.436.655-.683.368-1.355.808-1.999 1.307a12.16 12.16 0 0 0-1.757 1.676 12.909 12.909 0 0 0-2.003 3.125c-.23.51-.437 1.053-.633 1.66-.147.45-.264.92-.358 1.434-.121.66-.192 1.345-.215 2.094-.014.425-.002.846.01 1.242.006.178.03.36.053.542.013.094.025.191.035.288l.025.213c.066.498.179.99.326 1.563.239.926.597 1.833 1.096 2.772.327.616.723 1.225 1.175 1.81.446.576.956 1.135 1.517 1.66.455.428.96.829 1.5 1.194a13.23 13.23 0 0 0 2.578 1.366c.91.356 1.874.618 2.866.778.74.12 1.503.17 2.33.156a13.393 13.393 0 0 0 3.32-.482 14.278 14.278 0 0 0 2.267-.826c.513-.24.998-.53 1.449-.809.504-.311 1.018-.689 1.572-1.155a12.993 12.993 0 0 0 1.788-1.853 13.53 13.53 0 0 0 1.202-1.774c.341-.607.64-1.264.914-2.01.17-.464.297-.881.39-1.277.163-.7.265-1.287.32-1.852.056-.58.083-1.064.084-1.521.002-.474-.021-.892-.068-1.28a14.509 14.509 0 0 0-.396-2.08l-.076-.266c-.21-.702-.47-1.38-.77-2.016a13.201 13.201 0 0 0-1.233-2.097 13.55 13.55 0 0 0-2.227-2.41 13.662 13.662 0 0 0-4.391-2.506 14.516 14.516 0 0 0-1.434-.416c-.336-.077-.686-.13-1.027-.182-.104-.016-.208-.031-.311-.048-.507-.08-1.024-.093-1.53-.106h-.062a12.479 12.479 0 0 0-1.764.098 13.958 13.958 0 0 0-3.743.988 12.38 12.38 0 0 0-2.159 1.154c-.45.301-1.03.708-1.551 1.18a14.22 14.22 0 0 0-2.24 2.541 13.684 13.684 0 0 0-1.253 2.27 13.194 13.194 0 0 0-.743 2.254 12.895 12.895 0 0 0-.3 1.719 16.63 16.63 0 0 0-.08 2.038c.025.767.097 1.447.221 2.077a13.83 13.83 0 0 0 1.947 4.867 13.593 13.593 0 0 0 3.494 3.69 14.069 14.069 0 0 0 2.77 1.55c.603.25 1.24.465 1.895.636a12.38 12.38 0 0 0 2.357.396c.412.027.858.04 1.361.039.892-.001 1.838-.112 2.893-.341a13.199 13.199 0 0 0 2.525-.829 14.257 14.257 0 0 0 4.24-2.847 14.565 14.565 0 0 0 1.509-1.745 13.32 13.32 0 0 0 1.518-2.63c.273-.632.492-1.24.667-1.86.19-.673.305-1.339.393-1.904.137-.88.164-1.822.082-2.882a13.691 13.691 0 0 0-.74-3.524 14.047 14.047 0 0 0-1.54-3.119 14.168 14.168 0 0 0-1.251-1.64 14.551 14.551 0 0 0-1.627-1.545 14.218 14.218 0 0 0-2.215-1.469 14.352 14.352 0 0 0-1.808-.824c-.44-.165-.895-.297-1.324-.415-.54-.148-.99-.245-1.42-.305l-.235-.034c-.474-.069-.954-.139-1.433-.11-.13.006-.26 0-.382-.007-.088-.005-.176-.01-.262-.01a15.3 15.3 0 0 0-1.643.104 13.898 13.898 0 0 0-3.202.766c-.645.232-1.312.538-2.042.934-.523.285-1.06.634-1.692 1.099a12.23 12.23 0 0 0-1.32 1.144c-.75.739-1.42 1.563-1.993 2.452-.385.596-.73 1.236-1.051 1.948l-.136.31c-.265.617-.462 1.269-.643 1.887-.18.618-.274 1.26-.35 1.868-.083.666-.115 1.36-.098 2.122.014.635.067 1.273.158 1.898.092.628.243 1.276.46 1.981a14.208 14.208 0 0 0 5.257 7.34c.646.471 1.266.855 1.896 1.173 1.104.557 2.255.97 3.42 1.228.283.063.47.202.568.441v.006l.183.02-.216.107a.115.115 0 0 1-.033.02v.002a.12.12 0 0 1-.056.009l-.288-.03.172-.085a.418.418 0 0 0-.121-.15.646.646 0 0 0-.257-.108 14.81 14.81 0 0 1-3.477-1.248 13.842 13.842 0 0 1-1.928-1.194 14.457 14.457 0 0 1-3.588-3.743 14.7 14.7 0 0 1-1.756-3.718 13.291 13.291 0 0 1-.468-2.017 15.733 15.733 0 0 1-.16-1.928c-.017-.772.015-1.477.1-2.156.076-.611.171-1.27.357-1.905.18-.62.381-1.283.652-1.914.364-.85.758-1.6 1.206-2.294a14.654 14.654 0 0 1 2.026-2.491 12.44 12.44 0 0 1 1.346-1.167 14.84 14.84 0 0 1 3.795-2.066 14.15 14.15 0 0 1 3.255-.779 15.553 15.553 0 0 1 1.67-.105c.093 0 .187.005.275.01Z"/><path stroke="#000" stroke-miterlimit="10" stroke-width=".2" d="M21.846 15.64a5.146 5.146 0 0 1 1.864.33 5.066 5.066 0 0 1 2.55 2.057c.606.94.876 1.986.8 3.106a5.126 5.126 0 0 1-.46 1.784c-.323.713-.799 1.319-1.454 1.85a4.88 4.88 0 0 1-1.564.838 5.135 5.135 0 0 1-2.334.22 4.637 4.637 0 0 1-1.402-.42 4.891 4.891 0 0 1-2.087-1.874 4.821 4.821 0 0 1-.696-2.513 4.679 4.679 0 0 1 .116-1.079l.041-.169a4.712 4.712 0 0 1 1.882-2.717 4.75 4.75 0 0 1 2.625-.876 4.476 4.476 0 0 1 1.993.379c.753.333 1.36.807 1.85 1.449.422.55.71 1.179.858 1.866.123.575.112 1.196-.03 1.896-.094.457-.28.914-.567 1.395a4.42 4.42 0 0 1-1.213 1.299c-.36.261-.734.462-1.114.595a4.71 4.71 0 0 1-1.502.275c-.5.008-.955-.053-1.39-.186a4.273 4.273 0 0 1-2.701-2.448 4.274 4.274 0 0 1-.298-1.155c-.06-.475-.025-.99.101-1.572.084-.386.226-.755.423-1.096a4.246 4.246 0 0 1 1.48-1.532l.155-.09a4.211 4.211 0 0 1 2.526-.514c.788.081 1.48.36 2.056.83.674.548 1.139 1.175 1.389 1.874.25.7.281 1.468.098 2.296-.16.715-.52 1.34-1.099 1.908-.726.714-1.644 1.097-2.726 1.141a3.517 3.517 0 0 1-1.924-.477c-1.233-.71-1.892-1.786-1.954-3.192a3.673 3.673 0 0 1 .41-1.884 3.592 3.592 0 0 1 1.712-1.635c.992-.458 1.964-.489 2.963-.091 1.003.399 1.693 1.142 2.047 2.201.261.781.225 1.584-.104 2.382-.224.541-.575 1-1.044 1.365-.932.724-1.97.942-3.076.645-.906-.244-1.584-.79-2.01-1.619a3.21 3.21 0 0 1-.28-2.192c.116-.54.334-1.002.651-1.374.572-.67 1.292-1.05 2.137-1.127.504-.045.953.01 1.371.172.627.243 1.1.61 1.44 1.123.576.868.696 1.771.35 2.677-.45 1.177-1.382 1.85-2.68 1.94a2.542 2.542 0 0 1-1.617-.452c-1.048-.713-1.462-2.008-1.033-3.22a2.468 2.468 0 0 1 1.264-1.426c.906-.441 1.781-.402 2.589.122.644.418 1.012 1.024 1.092 1.794.063.607-.092 1.159-.47 1.681-.233.324-.595.597-1.009.768l-.18.067c-.51.17-1.037.176-1.481.013-.923-.34-1.449-1.114-1.44-2.116.003-.449.145-.862.42-1.224.499-.66 1.18-.94 2.008-.83.46.06.857.289 1.18.673l.084.11c.404.568.542 1.482.007 2.179-.482.628-1.135.882-1.88.727-.459-.096-.8-.34-1.034-.741-.195-.334-.261-.688-.21-1.105a1.519 1.519 0 0 1 1.276-1.311c.532-.082 1 .093 1.344.504a1.3 1.3 0 0 1 .297 1.056 1.287 1.287 0 0 1-1.442 1.072 1.117 1.117 0 0 1-.7-.365 1.077 1.077 0 0 1-.25-.74 1.03 1.03 0 0 1 .254-.689c.162-.178.395-.293.682-.343a.77.77 0 0 1 .464.088.696.696 0 0 1 .329.322.909.909 0 0 1-.002.643.936.936 0 0 1-.404.506.566.566 0 0 1-.34.06.538.538 0 0 1-.311-.142.597.597 0 0 1-.177-.314.542.542 0 0 1 .058-.347.531.531 0 0 1 .212-.23.562.562 0 0 1 .305-.065c.077-.002.12.066.118.124a.118.118 0 0 1-.124.113.33.33 0 0 0-.182.035.296.296 0 0 0-.117.131.305.305 0 0 0-.036.197c.012.06.046.123.11.188a.305.305 0 0 0 .175.072.331.331 0 0 0 .194-.03.7.7 0 0 0 .293-.377.674.674 0 0 0 .008-.472.464.464 0 0 0-.219-.203.535.535 0 0 0-.313-.064c-.241.041-.423.135-.544.268a.794.794 0 0 0-.195.535.839.839 0 0 0 .194.579.88.88 0 0 0 .552.285 1.05 1.05 0 0 0 1.173-.875 1.065 1.065 0 0 0-.245-.865 1.168 1.168 0 0 0-1.125-.423 1.28 1.28 0 0 0-1.076 1.105c-.045.37.013.672.18.957.2.342.485.546.877.628.333.069.634.049.905-.056.272-.106.519-.298.737-.583.49-.637.326-1.502-.084-1.99-.287-.342-.633-.54-1.03-.592-.743-.098-1.34.149-1.787.738a1.782 1.782 0 0 0-.371 1.083c-.007.902.46 1.587 1.284 1.89.39.144.861.13 1.302-.01.44-.14.841-.404 1.093-.753.344-.477.482-.972.426-1.517l-.016-.13a2.09 2.09 0 0 0-.97-1.49c-.732-.475-1.52-.513-2.354-.107A2.223 2.223 0 0 0 19.642 20l-.041.108c-.394 1.112-.015 2.293.943 2.944.45.306.957.447 1.466.411.615-.043 1.127-.216 1.538-.512.41-.297.724-.722.936-1.276.316-.827.21-1.653-.326-2.46-.31-.469-.743-.806-1.327-1.032a2.752 2.752 0 0 0-1.265-.157c-.78.07-1.444.42-1.976 1.044-.289.339-.492.765-.6 1.27a2.974 2.974 0 0 0 .26 2.033 2.82 2.82 0 0 0 1.704 1.452l.155.046.193.046c.959.203 1.856-.014 2.675-.65.436-.339.763-.765.97-1.267.308-.747.34-1.491.098-2.216-.332-.994-.974-1.684-1.909-2.055-.936-.373-1.842-.345-2.774.086a3.356 3.356 0 0 0-1.601 1.529 3.435 3.435 0 0 0-.383 1.764c.059 1.34.656 2.317 1.835 2.995.56.322 1.163.472 1.795.446 1.04-.042 1.878-.394 2.57-1.073.548-.54.884-1.124 1.032-1.79.174-.787.142-1.51-.091-2.164-.234-.654-.67-1.246-1.314-1.77-.538-.438-1.187-.7-1.93-.777a3.986 3.986 0 0 0-2.533.57 4.005 4.005 0 0 0-1.397 1.447 3.57 3.57 0 0 0-.396 1.029c-.122.56-.153 1.047-.098 1.49.052.413.144.77.281 1.093a4.046 4.046 0 0 0 2.553 2.313 4.474 4.474 0 0 0 2.742-.086l.134-.05c.31-.123.62-.295.919-.513a4.187 4.187 0 0 0 1.15-1.23c.274-.46.45-.892.536-1.319.137-.672.147-1.26.032-1.798a4.406 4.406 0 0 0-.814-1.772 4.396 4.396 0 0 0-1.757-1.376 4.238 4.238 0 0 0-1.889-.358c-.93.035-1.769.315-2.495.832a4.472 4.472 0 0 0-1.83 2.745c-.075.33-.113.674-.11 1.024.007.879.23 1.683.662 2.39a4.656 4.656 0 0 0 1.987 1.785c.418.202.866.336 1.33.399a4.9 4.9 0 0 0 2.228-.212 4.641 4.641 0 0 0 1.488-.795c.628-.51 1.081-1.087 1.387-1.764a4.89 4.89 0 0 0 .439-1.703 4.758 4.758 0 0 0-.76-2.96 4.83 4.83 0 0 0-2.434-1.963 4.9 4.9 0 0 0-1.779-.315 5.064 5.064 0 0 0-1.974.398 5.101 5.101 0 0 0-2.302 1.928 4.84 4.84 0 0 0-.731 1.84 5.01 5.01 0 0 0-.053 1.536c.071.526.188.983.356 1.399a4.89 4.89 0 0 0 1.145 1.71 5.296 5.296 0 0 0 1.923 1.185 5.38 5.38 0 0 0 1.749.291 5.27 5.27 0 0 0 1.765-.296 5.336 5.336 0 0 0 1.521-.816c.461-.353.857-.77 1.174-1.237l.123-.187a5.221 5.221 0 0 0 .809-2.466v-.005a.473.473 0 0 1 .012-.093.184.184 0 0 1 .072-.107c.059-.04.127-.034.188-.015a.12.12 0 0 1 .078.149.118.118 0 0 1-.112.081v.006c-.02.292-.062.58-.13.872l-.076.294a5.556 5.556 0 0 1-.766 1.605 5.581 5.581 0 0 1-1.226 1.292 5.572 5.572 0 0 1-1.59.853 5.511 5.511 0 0 1-2.352.283H21.44a5.36 5.36 0 0 1-1.307-.28 5.53 5.53 0 0 1-2.008-1.237 5.13 5.13 0 0 1-1.201-1.793 5.772 5.772 0 0 1-.341-1.256l-.03-.2a5.244 5.244 0 0 1 .054-1.608 5.08 5.08 0 0 1 .767-1.93 5.337 5.337 0 0 1 4.472-2.434Zm.064 4.904h.002v-.03l-.002.03Zm.002 0h-.002l.002-.03v.03Z"/><path stroke="#000" stroke-miterlimit="10" stroke-width=".2" d="M42.524 4.132A3.359 3.359 0 0 0 39.165.774H4.632a3.359 3.359 0 0 0-3.358 3.358v33.939a3.359 3.359 0 0 0 3.358 3.358h34.533a3.359 3.359 0 0 0 3.359-3.358V4.132Zm.274 33.939a3.632 3.632 0 0 1-3.633 3.632H4.632A3.632 3.632 0 0 1 1 38.07V4.133A3.632 3.632 0 0 1 4.632.5h34.533a3.632 3.632 0 0 1 3.633 3.632v33.939Z"/><path stroke="#000" stroke-miterlimit="10" stroke-width=".2" d="M39.34 4.045a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM39.34 37.965a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.06 0 1.03 1.03 0 0 1 2.06 0ZM5.75 37.965a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM5.75 4.045a.757.757 0 1 0-1.513 0 .757.757 0 0 0 1.513 0Zm.274 0a1.03 1.03 0 1 1-2.061 0 1.03 1.03 0 0 1 2.06 0ZM36.964 21.102c0-8.32-6.745-15.065-15.065-15.065S6.834 12.782 6.834 21.102 13.58 36.166 21.9 36.166s15.065-6.744 15.065-15.064Zm.31 0c0 8.491-6.883 15.375-15.375 15.375-8.491 0-15.375-6.884-15.375-15.375 0-8.492 6.884-15.376 15.375-15.376 8.492 0 15.375 6.885 15.375 15.376Z"/><path stroke="#000" stroke-miterlimit="10" stroke-width=".2" d="M38.452 21.102c0-9.142-7.41-16.554-16.553-16.554-9.142 0-16.553 7.412-16.553 16.554s7.411 16.553 16.553 16.553c9.142 0 16.553-7.411 16.553-16.553Zm.31 0c0 9.313-7.55 16.863-16.863 16.863-9.313 0-16.864-7.55-16.864-16.863 0-9.314 7.55-16.864 16.864-16.864s16.864 7.55 16.864 16.864Z"/></svg>'
        const generalSvg =
          '<svg xmlns="http://www.w3.org/2000/svg" width="41" height="42" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M16.182 12.434a4.876 4.876 0 0 1 9.476 1.625c0 3.25-4.876 4.876-4.876 4.876v2.655m.063 3.852h.021m-4.9 10.194 3.166 4.222c.47.627.706.941.995 1.054.252.098.533.098.786 0 .288-.113.524-.427.995-1.054l3.166-4.222c.636-.848.954-1.272 1.342-1.596a4.338 4.338 0 0 1 1.782-.891c.492-.116 1.022-.116 2.081-.116 3.032 0 4.548 0 5.744-.495a6.506 6.506 0 0 0 3.521-3.522c.495-1.196.495-2.711.495-5.743V10.911c0-3.645 0-5.467-.709-6.858a6.506 6.506 0 0 0-2.843-2.844C35.095.5 33.273.5 29.629.5H11.41c-3.644 0-5.466 0-6.857.71a6.507 6.507 0 0 0-2.844 2.843C1 5.444 1 7.266 1 10.91v12.362c0 3.032 0 4.547.495 5.743a6.506 6.506 0 0 0 3.522 3.522c1.195.495 2.711.495 5.743.495 1.06 0 1.59 0 2.08.116.656.154 1.267.46 1.784.891.387.324.705.748 1.341 1.596Z"/></svg>'
        const shippingSvg =
          '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="37" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M27.16 7.243h5.095c.533 0 .8 0 1.05.06.223.053.435.141.63.261.22.135.409.323.786.7l8.856 8.857c.377.377.566.566.7.785.12.196.208.408.262.63.06.252.06.518.06 1.051v6.185c0 1.016 0 1.524-.166 1.925a2.18 2.18 0 0 1-1.18 1.18c-.4.165-.908.165-1.924.165m-10.9 0h-3.27m0 0V7.68c0-2.442 0-3.663-.475-4.596a4.36 4.36 0 0 0-1.905-1.905c-.933-.475-2.154-.475-4.596-.475H7.976c-2.442 0-3.663 0-4.595.475a4.36 4.36 0 0 0-1.906 1.905C1 4.016 1 5.237 1 7.68v17.003a4.36 4.36 0 0 0 4.36 4.36m21.8 0h-8.72m-13.08 0a6.54 6.54 0 1 0 13.08 0m-13.08 0a6.54 6.54 0 1 1 13.08 0m22.889 1.09a5.45 5.45 0 1 1-10.9 0 5.45 5.45 0 0 1 10.9 0Z"/></svg>'
        const affiliateSvg =
          '<svg xmlns="http://www.w3.org/2000/svg" width="38" height="39" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M28.748 25.575c2.305 1.158 4.282 3.017 5.724 5.34.286.46.429.69.478 1.01.1.647-.342 1.443-.945 1.699-.297.126-.631.126-1.299.126m-7.125-14.99a7.125 7.125 0 0 0 3.959-6.385 7.125 7.125 0 0 0-3.959-6.384m-3.166 6.384a7.125 7.125 0 1 1-14.25 0 7.125 7.125 0 0 1 14.25 0ZM4.3 30.485c2.524-3.79 6.508-6.235 10.99-6.235s8.465 2.446 10.99 6.236c.552.83.829 1.245.797 1.776-.025.413-.296.918-.626 1.168-.423.32-1.006.32-2.172.32H6.3c-1.166 0-1.748 0-2.172-.32-.33-.25-.6-.755-.626-1.168-.031-.53.245-.946.798-1.776Z"/></svg>'
        const icons = [deviceSvg, generalSvg, shippingSvg, affiliateSvg]
        if (stack.length == 0) return icons[id] || ''

        return icons[defaultLinks.findIndex((l) => l.title === stack[0].title)] || ''
      }
      function renderLinks(links, parentTitle) {
        // Show/hide the back button
        const backBtn = document.getElementById('support-back')
        if (stack.length === 0) {
          backBtn.classList.remove('visible')
        } else {
          backBtn.classList.add('visible')
        }
        // Back button click handler
        backBtn.onclick = function () {
          if (stack.length > 0) {
            stack.pop()
            const prev = stack.length === 0 ? linkData : stack[stack.length - 1].links
            renderLinks(prev)
          }
        }
        let html = ''
        // Update the support-header(s) and add a div under each
        const headersElem = document.getElementById('support-headers')
        let headersHtml = ''
        if (stack.length === 0) {
          headersHtml += '<h1 class="support-title-root">What do you need help with?</h1>'
        } else {
          for (let i = 0; i < stack.length - 1; i++) {
            headersHtml += '<h2 class="support-header">' + (stack[i].title || '') + '</h2>'
          }
          headersHtml +=
            '<h1 class="support-header">' + (stack[stack.length - 1].title || 'What do you need help with?') + '</h1>'
        }
        headersElem.innerHTML = headersHtml
        // Update the .support-title div below the headers
        const supportTitleElem = document.querySelector('.support-title')
        let supportTitleText = ''
        if (stack.length === 0) {
          supportTitleText = ''
          supportTitleElem.style.display = 'none'
        } else if (links.some((l) => Array.isArray(l.links) && l.links.length > 0)) {
          supportTitleText = 'Which device?'
          supportTitleElem.style.display = 'block'
        } else {
          supportTitleText = 'What is going on?'
          supportTitleElem.style.display = 'block'
        }
        supportTitleElem.textContent = supportTitleText
        links.forEach((link, idx) => {
          const title = link.title || link.handle || 'Untitled'
          html += `<button class="support-card" data-link-index="${idx}"><h3 class="support-card-title">${addIconToLinks(
            idx
          )} ${title}</h3></button>`
        })
        cardsContainer.innerHTML = html

        // Add event listeners
        Array.from(cardsContainer.querySelectorAll('.support-card')).forEach((btn, i) => {
          btn.onclick = function () {
            const link = links[i]
            if (Array.isArray(link.links) && link.links.length > 0) {
              stack.push(link)
              renderLinks(link.links, link.title)
            } else if (link.url) {
              window.location.href = link.url
            }
          }
        })
      }
      renderLinks(linkData)
    })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v2-confidence"] && !Shopify.designMode) return;
  try {
    
  var confidenceVideos = document.querySelectorAll('.v2-confidence-video video')
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

  function handleReducedMotion(mql) {
    confidenceVideos.forEach(function (video) {
      if (mql.matches) {
        video.removeAttribute('autoplay')
        video.pause()
        video.currentTime = 0
      } else {
        video.play()
      }
    })
  }

  handleReducedMotion(reducedMotion)
  reducedMotion.addEventListener('change', handleReducedMotion)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-compare')) {
    customElements.define(
      'vm-compare',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            const color = e.target.closest('[data-set-color]')
            const buy = e.target.closest('[data-vm-buy-link]')
            if (color) this.pickColor(color.dataset.setColor)
            if (buy && buy.getAttribute('href') === '#vm-buy') {
              const target = document.getElementById('vm-buy')
              if (target) {
                e.preventDefault()
                target.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            }
          })
        }
        pickColor(value) {
          this.dataset.color = value
          this.querySelectorAll('[data-set-color]').forEach((b) => {
            b.setAttribute('aria-pressed', String(b.dataset.setColor === value))
          })
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-confidence"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-confidence')) {
    customElements.define(
      'vm-confidence',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            const link = e.target.closest('[data-vm-buy-link]')
            const target = link && document.getElementById('vm-buy')
            if (!target) return
            e.preventDefault()
            target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          })
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-faq')) {
    customElements.define(
      'vm-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            const btn = e.target.closest('.vm-faq-q')
            if (!btn) return
            const open = btn.getAttribute('aria-expanded') !== 'true'
            this.querySelectorAll('.vm-faq-q').forEach((b) => {
              const isThis = b === btn && open
              b.setAttribute('aria-expanded', String(isThis))
              const panel = document.getElementById(b.getAttribute('aria-controls'))
              if (panel) panel.hidden = !isThis
            })
          })
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-features"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-features')) {
    class VmFeatures extends HTMLElement {
      connectedCallback() {
        this._timers = []
        this._observers = []
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        if (reduced || !('IntersectionObserver' in window)) return

        this.cards = Array.from(this.querySelectorAll('[data-vm-feat-card]'))

        // Pause looping CSS animations off screen.
        const offIO = new IntersectionObserver(
          (es) => es.forEach((en) => en.target.classList.toggle('is-off', !en.isIntersecting)),
          { rootMargin: '150px' }
        )
        this.cards.forEach((c) => offIO.observe(c))
        this._observers.push(offIO)

        this.startTypewriter()
        this.startPresets()
        this.startDayNight()
        this.startHzCount()

        // Cards ease back as they leave the middle of the viewport.
        this._tick = false
        this._onScroll = () => {
          if (this._tick) return
          this._tick = true
          requestAnimationFrame(() => {
            this._tick = false
            this.updateCards()
          })
        }
        window.addEventListener('scroll', this._onScroll, { passive: true })
        window.addEventListener('resize', this._onScroll)
        this.updateCards()
      }

      disconnectedCallback() {
        this._timers.forEach((t) => clearTimeout(t))
        clearTimeout(this._tw)
        clearTimeout(this._pb)
        cancelAnimationFrame(this._hzRaf)
        this._observers.forEach((o) => o.disconnect())
        if (this._onScroll) {
          window.removeEventListener('scroll', this._onScroll)
          window.removeEventListener('resize', this._onScroll)
        }
      }

      updateCards() {
        const vh = window.innerHeight
        this.cards.forEach((c) => {
          const r = c.getBoundingClientRect()
          if (r.bottom < -100 || r.top > vh + 100) return
          const raw = Math.min(1, Math.abs(r.top + r.height / 2 - vh / 2) / (vh * 0.6))
          const t = Math.max(0, (raw - 0.15) / 0.85)
          const ad = t * t * (3 - 2 * t)
          c.style.transform = 'scale(' + (1 - 0.04 * ad).toFixed(4) + ')'
          c.style.opacity = (1 - 0.3 * ad).toFixed(3)
          const media = c.querySelector('[data-vm-feat-media]')
          if (media) media.style.transform = 'scale(' + (1 + 0.06 * ad).toFixed(4) + ')'
        })
      }

      startTypewriter() {
        const el = this.querySelector('[data-vm-tw-word]')
        if (!el) return
        const words = (el.dataset.words || '')
          .split(',')
          .map((w) => w.trim())
          .filter(Boolean)
        if (words.length < 2) return
        let i = 0
        let len = words[0].length
        let del = true
        const tick = () => {
          if (del) {
            len--
            el.textContent = words[i].slice(0, Math.max(0, len))
            if (len <= 0) {
              del = false
              i = (i + 1) % words.length
            }
            this._tw = setTimeout(tick, len <= 0 ? 350 : 55)
          } else {
            len++
            el.textContent = words[i].slice(0, len)
            if (len >= words[i].length) {
              del = true
              this._tw = setTimeout(tick, 2200)
            } else {
              this._tw = setTimeout(tick, 95)
            }
          }
        }
        this._tw = setTimeout(tick, 2200)
      }

      startPresets() {
        const card = this.querySelector('[data-vm-feat-presets]')
        if (!card) return
        const sws = Array.from(card.querySelectorAll('[data-vm-feat-swatch]'))
        if (!sws.length) return
        const clear = () => sws.forEach((el) => el.classList.remove('is-on'))
        const step = (i) => {
          clear()
          sws[i].classList.add('is-on')
          this._pb = setTimeout(() => step((i + 1) % sws.length), 1400)
        }
        const io = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              clearTimeout(this._pb)
              if (en.isIntersecting) this._pb = setTimeout(() => step(0), 200)
              else clear()
            }),
          { threshold: 0.5 }
        )
        io.observe(card)
        this._observers.push(io)
      }

      startDayNight() {
        const card = this.querySelector('[data-vm-feat-daynight]')
        if (!card || !card.querySelector('.vm-feat-night')) return
        const io = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              if (en.isIntersecting) {
                // Restart from "day" every time the card comes into view.
                card.classList.remove('is-night')
                void card.offsetWidth
                card.classList.add('is-night')
              }
            }),
          { threshold: 0.4 }
        )
        io.observe(card)
        this._observers.push(io)
      }

      startHzCount() {
        const el = this.querySelector('[data-vm-hzcount]')
        if (!el) return
        const to = parseFloat((el.dataset.to || '').replace(/,/g, ''))
        if (!isFinite(to)) return
        const decimals = ((el.dataset.to || '').split('.')[1] || '').length
        const fmt = (v) =>
          v.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
        el.textContent = fmt(0)
        const io = new IntersectionObserver(
          (es) =>
            es.forEach((en) => {
              if (!en.isIntersecting) return
              io.disconnect()
              const D = 1100
              const t0 = performance.now()
              const tick = (t) => {
                const p = Math.min(1, (t - t0) / D)
                const k = 1 - Math.pow(1 - p, 3)
                el.textContent = fmt(p >= 1 ? to : to * k)
                if (p < 1) this._hzRaf = requestAnimationFrame(tick)
              }
              this._hzRaf = requestAnimationFrame(tick)
            }),
          { threshold: 0.4 }
        )
        io.observe(el)
        this._observers.push(io)
      }
    }
    customElements.define('vm-features', VmFeatures)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-frequencies"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-freq-tabs')) {
    class VmFreqTabs extends HTMLElement {
      connectedCallback() {
        this.nav = this.querySelector('[data-vm-fq-nav]')
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
        this.prev = this.querySelector('[data-vm-fq-prev]')
        this.next = this.querySelector('[data-vm-fq-next]')
        this.index = Math.max(
          0,
          this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')
        )
        this.ac = new AbortController()
        const opts = { signal: this.ac.signal }
        this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i), opts))
        this.nav.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault()
              this.select(this.index + (e.key === 'ArrowRight' ? 1 : -1), true)
            }
          },
          opts
        )
        this.prev.addEventListener('click', () => this.select(this.index - 1), opts)
        this.next.addEventListener('click', () => this.select(this.index + 1), opts)
        this.syncArrows()
      }

      disconnectedCallback() {
        this.ac.abort()
      }

      select(i, focus) {
        if (i < 0 || i >= this.tabs.length) return
        this.index = i
        this.tabs.forEach((tab, k) => {
          const on = k === i
          tab.setAttribute('aria-selected', on ? 'true' : 'false')
          tab.tabIndex = on ? 0 : -1
          const panel = document.getElementById(tab.getAttribute('aria-controls'))
          if (panel) panel.hidden = !on
          if (on && panel) {
            const cards = panel.querySelector('[data-vm-fq-cards]')
            if (cards) cards.scrollLeft = 0
          }
        })
        const tab = this.tabs[i]
        if (focus) tab.focus()
        const left = this.nav.scrollLeft + tab.getBoundingClientRect().left - this.nav.getBoundingClientRect().left - 20
        this.nav.scrollTo({ left: Math.max(0, left), behavior: 'smooth' })
        this.syncArrows()
      }

      syncArrows() {
        this.prev.disabled = this.index <= 0
        this.next.disabled = this.index >= this.tabs.length - 1
      }
    }
    customElements.define('vm-freq-tabs', VmFreqTabs)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-how-to-use"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-how-to')) {
    class VmHowTo extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
        this.fill = this.querySelector('[data-vm-how-fill]')
        this.steps = Array.from(this.querySelectorAll('[data-vm-how-step]'))
        if (!this.steps.length) return
        this.classList.add('is-live')
        this._tick = false
        this._onScroll = () => {
          if (this._tick) return
          this._tick = true
          requestAnimationFrame(() => {
            this._tick = false
            this.update()
          })
        }
        window.addEventListener('scroll', this._onScroll, { passive: true })
        window.addEventListener('resize', this._onScroll)
        this.update()
      }

      disconnectedCallback() {
        if (!this._onScroll) return
        window.removeEventListener('scroll', this._onScroll)
        window.removeEventListener('resize', this._onScroll)
      }

      update() {
        const r = this.getBoundingClientRect()
        const line = window.innerHeight * 0.55
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return
        if (this.fill) {
          this.fill.style.height = Math.max(0, Math.min(r.height - 40, line - r.top - 20)) + 'px'
        }
        this.steps.forEach((st) => {
          st.classList.toggle('is-on', st.getBoundingClientRect().top < line)
        })
      }
    }
    customElements.define('vm-how-to', VmHowTo)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-modulate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-modulate')) {
    const wavePath = (cycles, m, phase, W, H, N) => {
      const k = Math.tanh(28)
      const amp = H * 0.36
      const mid = H / 2
      let d = ''
      for (let i = 0; i <= N; i++) {
        const t = i / N
        const sn = Math.sin((t * cycles + phase) * Math.PI * 2)
        const v = (1 - m) * sn + m * (Math.tanh(sn * 28) / k)
        d += (i ? 'L' : 'M') + (t * W).toFixed(1) + ' ' + (mid - v * amp).toFixed(1)
      }
      return d
    }
    const fmtHz = (v) => v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    class VmModulate extends HTMLElement {
      connectedCallback() {
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
        this.ac = new AbortController()
        const opts = { signal: this.ac.signal }

        this.readout = this.querySelector('[data-vm-mod-readout]')
        this.hzEl = this.querySelector('[data-vm-mod-hz]')
        this.fillEl = this.querySelector('[data-vm-mod-fill]')
        this.wavesEl = this.querySelector('[data-vm-mod-waves]')
        this.glow = this.querySelector('[data-vm-mod-glow]')
        this.line = this.querySelector('[data-vm-mod-line]')
        this.rings = Array.from(this.querySelectorAll('[data-vm-mod-ring]'))
        this.presets = Array.from(this.querySelectorAll('[data-vm-mod-preset]'))
        this.modes = Array.from(this.querySelectorAll('[data-vm-mod-mode]'))
        this.kinds = Array.from(this.querySelectorAll('[data-vm-mod-kind]'))
        this.simHz = this.querySelector('[data-vm-mod-sim-hz]')
        this.modeLabel = this.querySelector('[data-vm-mod-mode-label]')
        this.labels = [this.dataset.sineLabel || 'Sine wave', this.dataset.squareLabel || 'Square wave']

        this.preset = 0
        this.mode = 'sine'
        this.w = { c: 2, m: 0, ph: 0, rp: 0, lp: 0 }

        this.presets.forEach((btn, i) => btn.addEventListener('click', () => this.setPreset(i), opts))
        this.modes.forEach((btn) => btn.addEventListener('click', () => this.setMode(btn.dataset.vmModMode), opts))

        this.scrollTick = false
        const onScroll = () => {
          if (this.scrollTick) return
          this.scrollTick = true
          requestAnimationFrame(() => {
            this.scrollTick = false
            this.updateReadout()
          })
        }
        window.addEventListener('scroll', onScroll, { passive: true, signal: this.ac.signal })
        window.addEventListener('resize', onScroll, opts)
        this.updateReadout()

        this.drawStatic()
        if (!this.reduced) {
          this.visible = false
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              (es) =>
                es.forEach((en) => {
                  this.visible = en.isIntersecting
                  if (this.visible) this.start()
                }),
              { rootMargin: '100px' }
            )
            this.io.observe(this.querySelector('.vm-mod-sim') || this)
          } else {
            this.visible = true
            this.start()
          }
        }
      }

      disconnectedCallback() {
        this.ac.abort()
        if (this.io) this.io.disconnect()
        cancelAnimationFrame(this.raf)
        this.raf = null
      }

      // Pulse speed: lowest preset 0, highest 1, by position in the list.
      speed(i) {
        const n = this.presets.length
        return n > 1 ? i / (n - 1) : 0
      }

      setPreset(i) {
        this.preset = i
        this.presets.forEach((b, k) => b.setAttribute('aria-pressed', k === i ? 'true' : 'false'))
        const hz = parseFloat(String(this.presets[i].dataset.hz).replace(/,/g, ''))
        if (this.simHz) this.simHz.textContent = isFinite(hz) ? fmtHz(hz) : this.presets[i].dataset.hz
        if (this.reduced) this.drawStatic()
      }

      setMode(mode) {
        this.mode = mode
        this.modes.forEach((b) => b.setAttribute('aria-pressed', b.dataset.vmModMode === mode ? 'true' : 'false'))
        this.kinds.forEach((k) => (k.hidden = k.dataset.vmModKind !== mode))
        if (this.modeLabel) this.modeLabel.textContent = mode === 'square' ? this.labels[1] : this.labels[0]
        if (this.reduced) this.drawStatic()
      }

      drawStatic() {
        if (!this.line) return
        const d = wavePath(1.5 + this.speed(this.preset) * 14, this.mode === 'square' ? 1 : 0, 0, 320, 64, 640)
        this.line.setAttribute('d', d)
        this.glow.setAttribute('d', d)
      }

      start() {
        if (this.raf) return
        let last = performance.now()
        const w = this.w
        const tick = (t) => {
          if (!this.visible || !this.isConnected) {
            this.raf = null
            return
          }
          const dt = Math.min(50, t - last)
          last = t
          const lp = this.speed(this.preset)
          const tm = this.mode === 'square' ? 1 : 0
          w.lp += (lp - w.lp) * 0.035
          w.m += (tm - w.m) * 0.07
          w.c = 1.5 + w.lp * 14
          w.ph -= dt * 0.0008 * w.c * (0.32 + Math.pow(w.lp, 2.2) * 5.3)
          const d = wavePath(w.c, w.m, w.ph, 320, 64, 640)
          this.glow.setAttribute('d', d)
          this.line.setAttribute('d', d)
          const P = 2.2 * Math.pow(0.143, w.lp)
          w.rp = (w.rp + dt / (P * 1000)) % 1
          this.rings.forEach((el, i) => {
            const f = (w.rp + i / 4) % 1
            const oSine = 0.55 * Math.sin(Math.PI * f)
            const oSq = f < 0.06 ? (f / 0.06) * 0.8 : 0.8 * Math.pow(1 - (f - 0.06) / 0.94, 1.6)
            el.style.opacity = ((1 - w.m) * oSine + w.m * oSq).toFixed(3)
            el.style.transform = 'scale(' + (0.6 + f * 1.05).toFixed(3) + ')'
            el.style.borderWidth = 1 + w.m + 'px'
          })
          this.raf = requestAnimationFrame(tick)
        }
        this.raf = requestAnimationFrame(tick)
      }

      // Progress runs from the section top reaching the readout's sticky line
      // to the simulator block arriving just under the pinned readout.
      updateReadout() {
        if (!this.readout || !this.wavesEl) return
        const sr = this.getBoundingClientRect()
        const stick = parseFloat(getComputedStyle(this.readout).top) || 0
        const rh = this.readout.offsetHeight
        const total = this.wavesEl.getBoundingClientRect().top - sr.top - (stick + rh)
        const p = total > 0 ? Math.max(0, Math.min(1, (stick - sr.top) / total)) : 0
        if (p === this.lastP) return
        this.lastP = p
        const text = fmtHz(0.01 + 9999.98 * Math.pow(p, 1.4))
        if (this.hzEl.textContent !== text) this.hzEl.textContent = text
        this.fillEl.style.transform = 'scaleX(' + p.toFixed(4) + ')'
      }
    }
    customElements.define('vm-modulate', VmModulate)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vm-product')) {
    /**
     * <vm-product>: state for the V3 Max buy box.
     * Selected colour + card + qty drive both <add-to-cart>s, the prices, the
     * express links and the sticky bar. Each card carries its variants as JSON
     * (snippets/v3-max-bundle-card.liquid).
     */
    class VmProduct extends HTMLElement {
      connectedCallback() {
        this._ac = new AbortController()
        const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, { signal: this._ac.signal, ...opts })

        this.money = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
        })
        this.moneyRound = new Intl.NumberFormat(this.dataset.locale || undefined, {
          style: 'currency',
          currency: this.dataset.currency || 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })

        this.cards = Array.from(this.querySelectorAll('[data-card]')).map((el) => ({
          el,
          id: el.dataset.card,
          name: el.dataset.name,
          own: el.dataset.own === 'true',
          variants: JSON.parse(el.querySelector('script[type="application/json"]').textContent),
        }))
        const pre = this.cards.find((c) => c.el.getAttribute('aria-checked') === 'true')
        this.card = pre || this.cards[0]
        const colorBtn = this.querySelector('.vm-pdp-color[aria-checked="true"]')
        this.color = colorBtn ? colorBtn.dataset.color : ''
        this.colorName = colorBtn ? colorBtn.dataset.colorName : ''
        this.qty = 1

        this.querySelectorAll('.vm-pdp-color').forEach((btn) =>
          on(btn, 'click', () => this.setColor(btn.dataset.color, btn.dataset.colorName))
        )
        this.cards.forEach((c) => on(c.el, 'click', () => this.setCard(c)))
        on(this.querySelector('[data-qty-minus]'), 'click', () => this.setQty(this.qty - 1))
        on(this.querySelector('[data-qty-plus]'), 'click', () => this.setQty(this.qty + 1))
        on(this.querySelector('[data-reviews-link]'), 'click', (e) => this.goReviews(e))
        // The Liquid count comes from Yotpo's synced metafield, which lags. The
        // reviews section announces the live API total, so both numbers match.
        on(document, 'vm:reviews-total', (e) => this.setReviewsTotal(e.detail.total))
        if (window.__vmReviewsTotal) this.setReviewsTotal(window.__vmReviewsTotal)
        this.querySelectorAll('[data-express]').forEach((a) =>
          on(a, 'click', (e) => {
            if (a.getAttribute('href') === '#') e.preventDefault()
          })
        )

        this.setupGallery(on)
        this.setupExperts(on)
        this.setupSticky()
        this.setupShipping()
        this.render()
      }

      disconnectedCallback() {
        this._ac.abort()
        clearInterval(this._shipTimer)
        if (this._stickyIO) this._stickyIO.disconnect()
      }

      /* Variant for a card under the current colour. */
      variantFor(card) {
        const vs = card.variants
        const match = this.color && vs.find((v) => v.colors.includes(this.color) && v.available)
        const matchAny = this.color && vs.find((v) => v.colors.includes(this.color))
        return match || matchAny || vs.find((v) => v.available) || vs[0]
      }

      setColor(color, name) {
        this.color = color
        this.colorName = name
        this.querySelectorAll('.vm-pdp-color').forEach((b) =>
          b.setAttribute('aria-checked', String(b.dataset.color === color))
        )
        const label = this.querySelector('[data-color-label]')
        if (label) label.textContent = name
        const v = this.variantFor(this.cards.find((c) => c.own) || this.card)
        if (v && this.heroMap) this.showVariantHero(v.id)
        else if (v && v.media) this.goToMedia(v.media)
        this.render()
      }

      setCard(card) {
        this.card = card
        this.render()
      }

      setQty(n) {
        this.qty = Math.max(1, Math.min(9, n))
        this.render()
      }

      render() {
        const fmt = (c) => this.money.format(c / 100)

        this.cards.forEach((c) => {
          const v = this.variantFor(c)
          const sel = c === this.card
          c.el.setAttribute('aria-checked', String(sel))
          c.el.classList.toggle('is-selected', sel)
          c.el.querySelector('[data-card-price]').textContent = fmt(v.price)
          const was = c.el.querySelector('[data-card-was]')
          was.textContent = v.was > v.price ? fmt(v.was) : ''
          was.hidden = !(v.was > v.price)
          const save = c.el.querySelector('[data-card-save]')
          if (save) {
            const s = v.was - v.price
            save.hidden = !(s > 0)
            if (s > 0)
              save.textContent = 'Save ' + this.moneyRound.format(s / 100) + ' · ' + Math.round((s / v.was) * 100) + '%'
          }
          const img = c.el.querySelector('[data-card-img]')
          // Drop the srcset image_tag adds, or the browser keeps drawing from
          // it and ignores the new src.
          if (img && v.image && img.dataset.locked !== 'true' && img.getAttribute('src') !== v.image) {
            img.removeAttribute('srcset')
            img.src = v.image
          }
        })

        const v = this.variantFor(this.card)
        const stepSave = this.querySelector('[data-step-save]')
        if (stepSave) {
          const s = (v.was - v.price) * this.qty
          stepSave.classList.toggle('is-saving', s > 0)
          stepSave.textContent =
            s > 0
              ? 'You save ' +
                this.moneyRound.format(s / 100) +
                ' (' +
                Math.round(((v.was - v.price) / v.was) * 100) +
                '%)'
              : stepSave.dataset.fallback || ''
        }

        const qtyEl = this.querySelector('[data-qty]')
        if (qtyEl) qtyEl.textContent = this.qty

        this.querySelectorAll('add-to-cart').forEach((atc) => {
          atc.setAttribute('variant-id', v.id)
          atc.setAttribute('quantity', this.qty)
          atc.dataset.price = v.price
          if (v.available) atc.removeAttribute('sold-out')
          else atc.setAttribute('sold-out', '')
          const label = atc.querySelector('[data-atc-label]')
          if (label) {
            label.dataset.default = label.dataset.default || label.textContent
            label.textContent = v.available ? label.dataset.default : 'Out of stock'
          }
        })

        const pay4 = this.querySelector('[data-pay4]')
        if (pay4) pay4.textContent = fmt(Math.round((v.price * this.qty) / 4))

        const root = (this.dataset.root || '/').replace(/\/?$/, '/')
        const base = root + 'cart/' + v.id + ':' + this.qty
        this.querySelectorAll('[data-express]').forEach((a) => {
          a.href = a.dataset.express === 'shop_pay' ? base + '?payment=shop_pay' : base
        })

        const sName = this.querySelector('[data-sticky-name]')
        if (sName) {
          sName.textContent = this.card.name
          this.querySelector('[data-sticky-color]').textContent = this.colorName ? '· ' + this.colorName : ''
          this.querySelector('[data-sticky-price]').textContent = fmt(v.price * this.qty)
          const sWas = this.querySelector('[data-sticky-was]')
          sWas.textContent = v.was > v.price ? fmt(v.was * this.qty) : ''
          const sImg = this.querySelector('[data-sticky-img]')
          const cardImg = this.card.el.querySelector('[data-card-img]')
          // src, not currentSrc: currentSrc still holds the old image until the
          // swapped one has loaded.
          const src = (cardImg && cardImg.src) || v.image
          if (src) {
            sImg.src = src
            sImg.alt = this.card.name
            sImg.hidden = false
          }
        }
      }

      /* ---- Gallery ---- */
      setupGallery(on) {
        this.track = this.querySelector('[data-gallery-track]')
        if (!this.track) return
        this.heroSlide = this.track.querySelector('[data-variant-slide]')
        this.heroMap = null
        if (this.heroSlide) {
          this.heroMap = {}
          this.querySelectorAll('template[data-variant-hero]').forEach((t) => {
            this.heroMap[t.dataset.variantHero] = t
          })
          this.heroShown = this.heroSlide.hidden ? '' : this.dataset.variantId || ''
        }
        this.refreshSlides()
        this.galIdx = 0
        let raf = 0
        on(
          this.track,
          'scroll',
          () => {
            cancelAnimationFrame(raf)
            raf = requestAnimationFrame(() => {
              const n = Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth))
              if (n !== this.galIdx) this.setGalIdx(n)
            })
          },
          { passive: true }
        )
        on(this.querySelector('[data-gallery-prev]'), 'click', () => this.goToSlide(this.galIdx - 1))
        on(this.querySelector('[data-gallery-next]'), 'click', () => this.goToSlide(this.galIdx + 1))
      }

      setGalIdx(n) {
        this.galIdx = n
        this.dots.forEach((d, i) => d.classList.toggle('is-active', i === n))
      }

      goToSlide(i) {
        if (!this.slides || !this.slides.length) return
        const n = (i + this.slides.length) % this.slides.length
        this.track.scrollTo({ left: n * this.track.clientWidth, behavior: 'smooth' })
        this.setGalIdx(n)
      }

      /* Visible slides, their aria-labels and one dot per slide. */
      refreshSlides() {
        this.slides = Array.from(this.track.children).filter((s) => !s.hidden)
        const total = this.slides.length
        this.slides.forEach((s, i) => s.setAttribute('aria-label', i + 1 + ' / ' + total))
        const dotWrap = this.querySelector('[data-gallery-dots]')
        if (dotWrap && dotWrap.children.length !== total) {
          dotWrap.innerHTML = '<span class="vm-pdp-dot"></span>'.repeat(total)
        }
        this.dots = dotWrap ? Array.from(dotWrap.children) : []
        const nav = this.querySelector('.vm-pdp-gallery-nav')
        if (nav) nav.hidden = total < 2
      }

      /* Variant hero (custom.variant_gallery_images): swap the first slide to
         the variant's image, or hide it when the variant has none. */
      showVariantHero(variantId) {
        const id = String(variantId)
        const tpl = this.heroMap[id]
        const slide = this.heroSlide
        if (tpl && this.heroShown !== id) {
          slide.replaceChildren(tpl.content.cloneNode(true))
          this.heroShown = id
        }
        const wasHidden = slide.hidden
        slide.hidden = !tpl
        if (wasHidden !== slide.hidden) {
          this.refreshSlides()
          this.track.scrollTo({ left: 0 })
          this.setGalIdx(0)
        }
        if (tpl) this.goToSlide(0)
      }

      goToMedia(mediaId) {
        if (!this.slides) return
        const i = this.slides.findIndex((s) => s.dataset.mediaId === String(mediaId))
        if (i > -1) this.goToSlide(i)
      }

      /* ---- Expert carousel: snap, dots, mouse drag ---- */
      setupExperts(on) {
        const track = this.querySelector('[data-exp-track]')
        if (!track) return
        const dots = Array.from(this.querySelectorAll('[data-exp-dots] > *'))
        const step = () => (track.children[0] ? track.children[0].offsetWidth + 10 : 1)
        const go = (i) => {
          const c = track.children[i]
          if (c)
            track.scrollTo({
              left: c.offsetLeft - track.offsetLeft - (track.clientWidth - c.offsetWidth) / 2,
              behavior: 'smooth',
            })
        }
        dots.forEach((d, i) => on(d, 'click', () => go(i)))
        on(
          track,
          'scroll',
          () => {
            const n = Math.round(track.scrollLeft / step())
            dots.forEach((d, i) => d.classList.toggle('is-active', i === n))
          },
          { passive: true }
        )

        let drag = null
        let moved = false
        on(track, 'pointerdown', (e) => {
          if (e.pointerType !== 'mouse') return
          drag = { x: e.clientX, l: track.scrollLeft }
          moved = false
          track.classList.add('is-dragging')
        })
        on(track, 'pointermove', (e) => {
          if (!drag) return
          const dx = e.clientX - drag.x
          if (Math.abs(dx) > 4) moved = true
          track.scrollLeft = drag.l - dx
        })
        const up = () => {
          if (!drag) return
          drag = null
          track.classList.remove('is-dragging')
          go(Math.max(0, Math.min(track.children.length - 1, Math.round(track.scrollLeft / step()))))
        }
        on(track, 'pointerup', up)
        on(track, 'pointerleave', up)
        on(
          track,
          'click',
          (e) => {
            if (moved) {
              e.preventDefault()
              e.stopPropagation()
              moved = false
            }
          },
          { capture: true }
        )
      }

      setReviewsTotal(total) {
        const link = this.querySelector('[data-reviews-link]')
        const text = link && link.querySelector('[data-reviews-link-text]')
        if (!text || !total || !link.dataset.label.includes('[count]')) return
        text.textContent = link.dataset.label.replace('[count]', total.toLocaleString('en-US'))
      }

      goReviews(e) {
        const target =
          document.getElementById('reviews') ||
          (document.querySelector('[data-sp-reviews]') || {}).closest?.('.shopify-section')
        if (!target) return
        e.preventDefault()
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }

      /* ---- Sticky bar: on once the main Add to Cart has scrolled above the viewport ---- */
      setupSticky() {
        const bar = this.querySelector('[data-sticky]')
        const main = this.querySelector('[data-main-atc]')
        if (!bar || !main || !('IntersectionObserver' in window)) return
        this._stickyIO = new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0
          bar.classList.toggle('is-on', past)
          bar.setAttribute('aria-hidden', String(!past))
          const btn = bar.querySelector('button')
          if (btn) btn.tabIndex = past ? 0 : -1
        })
        this._stickyIO.observe(main)
      }

      /* ---- Ship-by countdown to the daily cutoff (visitor's local time) ---- */
      setupShipping() {
        const box = this.querySelector('[data-ship]')
        if (!box) return
        const cd = box.querySelector('[data-ship-countdown]')
        const arrive = box.querySelector('[data-ship-arrive]')
        const hour = parseInt(this.dataset.cutoffHour, 10) || 14
        const days = parseInt(this.dataset.businessDays, 10) || 2
        const p2 = (n) => String(n).padStart(2, '0')
        const tick = () => {
          const now = new Date()
          const cut = new Date(now)
          cut.setHours(hour, 0, 0, 0)
          if (cut <= now) cut.setDate(cut.getDate() + 1)
          const left = Math.floor((cut - now) / 1000)
          cd.textContent =
            p2(Math.floor(left / 3600)) + 'h ' + p2(Math.floor((left % 3600) / 60)) + 'm ' + p2(left % 60) + 's'
          const arr = new Date(cut)
          let bd = 0
          while (bd < days) {
            arr.setDate(arr.getDate() + 1)
            const wd = arr.getDay()
            if (wd !== 0 && wd !== 6) bd++
          }
          arrive.textContent = arr.toLocaleDateString(this.dataset.locale || undefined, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          })
        }
        tick()
        box.hidden = false
        this._shipTimer = setInterval(tick, 1000)
      }
    }
    customElements.define('vm-product', VmProduct)
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["v3-max-reviews"] && !Shopify.designMode) return;
  try {
    
  /**
   * <vm-ugc-gallery>: the customer photo grid. Each photo opens the native
   * <dialog> (Esc, focus trap and top layer for free) scrolled to that photo.
   * Swiping is the track's own scroll-snap; arrows, arrow keys and the counter
   * drive or follow it. Tapping outside the photo closes.
   */
  if (!customElements.get('vm-ugc-gallery')) {
    customElements.define(
      'vm-ugc-gallery',
      class extends HTMLElement {
        connectedCallback() {
          if (this._ac) return
          this.dialog = this.querySelector('[data-ugc-dialog]')
          this.track = this.querySelector('[data-ugc-track]')
          if (!this.dialog || !this.track) return
          this._ac = new AbortController()
          const opts = { signal: this._ac.signal }
          this.counter = this.querySelector('[data-ugc-count]')
          this.total = this.track.children.length
          this.idx = 0

          this.querySelectorAll('[data-ugc-open]').forEach((btn) =>
            btn.addEventListener('click', () => this.open(Number(btn.dataset.ugcOpen), btn), opts)
          )
          const close = this.querySelector('[data-ugc-close]')
          if (close) close.addEventListener('click', () => this.dialog.close(), opts)
          const prev = this.querySelector('[data-ugc-prev]')
          if (prev) prev.addEventListener('click', () => this.go(this.idx - 1), opts)
          const next = this.querySelector('[data-ugc-next]')
          if (next) next.addEventListener('click', () => this.go(this.idx + 1), opts)

          // A tap on the dark area around the photo (the slide's padding or
          // the dialog itself) closes; a tap on the photo does not.
          this.dialog.addEventListener(
            'click',
            (e) => {
              if (e.target === this.dialog || e.target.classList.contains('vm-rev-lb-slide')) this.dialog.close()
            },
            opts
          )
          this.dialog.addEventListener(
            'keydown',
            (e) => {
              if (e.key === 'ArrowLeft') this.go(this.idx - 1)
              else if (e.key === 'ArrowRight') this.go(this.idx + 1)
            },
            opts
          )
          this.dialog.addEventListener(
            'close',
            () => {
              document.documentElement.style.overflow = ''
              if (this.opener) this.opener.focus({ preventScroll: true })
            },
            opts
          )

          let raf = 0
          this.track.addEventListener(
            'scroll',
            () => {
              cancelAnimationFrame(raf)
              raf = requestAnimationFrame(() =>
                this.setIdx(Math.round(this.track.scrollLeft / Math.max(1, this.track.clientWidth)))
              )
            },
            { ...opts, passive: true }
          )
        }

        disconnectedCallback() {
          if (this._ac) this._ac.abort()
          this._ac = null
          document.documentElement.style.overflow = ''
        }

        open(i, opener) {
          this.opener = opener
          this.dialog.showModal()
          document.documentElement.style.overflow = 'hidden'
          this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'auto' })
          this.setIdx(i)
        }

        go(i) {
          const n = (i + this.total) % this.total
          this.track.scrollTo({ left: n * this.track.clientWidth, behavior: 'smooth' })
          this.setIdx(n)
        }

        setIdx(n) {
          this.idx = Math.max(0, Math.min(this.total - 1, n))
          if (this.counter) this.counter.textContent = this.idx + 1 + ' / ' + this.total
        }
      }
    )
  }

  if (!customElements.get('vm-reviews')) {
    const esc = (s) =>
      String(s == null ? '' : s).replace(
        /[&<>"]/g,
        (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]
      )

    const stars = (rating) => {
      const full = Math.floor(rating || 0)
      const half = (rating || 0) - full >= 0.25
      let out = ''
      for (let i = 1; i <= 5; i++) {
        if (i <= full) out += '<i class="ph-fill ph-star" aria-hidden="true"></i>'
        else if (half && i === full + 1) out += '<i class="ph-fill ph-star-half" aria-hidden="true"></i>'
        else out += '<i class="ph ph-star is-empty" aria-hidden="true"></i>'
      }
      return out
    }

    const fmtDate = (iso) => {
      const d = new Date(iso)
      if (isNaN(d.getTime())) return ''
      const days = Math.floor((Date.now() - d.getTime()) / 86400000)
      if (days < 1) return 'Today'
      if (days < 7) return days === 1 ? '1 day ago' : days + ' days ago'
      if (days < 30) {
        const w = Math.floor(days / 7)
        return w === 1 ? '1 week ago' : w + ' weeks ago'
      }
      if (days < 365) {
        const m = Math.floor(days / 30)
        return m === 1 ? '1 month ago' : m + ' months ago'
      }
      return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    }

    const PAGE = 3

    customElements.define(
      'vm-reviews',
      class extends HTMLElement {
        connectedCallback() {
          if (this._started) return
          this._started = true
          this.state = { star: 0, sort: 'recent', shown: PAGE }
          this.load()
        }

        async fetchPage(page) {
          const url =
            'https://api-cdn.yotpo.com/v3/storefront/store/' +
            encodeURIComponent(this.dataset.yotpoStore) +
            '/product/' +
            encodeURIComponent(this.dataset.yotpoProduct) +
            '/reviews?perPage=100&page=' +
            page
          const res = await fetch(url, { headers: { accept: 'application/json' } })
          if (!res.ok) throw new Error('Yotpo ' + res.status)
          return res.json()
        }

        // Company-wide count and weighted average across every product. Null on
        // failure, so the headline falls back to this product's numbers.
        async fetchCompany() {
          try {
            const res = await fetch(
              'https://api-cdn.yotpo.com/v1/apps/' +
                encodeURIComponent(this.dataset.yotpoStore) +
                '/bottom_lines?count=1000',
              { headers: { accept: 'application/json' } }
            )
            if (!res.ok) return null
            const data = await res.json()
            const lines = (data.response && data.response.bottomlines) || []
            let total = 0
            let sum = 0
            lines.forEach((l) => {
              const n = +l.total_reviews || 0
              total += n
              sum += n * (+l.product_score || 0)
            })
            return total ? { total, avg: sum / total } : null
          } catch (e) {
            return null
          }
        }

        async load() {
          if (!this.dataset.yotpoProduct) return
          const company = this.fetchCompany()
          try {
            const first = await this.fetchPage(1)
            let reviews = first.reviews || []
            if (!reviews.length) return
            const total = (first.pagination && first.pagination.total) || reviews.length
            const pages = Math.min(20, Math.ceil(total / reviews.length))
            if (pages > 1) {
              const rest = await Promise.all(
                Array.from({ length: pages - 1 }, (_, i) => this.fetchPage(i + 2).catch(() => ({ reviews: [] })))
              )
              rest.forEach((d) => (reviews = reviews.concat(d.reviews || [])))
            }
            this.reviews = reviews.map((r, i) => ({ ...r, _i: i }))
            this.renderSummary(first.bottomline || {}, await company)
            this.wire()
            this.renderList()
            this.closest('.vm-rev').hidden = false
          } catch (e) {
            /* keep the section hidden */
          }
        }

        renderSummary(bl, company) {
          // Product numbers: drive the star bars, the filter and the list count.
          const total = bl.totalReview || this.reviews.length
          const avg = bl.averageScore || this.reviews.reduce((s, r) => s + (r.score || 0), 0) / this.reviews.length
          const dist = bl.starDistribution || {}
          this.total = total
          // Headline numbers: company-wide when available.
          const headTotal = company ? company.total : total
          const headAvg = company ? company.avg : avg
          // The buy box's "Read all [count] reviews" link picks this up, so it
          // matches the headline.
          window.__vmReviewsTotal = headTotal
          document.dispatchEvent(new CustomEvent('vm:reviews-total', { detail: { total: headTotal } }))
          this.querySelector('[data-rev-avg]').textContent = (Math.round(headAvg * 10) / 10).toFixed(1)
          this.querySelector('[data-rev-stars]').innerHTML = stars(headAvg)
          this.querySelector('[data-rev-based]').textContent =
            'Based on ' + headTotal.toLocaleString() + (headTotal === 1 ? ' review' : ' reviews')
          // Without company data the label would just repeat the headline.
          this.querySelector('.vm-rev-dist-label').hidden = !company
          let bars = ''
          for (let s = 5; s >= 1; s--) {
            const n = dist[s] || this.reviews.filter((r) => r.score === s).length
            const pct = total ? ((n / total) * 100).toFixed(1) : 0
            bars +=
              '<button type="button" class="vm-rev-bar" data-star="' +
              s +
              '" aria-pressed="false" aria-label="Show ' +
              s +
              '-star reviews"><span>' +
              s +
              '</span><span class="vm-rev-bar-track"><span class="vm-rev-bar-fill" style="width:' +
              pct +
              '%"></span></span><span class="vm-rev-bar-n">' +
              n.toLocaleString() +
              '</span></button>'
          }
          this.querySelector('[data-rev-bars]').innerHTML = bars
        }

        wire() {
          this.querySelector('[data-rev-bars]').addEventListener('click', (e) => {
            const bar = e.target.closest('[data-star]')
            if (!bar) return
            const s = +bar.dataset.star
            this.state.star = this.state.star === s ? 0 : s
            this.state.shown = PAGE
            this.querySelectorAll('[data-star]').forEach((b) =>
              b.setAttribute('aria-pressed', String(+b.dataset.star === this.state.star))
            )
            this.querySelector('[data-rev-bars]').classList.toggle('is-filtered', !!this.state.star)
            this.renderList()
          })
          this.querySelector('[data-rev-sort]').addEventListener('change', (e) => {
            this.state.sort = e.target.value
            this.state.shown = PAGE
            this.renderList()
          })
          this.querySelector('[data-rev-more]').addEventListener('click', () => {
            this.state.shown += PAGE
            this.renderList()
          })
        }

        renderList() {
          const { star, sort, shown } = this.state
          const list = this.reviews.filter((r) => !star || r.score === star)
          list.sort((a, b) => {
            if (sort === 'helpful') return (b.votesUp || 0) - (a.votesUp || 0) || a._i - b._i
            if (sort === 'high') return b.score - a.score || a._i - b._i
            if (sort === 'low') return a.score - b.score || a._i - b._i
            return a._i - b._i
          })
          const count = star ? list.length : this.total
          this.querySelector('[data-rev-count]').textContent =
            count.toLocaleString() + (count === 1 ? ' review' : ' reviews')

          const title = esc(this.dataset.productTitle || '')
          const img = this.dataset.productImage
            ? '<img src="' + esc(this.dataset.productImage) + '" alt="" width="36" height="36" loading="lazy">'
            : ''
          this.querySelector('[data-rev-list]').innerHTML = list
            .slice(0, shown)
            .map((r) => {
              const name = (r.user && r.user.displayName) || 'Customer'
              return (
                '<article class="vm-rev-item"><div class="vm-rev-item-head"><span class="vm-rev-who"><span class="vm-rev-name">' +
                esc(name) +
                '</span>' +
                (r.verifiedBuyer
                  ? '<span class="vm-rev-verified"><i class="ph-fill ph-seal-check" aria-hidden="true"></i>Verified buyer</span>'
                  : '') +
                '</span><span class="vm-rev-date">' +
                esc(fmtDate(r.createdAt)) +
                '</span></div>' +
                (title
                  ? '<div class="vm-rev-product">' + img + '<span><strong>Reviewing</strong>' + title + '</span></div>'
                  : '') +
                '<span class="vm-rev-item-stars" role="img" aria-label="' +
                esc(r.score) +
                ' out of 5 stars">' +
                stars(r.score) +
                '</span>' +
                (r.title ? '<h4 class="vm-rev-item-title">' + esc(r.title) + '</h4>' : '') +
                '<p class="vm-rev-item-body">' +
                esc(r.content) +
                '</p></article>'
              )
            })
            .join('')
          this.querySelector('[data-rev-empty]').hidden = list.length !== 0
          this.querySelector('[data-rev-more]').hidden = list.length <= shown
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
